export default {
  general: {
    searchAll: 'search all',
    pleaseContactUs: 'Please contact us for the additional assistance.',
    editThisAccount: 'Edit This Account',
  },
  btn: {
    reloadNow: 'Reload now',
    addNew: 'ADD NEW',
    Download: 'Download',
    metrics: 'Metrics',
    cancelLastChanges: 'cancel last changes',
    confirmBtn: 'Confirm',
    acceptResults: 'Accept Results',
    verifyAndGenerate: 'Verify and Generate',
    addAssessment: 'Add Assessment',
    enableClaim: 'Enable Claim',
    clearFilter: 'Clear Filter',
    applyChanges: 'Apply Changes',
    login: 'Login',
    proceed: 'Proceed',
    forgotPassword: 'Forgot Password?',
    cancel: 'Cancel',
    remove: 'Remove',
    save: 'Save',
    modifyDemographics: 'Modify Demographics',
    submit: 'Submit',
    send: 'Send',
    sendCode: 'Send Code',
    verify: 'Verify',
    backToSignIn: 'Back to Sign In',
    returnToDashboard: 'Return to Dashboard',
    confirmAndContinue: 'Confirm and Continue',
    create: 'Create',
    patient: 'Patient',
    addPatient: 'Add Patient',
    editPatient: 'Edit Patient',
    addAccount: 'Add Account',
    addOrder: 'Add Order',
    createAccount: 'Create Account',
    generateReport: 'Generate Report',
    createPatient: 'Create Patient',
    createOrder: 'Create Order',
    createProgram: 'Create Program',
    // Client-requested rename (2026-08-12): patient-profile tab label,
    // presented as "Services" alongside the renamed Services page.
    programs: 'Services',
    journeys: 'Programs',
    overview: 'Overview',
    contactSupport: 'Contact Support',
    copyToClipboard: 'Copy This Section',
    createAssessment: 'Create Assessment',
    createResource: 'Add Resource',
    startProgram: 'Start Program',
    select: 'Select',
    readMore: 'Read More',
    back: 'Back',
    selected: 'Selected',
    current: 'Current',
    setPasswordLogIn: 'Set Password',
    updatePassword: 'Update password',
    export: 'Export',
    close: 'Close',
    openAssessmentIntoNewTab: 'Open Assessment In New Browser Tab',
    acceptContinue: 'Accept & Continue',
    ok: 'Ok',
    logOut: 'Log Out',
    stayLoggedIn: 'Stay Logged In',
    resendInvitation: 'Resend Invitation',
    goToListOfPatients: 'Go to list of patients',
    orders: 'Orders',
    assessments: 'Assessments',
    resource: 'Resources',
    billing: 'Billing',
    billingReports: 'Billing Reports',
    claimsReporting: 'Claims',
    claimReport: 'Claim Report',
    reportable: 'Reportable',
    reportables: 'Reportables',
    takeInClinic: 'Take In-Clinic',
    sendAnInvite: 'Send an Invite',
    closeAll: 'Close All',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    exportPdf: 'Export PDF',
    default: 'Default',
    apply: 'Apply',
    next: 'Next',
    verifyEmail: 'Verify Email',
    addToAccount: 'Add to Account',
    applyFilter: 'Apply Filter',
    applySorting: 'Apply Sorting',
    downloadPDF: 'Download Outstanding Claim Report',
    downloadCSV: 'Download CSV',
    downloadZIP: 'Download ZIP',
    download: 'Download',
    refresh: 'Refresh',
    acknowledge: 'Acknowledge',
    noReportsToCompare: 'There are no other reports to compare yet.',
    selectorEndMessage: 'Yay! You have seen it all',
    searchByICDCode: 'Search by ICD code',
    continue: 'Continue',
    selectAllOption: 'Select All Option',
    deleting: 'Deleting...',
    permanentlyDeleteUser: 'Permanently Delete',
    retry: 'Retry',
    openInDrive: 'Open in Drive',
    retryAndClearFilters: 'Retry and clear filters',
    editMultiple: 'Edit multiple',
    cancelBulk: 'Cancel bulk',
    applyToAccounts: 'Apply to {{count}} accounts',
    manageAccess: 'Manage access',
    discard: 'Discard changes',
    keepEditing: 'Keep editing',
    retryFailed: 'Retry failed',
    add: 'Add',
    edit: 'Edit',
    removeAccess: 'Remove access',
    saving: 'Saving',
    applying: 'Applying',
    reload: 'Reload',
    addAccounts: 'Add accounts',
    compareWith: 'Compare with',
    done: 'Done',
  },
  nav: {
    resetPassword: 'Reset Password',
    logOut: 'Log Out',
    build: 'Build',
    env: 'ENV',
    dev: 'DEV',
    testing: 'TESTING',
    qhsLabs: 'QHS Lab',
    privacy: 'Privacy',
    terms: 'Terms',
    hippa_baa: 'HIPPA BAA',
  },
  titles: {
    authorizeAccess: 'Authorize Access',
    deleteUser: 'Remove Account Access',
    deleteUserLoading: 'Loading user information...',
    deleteUserSubtitle: 'User will be permanently removed from this account',
    deleteUserSubtitle2: 'User will be permanently removed from these accounts',
    deleteUserFinalTitle: 'Final Authorization Required',
    resource: 'resource',
    allowedAccounts: 'Allowed Accounts',
    availableAccounts: 'Available Accounts',
    selectedAccounts: 'Selected Accounts',
    selectAccountsInfo:
      'Select accounts to grant access to the new user. You can configure specific roles and permissions in the next step.',
    accountSettingsInfo:
      'Configure role and permissions that will be applied to all selected accounts',
    importFromExisting: 'Import from Existing Account',
    noAccountsSelected: 'No accounts selected',
    unlimitedAccessEnabled: 'Unlimited access is enabled',
    unlimitedAccessDescription:
      'This user has access to all accounts. Select specific accounts from the table to restrict access.',
    selectAccountsFromTable: 'Select accounts from the table on the left',
    removeFromSelection: 'Remove from selection',
    multipleSelection: 'Multiple Selection',
    instantAssessment: 'Instant Assessment',
    acknowledge: 'Acknowledge',
    oneMore: 'Some Action with modal',
    alerts: 'Alerts',
    cpts: 'CPTs',
    aspects: 'Aspects',
    responses: 'Responses',
    cpt: 'CPT',
    noShow: 'No Show',
    reverseNoShow: 'No Show Reversal',
    declined: 'Declined',
    reverseDeclined: 'Declined Reversal',
    accountCptCodes: 'Account CPT Codes',
    preview: 'preview',
    noAccountSelected: 'No account selected',
    displayedColumns: 'Displayed columns',
    assessmentInProgress: 'Assessment In Progress',
    assessmentInProgressMessage:
      "The patient hasn't completed this assessment yet. The report becomes available once they're done.",
    noReportData: 'No report data',
    noReportDataMessage: 'This assessment did not produce any report content.',
    failedToLoadReport: 'Failed to load report',
    failedToLoadReportMessage: 'Please try again, or contact support if the issue persists.',
    someDataNotAvailable: 'Some data may not be available yet',
    claimReports: 'Claim Reports',
    reportables: 'Reportables',
    botActivities: 'Bot Activity',
    reported: 'Reported',
    downloadReport: 'Download Report',
    accepted: 'Accepted',
    items: 'items',
    notFound: 'Not Found',
    dashboard: 'Dashboard',
    populationHealth: 'Population Health',
    assessmentPerformance: 'Assessment Performance',
    claimsManager: 'Claims Manager',
    bhiDashboard: 'BHI Dashboard',
    rootPage: 'Root Page',
    open: 'Open',
    claimsReporting: 'Claims',
    claims: 'claims',
    editClaim: 'Edit Claim',
    upload: 'Upload',
    patientUpload: 'Upload Patients',
    insuranceUpload: 'Upload Insurance',
    providersUpload: 'Upload Providers',
    claimsUpload: 'Upload Claims',
    downloadPracticeOptimizationReport: 'Download Practice Optimization Report',
    practiceOptimizationReport: 'Practice Optimization Report',
    enableClaim: 'Enable Claim for This {{source}}',
    enableClaimSubtitle:
      'A claim will be enable for this {{source}}. To remove the claim (undo this operation), mark the claim as Not Billable from the Claims area.',
    patientUploadForAccount: 'Patient Upload for {{accountName}}',
    insuranceUploadForAccount: 'Insurance Upload for {{accountName}}',
    claimsUploadForAccount: 'Claims Upload for {{accountName}}',
    providersUploadForAccount: 'Providers Upload for {{accountName}}',
    editProfile: 'Edit Profile',
    changePassword: 'Change Password',
    accounts: 'Accounts',
    selectAndUploadFile: 'Select And Upload File',
    itemSuccessfullyImported: '{{item}} successfully imported',
    insurance: 'Insurance',
    providers: 'Providers',
    // Client-requested rename (2026-08-12): the Journey Engine section
    // is presented as "Programs" in the UI (nav item, page header,
    // breadcrumb, document title) — the legacy Programs page became
    // "Services" the same day. Key stays `journeys`; routes, entities
    // and API are still journey-based.
    journeys: 'Programs',
    permissionsTesting: 'Permissions Testing',
    Claims: 'Claims',
    importPatients: 'Import Patients',
    validate: 'Validate',
    account: 'Account',
    createAccount: 'Create Account',
    editAccount: 'Edit Account',
    editAccountDetails: 'Edit account details',
    switchAccount: 'Switch account',
    appearance: 'Appearance',
    language: 'Language',
    light: 'Light',
    dark: 'Dark',
    // The user-facing word for the `auto` theme: follow the OS setting.
    system: 'System',
    notifications: 'Notifications',
    viewAccountDetails: 'View Account Details',
    removeAccount: 'Remove Account',
    readOnlyNoPermissions: 'Read-only: No permissions to edit this account',
    editUsers: 'Edit Users',
    users: 'Users',
    user: 'User',
    testDate: 'Test Date',
    singleView: 'Single',
    compareView: 'Compare',
    compareUnavailable: 'No previous assessment to compare',
    viewBillingReport: 'View Billing Report',
    addNewPatient: 'Add Patient',
    createNewAssessment: 'Create New Assessment',
    createNewResource: 'Create Resource',
    accountUsers: 'Account Users',
    managesUsers: 'Administrator',
    globalUsersManagement: 'Users',
    administerClaims: 'Administer Claims',
    administerClaimReports: 'Administer Claim Reports',
    administerReportable: 'Administer Reportable',
    receiveClaimsEmails: 'Receive Claims Emails',
    receiveSurveysEmails: 'Receive Assessment Statistics Emails',
    managesAlert: 'Manages Alert',
    enablePatientEngagementDeactivation: 'Deactivate Patient Engagement',
    manageChildAccounts: 'Administrator of Child Accounts',
    imminentRiskEmails: 'Receive Imminent Risk Emails',
    enablePrograms: 'Programs',
    managesUsersHint: 'You can modify account settings and users.',
    administerClaimsHint: 'Manage claims, claim reportables, and claim reports.',
    administerClaimReportsHint: 'Access and manage claim reports and reporting functionality.',
    imminentRiskEmailsHint: 'Will receive email notification for imminent risk patients.',
    receiveSurveysEmailsHint: 'Will receive periodic emails with assessment statistics.',
    receiveClaimsEmailsHint: 'Will receive periodic emails with claim statistics.',
    managesAlertHint:
      "Alerts will be considered 'read' if viewed by a user with this option. Can also take action on alerts, such as acknowledging them.",
    enablePatientEngagementDeactivationHint:
      'Allows the user to deactivate patient engagement for this account. Re-enabling requires a separate permission.',
    manageChildAccountsHint: 'Access to edit accounts.',
    enableProgramsHint:
      'Gives the user the Programs pages on this account. Requires the Programs module to be on for the account. Takes effect at the next sign-in.',
    createUser: 'Create User',
    removeUser: 'Remove User',
    editUser: 'Edit User',
    manageUserAccounts: 'User Account Access',
    removeAccess: 'Remove Access',
    removeAccessConfirmation: 'Remove Access Confirmation',
    saveChanges: 'Save Changes',
    addAccountAccess: 'Add Account Access',
    searchAccounts: 'Search accounts...',
    noAccountsFound: 'No accounts found for',
    configureAccessPermissions: 'Configure access permissions and role details',
    areYouSureRemoveAccess: 'Are you sure you want to remove access to',
    warningPermissionsLost:
      'Warning: All permissions and settings for this account will be permanently lost and cannot be recovered.',
    currentAccount: 'Current',
    permissionsCount: 'permissions',
    patients: 'Patients',
    patient: 'Patient',
    editPatient: 'Edit Patient',
    createProgram: 'Create Program',
    selectRangeDate: 'Select Range Date',
    removePatient: 'Remove Patient',
    createPatient: 'Create Patient',
    editOrder: 'Edit Order',
    removeOrder: 'Remove Order',
    reorder: 'Reorder',
    createOrder: 'Create Order',
    createAssessment: 'Create Assessment',
    orders: 'Orders',
    order: 'Order',
    assessmentCreated: 'Assessment created',
    resourceCreated: 'Resource Created',
    verifyInvitationDetails: 'Verify Invitation Details',
    assessments: 'Assessments',
    // Client-requested rename (2026-08-12): the Programs page is
    // presented as "Services" in the UI (nav item, page header,
    // breadcrumb, document title). Key stays `programs` — routes,
    // entities and API are still program-based.
    programs: 'Services',
    reports: 'Reports',
    report: 'Report',
    billing: 'Billing',
    billingReports: 'Billing Reports',
    allergiEndResources: 'AllergiEnd Documents',
    allergiEndResourcesDescription:
      'Browse AllergiEnd educational resources and clinical documents hosted on Google Drive.',
    qhslabDocuments: 'QHSLAB Documents',
    qhslabDocumentsDescription:
      'Browse QHSLAB guides, training materials and program documents hosted on Google Drive.',
    resourceCenter: 'Resource Center',
    resourceCenterDescription:
      'Everything you need to run QHS in your practice — product catalog, training, guides, billing help, updates, and support in one place.',
    resources: 'Resources',
    editAssessment: 'Edit Assessment',
    editBill: 'Edit Bill',
    removeBill: 'Remove Bill',
    patientDashboard: 'Patient Dashboard',
    // Client-requested rename (2026-08-12), pairs with `titles.programs`.
    programDashboard: 'Service Dashboard',
    removeAssessment: 'Remove Assessment',
    assessmentAdded: 'New Assessment Added',
    patientAdded: 'New Patient Added',
    invitationSent: 'Invitation Sent',
    assessmentLinkGenerated: 'Assessment Link Generated',
    assessmentLinkGeneratedSubtitle:
      'Your assessment link has been successfully generated. Share this secure link with your patient to begin their assessment.',
    openAssessment: 'Open Assessment',
    linkCopied: 'Link copied to clipboard!',
    invitationSentAssessment:
      'Your assessment invitation has been successfully sent to the patient. They will receive a message with instructions on how to complete their assessment.',
    invitationSentResource:
      'Your resource invitation has been successfully sent to the patient. They will receive a message with instructions on how to complete their resource.',
    immediateNotification: 'Patient will receive an immediate notification',
    assessmentLinkSecure: 'Assessment link is secure and personalized',
    resourceLinkSecure: 'Resource link is secure and personalized',
    assessmentResultsAuto: 'Results will appear in your dashboard automatically',
    resourceTrackingAuto: 'Access tracking will appear in your dashboard automatically',
    loading: 'Loading...',
    pleaseWait: 'Please wait',
    nothingFound: 'Nothing found matching your request.',
    resendInvitation: 'Resend Invitation',
    generateClaim: 'Generate Claim',
    viewAssessmentLink: 'View Assessment Link',
    generateProgramClaim: 'Generate Program Claim',
    // "E-Visit" is the product term for program reports (renamed from
    // "Download Program" 2026-08-20, per backend/customer); the
    // legacy `downloadProgram` key name stays per CLAUDE.md rule.
    downloadProgram: 'Download E-Visit Report',
    downloadCounselingReport: 'Download Counseling Report',
    // Assessments row-menu Download group: head + short sub-item
    // labels (each pair reads as "Download -> Report" etc.).
    downloadGroup: 'Download',
    downloadItemReport: 'Report',
    downloadItemComparison: 'Comparison Report',
    downloadItemProgram: 'E-Visit',
    downloadItemCounseling: 'Counseling Report',
    downloadImmunotherapyReport: 'Download Immunotherapy Report',
    reportNavigation: 'report navigation',
    reportSections: 'Report sections',
    linkWillBeProvided: 'A link will be provide after the assessment is created.',
    downForMaintenance: 'Down for maintenance.',
    downForMaintenanceSubtitleFirst:
      "We're currently working on some updates to our platform and will be down in the meantime.",
    downForMaintenanceSubtitleSecond: 'Thank you for your patience.',
    openThisPage:
      'Open this page on the appropriate device and allow the patient to complete the assessment. Once completed, you will receive next steps for processing.',
    engagementHistory: 'Status History',
    // Create User wizard
    step: 'Step',
    of: 'of',
    noSelection: 'No accounts selected',
    newBadge: 'NEW',
    errorLoading: 'Could not load user data.',
    selectAccountsForUser: 'Select accounts',
    configureAccess: 'Configure access',
    previousAssessment: 'Previous assessment',
    assessment1: 'Assessment 1',
    assessment2: 'Assessment 2',
    question: 'Question',
    result: 'Result',
    needsAttention: 'Needs attention',
    // Public auth pages (Sign In, Password Reset, Accept Invitation, 404, Maintenance)
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    verifyEmail: 'Verify Your Email',
    setNewPassword: 'Set New Password',
    almostThere: 'Almost there!',
    pageNotFound: 'Page not found',
    pageNotFoundSubtitle:
      'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
    welcomeToQHSLab: 'Welcome to the',
    qhsLabBrand: 'Quality Health System (QHS)',
    newAssessment: 'New Assessment',
    newResource: 'New Resource',
    configureAssessment: 'Configure assessment',
    configureResource: 'Configure resource',
    resourceSent: 'Resource sent',
    linkReady: 'Link ready',
    forPatient: 'For {{name}}',
    forPatientWithDob: 'For {{name}} · DOB {{dob}}',
  },
  catalog: {
    searchAssessments: 'Search assessments\u2026',
    searchResources: 'Search resources\u2026',
    noMatchesFor: 'No matches for "{{query}}"',
    matchesCountFor: '{{count}} matches for "{{query}}"',
    itemsCount: '{{count}} resources',
    sortedAlphabetically: 'Sorted alphabetically',
    bestMatchesFirst: 'Best matches first',
    allChip: 'All',
    autoAdvanceHint: 'Selecting auto-advances to step 2',
    readMore: 'Read more',
    readLess: 'Read less',
  },
  configure: {
    selectedAssessment: 'Selected assessment',
    selectedResource: 'Selected resource',
    change: 'Change',
    contactInformation: 'Contact information',
    whenToSend: 'When to send',
    sendNow: 'Send now',
    sendNowDescAssessment: 'Patient receives the invitation immediately.',
    sendNowDescResource: 'Patient receives the resource immediately.',
    scheduleForLater: 'Schedule for later',
    scheduleForLaterDesc: "Pick a date and time in the patient's timezone.",
    patientTimezone: 'Patient timezone: {{tz}}',
    noUpdateNeeded: 'No update needed \u2014 matches patient record.',
    matchesPatientRecord: 'Matches patient record.',
    phoneNotOnFile: "Phone number isn't on file. Add it below to deliver via SMS.",
    updateRecordEmailTitle: 'Update patient record with this email',
    updateRecordEmailDesc: 'Replaces {{previous}} on the patient profile after sending.',
    updateRecordPhoneTitle: 'Update patient record with this phone',
    updateRecordPhoneDesc: 'Saves {{value}} to the patient profile after sending.',
  },
  delivery: {
    sendInvitation: 'Send invitation',
    takeInClinic: 'Take in-clinic',
    howWillPatientTake: 'How will the patient take it?',
    sendInvitationDesc:
      'Email or text a link; the patient completes it on their own device, now or on a schedule.',
    takeInClinicDesc:
      'Get a link now and hand the patient a device in your office. No invitation is sent.',
    chooseToContinue: 'Choose how the patient will take this assessment to continue.',
    whatHappensNext: 'What happens next',
    assessmentLink: 'Assessment link',
    generateLink: 'Generate link',
    inClinicHeadline: 'A unique link will be generated',
    inClinicLead:
      'The patient will complete this assessment now, on a device in your clinic. ' +
      'No invitation is emailed.',
    inClinicStep1: 'Generate the link with the button below.',
    inClinicStep2: 'Open or copy the link onto your patient-facing device.',
    inClinicStep3:
      'Hand the device to the patient. Results sync to the dashboard automatically on submit.',
    // Resend Invitation panel: the assessment already exists, so the
    // in-clinic option shows its link instead of generating one.
    inClinicExistingLead:
      'This assessment already has a link. Open it on a device in your clinic and hand it ' +
      'to the patient. No new invitation is sent.',
  },
  done: {
    invitationSentTo: 'Invitation sent to {{name}}',
    resourceSentTo: 'Resource sent to {{name}}',
    invitationScheduledTo: 'Invitation scheduled for {{name}}',
    resourceScheduledTo: 'Resource scheduled for {{name}}',
    // The channel is no longer claimed here. It is one row per channel
    // in the list below, built from the contact fields that were
    // actually filled in \u2014 the lead used to name both channels whatever
    // was sent, so an SMS-only invitation read as an email one.
    invitationSentLead:
      'You can close this panel \u2014 results will appear in the patient dashboard ' +
      'once submitted.',
    invitationScheduledLead:
      'You can close this panel \u2014 the invitation goes out at the time you picked, ' +
      'and results will appear in the patient dashboard once submitted.',
    resourceSentLead: "They'll see it on their next dashboard visit too.",
    resourceScheduledLead:
      "The resource goes out at the time you picked. They'll see it on their next " +
      'dashboard visit too.',
    // "Sent", not "delivered": the server queues both sends and never
    // reports back whether either arrived.
    sentNow: 'Sent now',
    sentNowAt: 'at {{time}}',
    scheduledSend: 'Scheduled',
    scheduledFor: "for {{date}} at {{time}}, in the patient's time zone",
    scheduledForDate: "for {{date}}, in the patient's time zone",
    channelEmail: 'By email',
    channelSms: 'By SMS',
    channelTo: 'to {{address}}',
    patientProfileUpdatedEmail: 'Patient profile updated with new email.',
    patientProfileUpdatedPhone: 'Patient profile updated with new phone.',
    linkReadyHeadline: 'Assessment link generated',
    linkReadyLead:
      'Open this link on the device the patient will use, or copy it to send through ' +
      'your own channel.',
    linkReadyTip: "Tip: open the link on the patient's tablet, then hand it over.",
    openAssessment: 'Open assessment',
    copyLink: 'Copy link',
    linkCopied: 'Link copied to clipboard',
  },
  forms: {
    ID: 'ID',
    address: 'Address',
    loading: 'Loading...',
    undo: 'Undo',
    time: 'Time',
    date: 'Date',
    selectAllInfo:
      'Use this button to enable access for all accounts that are currently visible in the list.',
    allAccountsSelected: 'All accounts selected. ',
    selectAll: 'Select all',
    allowedResources: 'Allowed Resources',
    allowedSurveys: 'Allowed Assessments',
    addresses: 'Addresses',
    encounterStatus: 'Encounter Status',
    patientLanguage: 'Patient Language',
    race: 'Race',
    selectRace: 'Select race…',
    selectState: 'Select state…',
    dos: 'Date of Service',
    insurance: 'Insurance',
    cptInfo: 'CPT Info',
    billingStatus: 'Billing Status',
    location: 'Location',
    appointmentProvider: 'Appointment Provider',
    checkDate: 'Check Date',
    paymentDate: 'Payment Date',
    paymentMethod: 'Payment Method',
    prType: 'PR Type',
    claimGeneratedTimestamp: 'Claim Created',
    createdBy: 'Created By',
    lastModifiedTimestamp: 'Modified Date',
    modifiedBy: 'Modified By',
    cptCode: 'CPT Code',
    price: 'Price',
    initialPrice: 'Initial Price',
    // ISP services row validation — every service row needs a code
    // and a price above zero before the form can be saved (empty
    // fields produce an invalid JSON Patch the API rejects).
    priceGreaterThanZero: 'Price must be greater than $0.',
    priceAtMost: 'Price must be at most ${{max}}.',
    accountName: 'Account Name',
    deliverInvitationBy: 'Deliver Invitation By',
    orderType: 'Order Type',
    email: 'Email',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    features: 'Features',
    settings: 'Settings',
    configure: 'Configure',
    configureCount: 'Configure ({{count}})',
    configureAriaLabel: 'Configure {{label}}',
    noItemsSelected: 'No items selected. Click "Configure" to select items.',
    searchItemsPlaceholder: 'Search items...',
    moreCount: '+{{count}} more',
    availableItemsTitle: 'Available Items',
    selectedItemsTitle: 'Selected Items',
    clearAll: 'Clear All',
    noItemsMatchSearch: 'No items match your search',
    noItemsAvailable: 'No items available',
    noItemsSelectedShort: 'No items selected',
    automationNotAvailable: 'Automation is not available for this item',
    customEmailSettings: 'Email & SMS Settings',
    customEmailConfiguration: 'Custom Email & SMS Configuration',
    customEmailDescription:
      'Customize the messages sent to your patients for different communication types. Use the toggle to override default messages with your own content.',
    invitations: 'Invitations',
    reminders: 'Reminders',
    completionNotifications: 'Completion Notifications',
    assessmentCommunications: 'Assessment Communications',
    resourceCommunications: 'Resource Communications',
    custom: 'Custom',
    claimReportType: 'Claim Report Type',
    claimReportWithoutFinancial: 'Without financial information',
    claimReportWithFinancial: 'With financial information',
    checkCptsTableErrors: 'Please check CPTs table. There are some errors.',
    // Create User steps
    step1EmailVerification: 'Step 1: Email Verification',
    checkUserExistsDescription: 'Check if user exists before creating',
    emailAddress: 'Email Address',
    emailPlaceholder: 'user@example.com',
    whyCheckFirst: 'Why check first?',
    checkFirstDescription: 'Prevents duplicate users and ensures data integrity in your system',
    step2UserDetails: 'Step 2: User Details',
    enterUserInformation: "Enter the user's personal information",
    // Create User step labels
    stepCheckEmail: 'Check Email',
    stepUserDetails: 'User Details',
    stepSelectAccounts: 'Select Accounts',
    stepAccountSettings: 'Account Settings',
    // Allowed Accounts section
    accessToAllAccounts: 'Access to all accounts',
    accessToSpecificAccounts: 'Access to {{count}} specific accounts',
    accessToSpecificAccount: 'Access to 1 specific account',
    unlimited: 'Unlimited',
    limited: 'Limited',
    accountSelected: 'Account Selected',
    accountsSelected: 'Accounts Selected',
    modifyAccessHint: 'Click "Modify Access" to view and change selected accounts',
    unlimitedAccessDescription: 'This user will have access to all current and future accounts',
    modifyAccess: 'Modify Access',
    setAccountAccess: 'Set Account Access',
    phone: 'Phone',
    preferredPhone: 'Preferred Phone',
    preferredPhoneDescription:
      'This field displays the primary telephone number as recorded by the patient and cannot be modified through the administrative interface.',
    confirmPassword: 'Confirm Password',
    confirmCode: 'Confirm Code',
    hasEmailSubscription: 'Email Subscription',
    hasEmailSubscriptionDescription:
      'The patient has given written or verbal consent to receive Email messages.',
    smsOptIn: 'SMS Opt-In',
    smsOptInDescription:
      'This patient has given written or verbal consent to receiving SMS messages.',
    bhiStatus: 'BHI Status',
    bhiStatusDescription:
      'Indicates whether the patient is enrolled in Behavioral Health Integration (BHI).',
    bhiStatusHint: 'This value is managed by the system and cannot be changed manually.',
    // Customer-mandated wording (daily call 2026-08-05): the word
    // "engagement" is reserved for future CPT/billing interaction
    // metrics — this feature speaks of the patient STATUS
    // (Active / Inactive, Deactivate / Reactivate). Keys keep the
    // legacy patientEngagement* names; only the copy changed.
    patientEngagement: 'Status',
    patientEngagementReason: 'Reason',
    patientEngagementReasonHint:
      'A reason (3-500 characters) is required when changing patient status.',
    patientEngagementEnabledShort: 'Active',
    patientEngagementDisabledShort: 'Inactive',
    patientEngagementHistoryActivated: 'Activated',
    patientEngagementHistoryDeactivated: 'Deactivated',
    patientEngagementChangedBy: 'Status changed by',
    patientEngagementViewHistory: 'View history',
    patientEngagementPauseTitle: 'Deactivate {{name}}?',
    patientEngagementResumeTitle: 'Reactivate {{name}}?',
    patientEngagementPauseWarning:
      'While inactive, this patient receives no assessment invitations, SMS, or emails, and no new BHI programs are created.',
    patientEngagementResumeInfo:
      'The patient will resume receiving assessment invitations, SMS, and emails.',
    patientEngagementPauseConfirm: 'Deactivate patient',
    patientEngagementResumeConfirm: 'Reactivate patient',
    patientEngagementResumeShort: 'Reactivate',
    patientEngagementSaveFirstHint: 'Save or discard your changes first',
    patientEngagementActive: 'Active',
    patientEngagementPausedBadge: 'Patient inactive',
    patientEngagementPausedBy: 'Deactivated by {{name}}',
    patientEngagementChange: 'Change',
    relativeToday: 'Today',
    relativeYesterday: 'Yesterday',
    relativeDaysAgo: '{{count}} days ago',
    distributionSponsor: 'Distribution Sponsor',
    updatePatientRecord: 'Update patient record',
    updatePatientRecordEmail: 'Update patient record with this email',
    updatePatientRecordPhone: 'Update patient record with this phone',
    businessName: 'Business Name',
    tradeName: 'Trade Name',
    sameAsBusinessName: 'Same as Business Name',
    fax: 'Fax',
    contactName: 'Contact Name',
    headProviderName: 'Head Provider Name',
    customId: 'Custom ID',
    name: 'Name',
    link: 'Link',
    streetAddress: 'Street Address',
    suite: 'Suite',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    basicInfo: 'Basic info',
    organizationAddress: 'Organization Address',
    overrideDefaultMessage: 'Override Default Message',
    useDefaultMessage: 'Use Default Message',
    survey: 'Assessment',
    resource: 'Resource',
    english: 'English',
    spanish: 'Spanish',
    invitationEmail: 'Invitation Email',
    invitationSMS: 'Invitation SMS',
    reminderEmail: 'Reminder Email',
    reminderSMS: 'Reminder SMS',
    completionEmail: 'Completion Email',
    completionSMS: 'Completion SMS',
    editAccountScreen: 'Edit Account screen',
    scheduledActivities: 'Scheduled Activities',
    ianaTimeZone: 'Time Zone',
    scheduleDeliverTime: 'Scheduled Delivery Time',
    scheduledDate: 'Scheduled Delivery Date',
    scheduleDeliverDate: 'Scheduled Delivery Date',
    scheduleDeliverData: 'When do you want to sent it?',
    shippingAddress: 'Shipping Address',
    accountType: 'Account Type',
    useSameAddress: 'Use the same as organization address',
    enableOrders: 'Orders',
    enableAllergiEndResources: 'AllergiEnd Documents',
    enableAssessments: 'Assessments',
    enableInstantAssessment: 'Instant Assessment',
    enableResources: 'Resources',
    enableClaimsManagement: 'Claims Management',
    enableImmunotherapyReport: 'Immunotherapy Report',
    enableIntellyChart: 'Preventive Health Counseling',
    disableOrdersAutomations: 'Orders Automations',
    otherAddresses: 'Other Addresses',
    addAddress: 'Add Address',
    manageCpts: 'Manage CPT codes',
    removeAddress: 'Remove Address',
    userDetails: 'User Details',
    userRoleDetails: 'User Role Details',
    accountAccess: 'Account Access',
    selectAllFilteredItems: 'Select All {{filtered}}Items',
    unselectAllFilteredItems: 'Unselect All {{filtered}}Items',
    accountAccessNumber: 'Number of account{{end}} with access granted: {{number}}',
    accountAccessTotalNumber: 'Total number of selected account{{end}}: {{number}}',
    cptsTotalNumber: 'CPT Codes: {{number}}',
    selectAllAccounts: 'Select all accounts',
    modifyAccountAccessList: 'Modify Child Account Access List',
    title: 'Title',
    npiNumber: 'NPI Number',
    provider: 'Provider',
    assistant: 'Assistant',
    role: 'Role',
    mrnNumber: 'MRN #',
    bussinessName: 'Account Name',
    dateOfBirth: 'Date of Birth',
    scheduleDate: 'Schedule Date',
    gender: 'Gender',
    genderAtBirth: 'Gender at Birth',
    allergies: 'Allergies',
    drugAllergies: 'Drug Allergies',
    noDrugAllergies: 'No Drug Allergies',
    drugList: 'Drug List',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    servesDate: 'Serves Date',
    patientName: 'Patient Name',
    assistantType: 'Assistant Type',
    datePaid: 'Date Paid',
    ctpNumber: 'CPT Code',
    allowed: 'Allowed',
    notAllowed: 'Not Allowed',
    all: 'All',
    notes: 'Notes',
    paid: 'Paid',
    pr: 'PR',
    female: 'Female',
    male: 'Male',
    comments: 'Comments',
    slit: 'Slit',
    scit: 'Scit',
    ctpInfo: 'CTP Info',
    orderCategory: 'Order Category',
    sendNow: 'Send Now',
    scheduleForLater: 'Schedule for Later',
    allergens: 'Allergens',
    patient: 'Patient',
    maintenance: 'Maintenance',
    lowDose: 'Low Dose',
    quantity: 'Quantity',
    invitationWillBeSent:
      'Invitation will be sent to the patient’s contact information provided above.',
    invitationWillBeResent: 'Another invitation will be sent to the email/phone specified above',
    sentOn: 'Sent',
    viewAssessmentLinkDescription:
      'Share this link with the patient, or open it to preview their experience.',
    viewAssessmentLinkHint: 'Anyone with this link can open the assessment.',
    invitationWillBeSentSubtitle: 'An invitation will be sent to the email/phone specified above',
    acceptInvitation: "Your QHS account is almost ready, you'll just need to configure a password.",
    resetPasswordStep1:
      "Enter the email address you use to log in. We'll send you a confirmation code to verify your identity.",
    resetPasswordStep2:
      'You should receive an email from us within a few moments with a confirmation code. Enter that code below to continue',
    resetPasswordStep3: 'Thanks {{name}}! The code was confirmed. Now set your new password below',
    // Public auth pages — concise subtitles for the v3 redesign.
    signInSubtitle: 'Access your dashboard',
    brandTagline: 'The intelligent healthcare platform for better patient outcomes.',
    brandAttribution: 'Powered by QHSLab, Inc.',
    secureHipaa: 'Secure HIPAA-compliant access',
    resetEmailSubtitle: 'Enter your email to receive a verification code.',
    verifyCodeSubtitle: 'Enter the confirmation code we sent to your email.',
    setNewPasswordSubtitle: 'Almost there! Create your new password.',
    acceptInvitationSubtitle: 'Set a password to finish setting up your QHS account.',
    notFoundCardSubtitle: 'It may have been removed, renamed, or is temporarily unavailable.',
    checkingBackAutomatically: 'Checking back automatically',
    appointmentTimestamp: 'Appointment Date',
    selectAppointmentProvider: 'Select Appointment Provider',
    selectInsuranceProvider: 'Select Insurance Provider',
    appointmentDate: 'Appointment Date',
    documentDate: 'Document Date',
    patientSeen: 'Patient Seen',
    documentUploaded: 'Document Uploaded',
    modifier: 'Modifier',
    icd: 'ICD',
    id: 'ID',
    DOS: 'Date of Service (DOS)',
    check: 'Check#',
    claimStatus: 'Claim Status',
    cptStatus: 'CPT Status',
    adjustmentCode: 'Adjustment Code',
    adjustmentCodePlaceholder: 'e.g. CO-45',
    adjustmentCodeHint: 'Optional — free text, up to 50 characters.',
    appointmentTime: 'Appointment Time',
    providerInformationRequired: 'Provider Information Required',
    providerTitleLabel: 'Provider Title',
    providerTitlePlaceholder: 'Select a title',
    providerTitleOther: 'Other',
    providerTitleOtherPlaceholder: 'e.g. NP-C',
    npiNumberPlaceholder: '10-digit NPI number',
    customIdHeader: 'Custom ID',
    accountAlreadyExists: 'Account already exists for this user',
    addToSelection: 'Add to selection',
    allowedAssessments: 'Allowed Assessments',
    allowedAssessmentsSubtitle: 'Select which assessments are available for this account',
    searchAssessmentsPlaceholder: 'Search assessments...',
    selectAllowedAssessments: 'Select Allowed Assessments',
    allowedResourcesLabel: 'Allowed Resources',
    allowedResourcesSubtitle: 'Select which resources are available for this account',
    searchResourcesPlaceholder: 'Search resources...',
    selectAllowedResources: 'Select Allowed Resources',
    loadingCptCodes: 'Loading CPT codes...',
    noCptConfigured: 'No CPT services configured. Click "Add CPT Service" to get started.',
    selectCptCode: 'Select CPT code...',
    addInitialPrice: 'Add Initial Price',
    enterEnglishMessage: 'Enter English message...',
    enterSpanishMessage: 'Enter Spanish message...',
    preview: 'Preview',
    personalInformation: 'Personal Information',
    demographicsMedicalInfo: 'Demographics & Medical Information',
    languagePreferenceRace: 'Language Preference & Race',
    addressInformation: 'Address Information',
    communicationPreferences: 'Communication Preferences',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    createNewPassword: 'Create New Password',
    createNewPasswordDescription: 'Make sure your new password is strong and unique',
    securityInfoTitle: 'Important Security Information:',
    securityUseChars: 'Use at least 8 characters',
    securityUpperLower: 'Include uppercase and lowercase letters',
    securityNumbers: 'Add numbers and special characters',
    securityNoPersonal: "Don't use personal information",
    securityNoReuse: "Don't reuse previous passwords",
    passwordStrengthTitle: 'Password Strength Recommendation:',
    passwordMissing: 'Your password is missing:',
    passwordContinueHint:
      'You can continue with this password, but we recommend strengthening it for better security.',
    strengthAtLeast8: 'At least 8 characters',
    strengthLowercase: 'Lowercase letters',
    strengthUppercase: 'Uppercase letters',
    strengthNumbers: 'Numbers',
    strengthSpecialChars: 'Special characters',
    orderDetails: 'Order Details',
    providerInformation: 'Provider Information',
    treatmentDetails: 'Treatment Details',
    treatmentType: 'Treatment Type',
    slitLabel: 'SLIT',
    slitDescription: 'Sublingual Immunotherapy',
    scitLabel: 'SCIT',
    scitDescription: 'Subcutaneous Immunotherapy',
    additionalClinicalInformation: 'Additional Clinical Information',
    additionalInformation: 'Additional Information',
    patientInformation: 'Patient Information',
    deliveryInformation: 'Delivery Information',
    expectedDeliveryDate: 'Expected Delivery Date',
    expectedDeliveryDateHint: "Set in the account's time zone, not your computer's.",
    contactInformation: 'Contact Information',
    userInformation: 'User Information:',
    currentAccount: 'Current Account:',
    unknownAccount: 'Unknown Account',
    criticalAction: 'Critical Action:',
    criticalActionWarningDS:
      ' User will be permanently removed from all accounts and lose all access.',
    criticalActionWarning:
      ' User will be permanently removed from this account and lose all access.',
    irreversibleAction: 'Irreversible Action:',
    deleteUserConfirmDS: 'will be permanently removed from',
    deleteUserConfirmDSEnd: 'and will no longer appear in any user lists.',
    deleteUserConfirm:
      'will be permanently removed from this account and will no longer appear in the user list.',
    deleteUserTypeInstruction: 'To proceed, type',
    deleteUserTypeInstructionEnd: 'in the field below to confirm authorization.',
    typeDeleteToConfirm: 'Type "delete" to confirm',
    pleaseTypeDeleteExactly: 'Please type delete exactly',
    userDeletedSuccess: 'has been successfully deleted from all accounts.',
    moreAccounts: 'more',
    // Create User wizard
    optional: 'optional',
    providerTitle: 'Provider title',
    providerNPINumber: 'Provider NPI number',
    // Both fields are mandatory for the provider role — the backend
    // rejects a provider without them.
    providerNpiExactDigits: 'NPI number must be exactly 10 digits.',
    requiresPermission: 'Requires "{{name}}"',
    programsPermissionAppliesWhereOn: 'Applies only to accounts with the Programs module on.',
    providerDescription: 'Clinical role with access to patient records.',
    assistantDescription: 'Operational role without clinical access.',
    importFromAccount: 'Import from existing',
    importFromAccountPlaceholder: 'Import role and permissions from an existing account…',
  },
  tables: {
    program: 'Program',
    // Label for the backend's `__unknown__` lookup sentinel (rows with
    // no value, e.g. claim lines without a payer) in dropdown filters.
    unknownValue: 'Unknown',
    desc: 'DESC',
    asc: 'ASC',
    sortedBy: 'Sorted by: ',
    filteredBy: 'Filtered by: ',
    noFilters: 'None',
    activeFilters: 'Active filters',
    noActiveFilters: 'No filters applied',
    removeFilter: 'Remove filter',
    recentFilters: 'Recent',
    sortTableBy: 'Sort table by:',
    sort: 'Sort',
    programName: 'Program Name',
    alertTags: 'Alert Tags',
    criticalCategory: 'Critical Category',
    alertName: 'Alert Name',
    acknowledged: 'Acknowledged',
    pendingAcknowledgment: 'Pending Acknowledgment',
    critical: 'Critical',
    description: 'Description',
    dateTriggered: 'Date Triggered',
    nonCritical: 'Non Critical',
    'monitor&support': 'Monitor & Support',
    name: 'Name',
    providerAssignment: 'Provider Assignment',
    uploadFailureReason: 'Failure Reason',
    documentUploadTimestamp: 'Activity Date',
    documentType: 'Document Type',
    documentTypeAssessment: 'Assessment',
    // The document the old grid showed under three "E-Visit" columns.
    // The API calls the row `programReport` because it is built from the
    // survey's ProgramDoc* fields, but what it is to a biller is the
    // E-Visit — the name the column carried before the grid went
    // per-document. Enum value unchanged; this is the display name.
    documentTypeProgramReport: 'E-Visit',
    documentTypeCounselingReport: 'Counseling Report',
    documentStatus: 'Upload Status',
    botIntegration: 'Bot',
    uploadTimestamp: 'Upload Date',
    failureReason: 'Failure Reason',
    botUploadStatus: 'Bot Upload Status',
    eVisitFailureReason: 'E-Visit Failure Reason',
    eVisitUploadStatus: 'E-Visit Upload Status',
    eVisitUploadTimestamp: 'E-Visit Upload Timestamp',
    hasClaim: 'Has Claim',
    hasProgram: 'Has Program',
    hasIntellyChart: 'Has Preventive Health Counseling',
    instant: 'Instant',
    price: 'Price',
    remove: 'Remove',
    surveyTags: 'Assessment Tags',
    entityNameAlert: 'Alert source',
    entityType: 'Entity Source',
    TotalCount: 'Total Count',
    viewedBy: 'Viewed By',
    acknowledgeStatus: 'Acknowledge Status',
    acknowledgedBy: 'Acknowledged By',
    alertType: 'Alert Type',
    crisisTriggered: 'Triggered',
    crisisTriggeredYes: 'Yes',
    crisisTriggeredNo: 'No',
    viewedTimestamp: 'Viewed Date',
    acknowledgedTimestamp: 'Acknowledged Date',
    createdTimestamp: 'Created',
    preFilter: 'Pre-Filter',
    preFilterHint:
      'Select “All” to see all options for this column. To pre-filter based on other column filters you’ve configured, choose “Pre-Filter”.',
    selectedOptions: 'Selected Options:',
    availableOptions: 'Available Options',
    filterMode: 'Filter mode',
    includeGroup: 'Include',
    excludeGroup: 'Exclude',
    // Reads on the filter button as "not Automated". Without it an
    // exclusion would show as its own opposite.
    excludePrefix: 'not',
    howFilteringWorks: 'How this filter combines',
    filterRuleExplainer:
      'Included values are matched first, then excluded ones are removed from that set. With nothing included, an exclusion means everything except those values. Rows with no value at all are kept.',
    conflictEmpty: 'is in both lists, so the two rules cancel out and the table will be empty.',
    conflictPartial: 'is in both lists and will be left out; the other included values still show.',
    allOptions: 'All Options',
    uncheckAllOptions: 'Uncheck all options',
    noAvailableOptions: 'No Available Options.',
    noSelectedOptions: 'No Selected Options.',
    addSomeTextToSearch: 'Start typing the name in the search to see the options.',
    cptCount: 'CPT Count',
    cptPaid: 'Paid CPTs Count',
    NotBillable: 'Not Billable',
    TotalBilledAmount: 'Total Billed Amount',
    TotalPaidAmount: 'Total Paid Amount',
    TotalPRAmount: 'Total PR Amount',
    TotalDeniedAmount: 'Total Denied Amount',
    AccountsCount: 'Accounts Count',
    TotalOutstandingAmount: 'Total Outstanding Amount',
    TotalPartiallyPaidAmount: 'Total Partially Paid Amount',
    TotalNotBillableAmount: 'Total Not Billable Amount',
    TotalNotBilledAmount: 'Total Not Billed Amount',
    assessmentResource: 'Assessment/Resource',
    entityName: 'Assessment/Resource',
    entityCompletedTimestamp: 'Completed Date',
    customId: 'Custom ID',
    accountCustomIdentifier: 'Custom ID',
    claimReportGeneratedTimestamp: 'Claim Report Generated Date',
    reportableGeneratedTimestamp: 'Reportable Generated Date',
    totalAmount: 'Total Amount',
    totalCount: 'Total Count',
    uniqueAccounts: 'Unique Accounts',
    totalPaidAmount: 'Total Reported Amount',
    totalUnpaidAmount: 'Total Reportable Amount',
    ViewedCount: 'Viewed Count',
    NotViewedCount: 'Not Viewed Count',
    PatientsCount: 'Patients Count',
    EngagedCount: 'Resources Engaged Count',
    EngageRate: 'Resources Engage Rate',
    totalCPTs: 'Total CPTs',
    generateClaimReport: 'Generate Claim Report',
    accessGranted: 'Access Granted',
    mrnNumber: 'Patient MRN',
    patientGender: 'Gender',
    female: 'Female',
    male: 'Male',
    patientMrnNumber: 'Patient MRN',
    createdBy: 'Created By',
    type: 'Type',
    manuallyCreated: 'Manually Created',
    integration: 'Integration',
    automated: 'Automated',
    createdByAthena: 'Athena',
    automation: 'Automation',
    invitedTimestamp: 'Invitation Date',
    appointmentTimestamp: 'Appointment Date',
    engagedTimestamp: 'Engaged Date',
    firstName: 'First Name',
    lastName: 'Last Name',
    address: 'Address',
    more: 'More',
    roles: 'Roles',
    account: 'Account',
    accountBusinessName: 'Account',
    accountName: 'Account Name',
    numberOfClaimCPTLineItems: '# of Claim CPT Line Items',
    assessment: 'Assessment',
    patientName: 'Patient Name',
    patientFirstName: 'Patient First Name',
    patientLastName: 'Patient Last Name',
    orderTimestamp: 'Order Date',
    resource: 'Resource',
    patientDOB: 'Patient DOB',
    patientDateOfBirth: 'Patient DOB',
    orderType: 'Order Type',
    orderFormula: 'Order Formula',
    orderDate: 'Order Date',
    success: 'Success',
    error: 'Error',
    customTags: 'Custom Tags',
    patientCustomTags: 'Patient Custom Tags',
    accountCustomTags: 'Account Custom Tags',
    helpRequested: 'Help Requested',
    reviewed: 'Reviewed',
    claimGeneratedTimestamp: 'Claim Generated Date',
    entityOrderTimestamp: 'Order Date',
    cptCode: 'CPT Code',
    allowed: 'Allowed',
    pr: 'PR',
    modifier: 'Modifier',
    icd: 'ICD',
    dos: 'DOS',
    prType: 'PR Type',
    cptStatus: 'CPT Status',
    reportStatus: 'Report Status',
    expectedDeliveryDate: 'Expected Delivery Date',
    status: 'Status',
    encounterStatus: 'Encounter Status',
    paymentDate: 'Payment Date',
    lastModifiedTimestamp: 'Modified Date',
    modifiedBy: 'Modified By',
    billingStatus: 'Billing Status',
    claimStatus: 'Claim Status',
    appointmentDate: 'Appointment Date',
    claimReportStatus: 'Claim Report Status',
    filter: 'filter',
    placeholder: 'placeholder',
    date: 'Date',
    all: 'All',
    pending: 'Pending',
    reportable: 'Reportable',
    icdIssue: 'ICD Issue',
    insuranceIssue: 'Insurance Issue',
    appointmentCancelled: 'Appt. Cancelled',
    appointmentTypeIssue: 'Appt. Type Issue',
    hold: 'Hold',
    readyToBill: 'Ready for Billing',
    reported: 'Reported',
    onHold: 'On Hold',
    processing: 'Processing',
    sending: 'Sending',
    delayed: 'Delayed',
    shipped: 'Shipped',
    putOnHold: 'Put On Hold',
    revertToPending: 'Revert To Pending',
    processManually: 'Process Manually',
    cancel: 'Cancel',
    sendToPharmacy: 'Send To Pharmacy',
    delay: 'Delay',
    ship: 'Ship',
    canceled: 'Canceled',
    compounding: 'Compounding',
    dateOfBirth: 'Date of Birth',
    mmddyyyy: 'MM/DD/YYYY',
    mm: 'MM',
    dd: 'DD',
    yyyy: 'YYYY',
    claimReportHistory: 'Claim Report history',
    reportableHistory: 'Reportable history',
    ordersHistory: 'Orders history',
    claimsHistory: 'Claims history',
    assessmentsHistory: 'Assessments history',
    programsHistory: 'Programs history',
    resourcesHistory: 'Resources history',
    assessmentsAlerts: 'Assessment Alerts',
    healthSeekingBehavior: 'Help Seeking Behavior',
    items: '{{totalCount}} Items',
    searchCustomers: 'Search Customers',
    pendingReview: 'Pending Review',
    partialProcessed: 'Partial Processed',
    eTransfer: 'E-Transfer',
    noShow: 'No Show',
    // Client-requested rename (2026-07-22): the column is still keyed
    // noShowStatus internally; only the user-facing label changed.
    noShowStatus: 'Patient Status',
    declined: 'Declined',
    notUpdated: 'Not Updated',
    none: 'None',
    invited: 'Invited',
    // Backend enum value is `staled` (patient opened the assessment
    // link but hasn't accepted terms) — surfaced as "Opened" per
    // client-facing copy decision, never the raw enum name.
    staled: 'Opened',
    // Assessment `created` status — instant assessments only (created
    // in clinic, patient hasn't started); labeled explicitly so it
    // isn't read as a generic lifecycle step.
    instantCreated: 'Instant Created',
    inProgress: 'In Progress',
    created: 'Created',
    scheduled: 'Scheduled',
    engaged: 'Engaged',
    completed: 'Completed',
    billingHistory: 'Billing history',
    completionRate: 'Completion Rate',
    noShowRate: 'No Show Rate',
    declinedRate: 'Declined Rate',
    noShowAndDeclinedRate: 'No Show + Declined Rate',
    totalAccountsCount: 'Total Accounts Count',
    AverageDaysToPayment: 'Average Days to Payment',
    AverageUnpaidAging: 'Average Unpaid Aging',
    performanceRate: 'Performance Rate',
    assessmentName: 'Assessment name',
    procedureName: 'Procedure Name',
    completedTimestamp: 'Date Completed',
    orderedTimestamp: 'Date Ordered',
    providerFirstName: 'Provider First Name',
    providerLastName: 'Provider Last Name',
    reviewedTimestamp: 'Date Reviewed',
    draft: 'Draft',
    notCreated: 'Not Created',
    billed: 'Billed',
    inProcess: 'In Process',
    paid: 'Paid',
    denied: 'Denied',
    resubmitted: 'Resubmitted',
    notBillable: 'Not Billable',
    isp: 'ISP',
    license: 'License',
    control: 'Control',
    experimental: 'Experimental',
    imminentRisk: 'Imminent Risk',
    helpSeekingBehavior: 'Help Seeking Behavior',
    AllergyTest: 'Allergy Test',
    HomeSleepStudy: 'Home Sleep Study',
    MentalHealth: 'Mental Health',
    PainManagement: 'Pain Management',
    SleepQuality: 'Sleep Quality',
    LifestyleImprovement: 'Lifestyle Improvement',
    MentalHealthHelpRequested: 'Mental Health Help Requested',
    SleepHelpRequested: 'Sleep Help Requested',
    SleepStudyRequested: 'Sleep Study Requested',
    PainManagementHelpRequested: 'Pain Management Help Requested',
    AllergyTestRequested: 'Allergy Test Requested',
    InterestedinImmunotherapy: 'Interested in Immunotherapy',
    LifestyleHelpRequested: 'Lifestyle Help Requested',
    BHIConsent: 'BHI Consent',
    RiskFactorsIdentified: 'Risk Factors Identified',
    QNEGPositive: 'Q-NEG Positive',
    Depressionriskdetected: 'Depression risk detected',
    Anxietyriskdetected: 'Anxiety risk detected',
    PersistentPain: 'Persistent Pain',
    SignificantPhysicalLimitations: 'Significant Physical Limitations',
    ElevatedAllergyScore: 'Elevated Allergy Score',
    HighSleepDisorderRisk: 'High Sleep Disorder Risk',
    SuicideRisk: 'Suicide Risk',
    SuicideorSelfHarmRisk: 'Suicide or Self-Harm Risk',
    Psychologicaldistressnoactivesuicidalideation:
      'Psychological distress, no active suicidal ideation',
    SDoHRisk: 'SDoH Risk',
    PersonalSafetyRisk: 'Personal Safety Risk',
    PreventiveScreeningRequired: 'Preventive Screening Required',
    CheckA1C: 'Check A1C',
    Fallrisk: 'Fall risk',
    ordersOnly: 'Orders Only',
    trial: 'Trial',
    demo: 'Demo',
    other: 'Other',
    active: 'Active',
    inactive: 'Inactive',
    bhiStatus: 'BHI Status',
    Billed: 'Billed',
    NotBilled: 'Not Billed',
    Paid: 'Paid',
    PR: 'PR',
    Denied: 'Denied',
    Outstanding: 'Outstanding',
    PartiallyPaid: 'Partially Paid',
    partiallyPaid: 'Partially Paid',
    multiLineActionMode: 'Multi-line action mode',
    regularMode: 'Regular mode',
    patientResponsibility: 'Patient Responsibility',
    refreshData: 'Refresh Data',
    generateReport: 'Generate Report',
    filterSettings: 'Filter settings',
    showFilters: 'Show filters',
    resetAllFilters: 'Reset all filters',
    unpinAll: 'Unpin all',
    chageStatus: 'Change status all rows of a table',
    miltiAction: 'Actions on all rows of a table',
    miltiActionAllData: 'The status change will be performed on all rows of the table at once.',
    miltiActionFilteredData:
      'The status change will be performed immediately on all table rows corresponding to the specified filters.',
    downloadOrderReports: 'Download Order Reports',
    downloadFileByFilters: 'Download File',
    downloadCSVFile: 'Download CSV File',
    downloadFileFilteredData:
      'The file will be generated from the table data corresponding to the selected filters and visible columns.',
    downloadFileAllData: 'The The file will be generated from all the data in the table.',
    numbersOfRows: 'The number of items.',
    multiLineActions: 'Multi row actions',
    totalNumberOfSelected: 'Total number of selected',
    acknowledgeDescription:
      'The status will be changed for all table values corresponding to the specified filters.',
    changeAcknowledgeStatus: 'Change status to acknowledge for all lines',
    changeStatus: 'Change Status',
    changeDeliveryDate: 'Change Expected Delivery Date',
    deliveryDateActionAllData:
      'The expected delivery date will be changed on all rows of the table at once.',
    deliveryDateActionFilteredData:
      'The expected delivery date will be changed immediately on all table rows corresponding to the specified filters.',
    deliveryDateModePick: 'Pick a date',
    deliveryDateModeReset: 'Reset to default',
    deliveryDateDefaultCalculation: 'Default calculation',
    deliveryDateCanceledHint:
      'Canceled orders cannot take a new expected delivery date. If the table contains any, the whole change is rejected.',
    change: 'Change',
    noRecordsToDisplay: 'No records to display',
    unableToLoadData: 'Unable to load data',
    failedToLoadData: 'Failed to load data',
    unexpectedServerError: 'An unexpected server error occurred',
    patientEngagement: 'Status',
  },
  placeholders: {
    noColumnsSelected: 'No columns selected',
    noItemsFound: 'No {{item}} Found',
    noFilteredItemsFound:
      '{{item}} have not been authorized. \n' +
      'Contact QHSLab at Ph 800-393-8817 to enable {{item}} for this Account.',
    reviseFiltersOrCreateYourFirstItem: 'Revise filters or create your first {{item}}.',
    selectAtLeastOneColumn: 'Select at least one column to display the table.',
    pleaseChangeSearchText: 'Please change the search text',
    noCPTCodes: 'No CPT Codes',
    addCPTCodes: 'Add a CPT code with the {{item}} button below',
  },
  validationErrors: {
    required: 'required field',
    matchPasswords: 'passwords must match',
    invalid: 'invalid {{name}}',
    minError: '{{name}} should be at least {{length}} characters long',
    maxError: '{{name}} should be a maximum of {{length}} characters long',
    lessThan30days: 'The DOS cannot be less than 30 days before the {{date}} (Appointment Date)',
    moreThan30days: 'The DOS cannot be more than 30 days after the {{date}} (Appointment Date)',
    requiredField: '{{fieldName}}  is a required field.',
    CPTCodeRequired: 'CPT Code is a required field.',
    claimSumValueLimits: 'Value should not be less than 0 and greater than $5,000.',
    PRTypeRequired: 'PR Type is a required field if PR > 0.',
    claimStatusMustBeEqual:
      'Claim Status must be equal to Pending if Billing Status is Pending or Hold.',
    dataIsInvalid: 'Data is invalid.',
    newPasswordRequired: 'New password is required',
    confirmPasswordRequired: 'Please confirm your new password',
    passwordsDoNotMatch: 'Passwords do not match',
  },
  errors: {
    loadingError:
      '   Oops, there seems to have been an error loading data. Please check the link or try loading again.',
    doNotHaveAccessToAnyAccounts:
      'You do not have access to any accounts on the QHS dashboard. If you feel this is an error, contact the administrator for your QHS account.',
    unknownError: 'Your request can not be completed due to an unknown error.',
    userNotFound: 'We could not find an account for the email you provided.',
    accountIsDisabled: 'Account is disabled. \nPlease contact support at 1-800-393-8817.',
    credentialsInvalid: 'The email or password you entered was not valid.',
    specifiedCondition: "The specified condition was not met for 'status'.",
    validationError:
      'Some input appears to be invalid. Fix any issues indicated in red, and try again.',
    pleaseEnterDescription:
      'Please enter a description of the issue you are having. Do not remove the content under the line below',
    supportRequest: 'QHS Support Request',
    invalidData: 'Invalid Data',
    noProvidersOnThisAccount:
      'No providers on this account. At least one provider is required to create an order.',
    noLongerValid: 'This invitation is no longer valid.',
    accountOrUser: 'Account or user not found.',
    orderCouldNotFind: 'Could not find the specified account or {{name}}. Refresh and try again.',
    metadataLoadingError: 'Error Loading Data',
    metadataLoadingErrorDescription:
      'Unfortunately, we were unable to load the necessary data for creating an order. Please try refreshing the page.',
    refreshPage: 'Refresh Page',
    orderCantBeRemoved: 'The order cannot be removed, as it no longer has a status of Pending.',
    orderStatusMultiplyValidation: `The status you are trying to change for one or more {{name}}s is not
        allowed. Check the {{name}}s and try again.`,
    orderStatusSingleValidation:
      'The status you selected is not allowed based on the current status of the {{name}}.',
    patientCouldNotFind: 'Could not find the specified account or patient. Refresh and try again.',
    patientCantBeRemoved: 'The patient {{name}} cannot be removed.',
    userCouldNotFind: 'Could not find the specified user. Refresh and try again.',
    userCantBeRemoved: 'The user profile for {{name}} cannot be removed from this account.',
    accountCouldNotFind: 'Could not find the specified account. Refresh and try again.',
    accountCantBeRemoved: 'The account {{name}} cannot be removed.',
    userProfileNotFound: 'A user profile was not found for the email specified.',
    verificationCodeInvalid:
      'The verification code is invalid. Please try again or send a new verification code.',
    tooManyInvitations:
      'Too many invitations were sent too quickly. Wait a few minutes and try again.',
    invitationCannotBeSent:
      'Invite was sent too quickly for this assessment. Try again in a minute or two.',
    invitationMessageWasJustSent:
      'Invitation message was just sent. Please try again in a few moments.',
    invitationsWereNotOriginallySent:
      'Invitations were not originally sent for this survey, so an invitation resend is not allowed.',
    dateRequiredToSend: 'The date is required to send.',
    timeRequiredToSend: 'The time is required to send.',
    somethingWentWrong: 'Something went wrong. Please try again.',
    somethingWentWrongTitle: 'Something went wrong',
    somethingWentWrongMessage: 'Please try again, or contact support if the issue persists.',
    accountAccessCannotBeRemoved: 'Access to account cannot be removed.',
    failedToCreateSurvey: 'Failed to create instant survey.',
    failedToUpdateSurvey: 'Failed to update survey.',
  },
  feedback: {
    triggerTooltip: 'Send feedback',
    dialogTitle: 'Send feedback',
    dialogSubtitle: 'Share an improvement, report an issue, or tell us what is not working.',
    categoryLabel: 'Category',
    categoryImprovement: 'Improvement',
    categoryIssue: 'Issue',
    categoryOther: 'Other',
    messageLabel: 'Message',
    placeholderImprovement: "What's not working smoothly, or could be clearer?",
    placeholderIssue: 'What happened, and what did you expect?',
    placeholderOther: "Tell us what's on your mind.",
    attachmentsLabel: 'Attachments (optional)',
    dropzoneTitle: 'Drag photos or videos here, or click to browse',
    dropzoneHint: 'Up to 5 files, 25 MB each. PNG, JPG, MP4, MOV.',
    removeAttachment: 'Remove',
    sendButton: 'Send feedback',
    sendingButton: 'Sending…',
    fileRejectedMime: '"{{name}}" is not an image or video.',
    fileRejectedSize: '"{{name}}" is larger than 25 MB.',
    fileRejectedCount: 'You can attach at most 5 files.',
    fileRejectedTotalSize: 'Total attachment size cannot exceed 50 MB.',
  },
  notifications: {
    acknowledgeStatusChanged: 'Acknowledge Status changed successfully',
    assessmentAccepted: 'Assessment accepted successfully',
    checkYourForm: 'Some fields contain errors.\n' + 'Please correct it before continuing.',
    autoLogout: 'You have been automatically logged out due to inactivity',
    logout401: 'Your QHSLab session has expired. Log in again to resume.',
    profileUpdated: 'Your profile updated successfully.',
    accountCreated: 'Account "{{name}}" created successfully.',
    accountEdited: 'Account "{{name}}" edited successfully.',
    claimEdited: 'Claim edited successfully.',
    amountCapped: 'Amount cannot exceed ${{max}}. The value was capped.',
    accountRemoved: 'The account {{name}} has been removed.',
    userCreated: 'User "{{name}}" created successfully.',
    userEdited: 'User "{{name}}" edited successfully.',
    userRemoved: 'The user profile for {{name}} has been removed', // from {{accountName}}.',
    patientCreated: 'Patient "{{name}}" created successfully.',
    notPermissionForEditingClaim: 'You do not have permission to edit claim.',
    notPermissionForDownloadingFile: 'You do not have permission to download file.',
    surveyURLCopied: 'Assessment URL has been copied to your clipboard',
    dataCopied: 'Data has been copied to your clipboard',
    dataNotCopied: 'Data has not been copied to your clipboard',
    patientEdited: 'Patient "{{name}}" edited successfully.',
    patientEngagementPaused: 'Patient "{{name}}" has been deactivated.',
    patientEngagementResumed: 'Patient "{{name}}" has been reactivated.',
    claimEnabled: 'The claim has been successfully enabled.',
    patientRemoved: 'The patient "{{name}}" has been removed.',
    dataIsInvalid: 'Data is invalid.',
    pdfSucceededSaved: 'The pdf file downloaded successfully.',
    noShowStatusSucceededChanged: 'The "No Show" status was changed successfully.',
    noShowStatusSucceededReversed: 'The "No Show" status was reversed successfully.',
    declinedStatusSucceededChanged: 'The "Declined" status was changed successfully.',
    declinedStatusSucceededReversed: 'The "Declined" status was reversed successfully.',
    fileSucceededSaved: 'The {{format}} file downloaded successfully.',
    zipSucceededSaved: 'The ZIP file downloaded successfully.',
    orderCreated: 'Order created successfully.',
    orderUpdated: 'Order updated successfully.',
    resourceCreated: 'Resource for "{{name}}" created successfully.',
    orderEdited: 'Order for "{{name}}" edited successfully.',
    accountAccessRemoved: 'Account access removed successfully.',
    accountChangesSaved: 'Account changes saved successfully.',
    accountChangesSavedNextSignIn:
      "Account changes saved. Permission changes take effect at the user's next sign-in.",
    userUpdated: 'User updated successfully.',
    instantSurveyCreated: 'Instant survey created successfully.',
    surveyUpdated: 'Survey updated successfully.',
    orderRemoved: 'The order has been removed.',
    orderStatusChanged: '"{{name}}" status(es) changed successfully.',
    orderDeliveryDateChanged: 'Expected delivery date changed successfully.',
    orderDeliveryDateReset: 'Expected delivery date reset to the default calculation.',
    verifyCodeHasBeenSent: 'Verify code has been sent.',
    passwordHasBeenChanged: 'Password has been changed.',
    addProvider: 'Add at least one provider to the account before creating orders.',
    youHaveBeenSwitched: `You've been automatically switched to account {{name}}`,
    welcomeToQHS: 'Your password has been set. Welcome to QHS!',
    emailInvitation: 'Another email invitation has been sent.',
    assessmentCreated: 'Assessment Created',
    assessmentMustBeCompleted: 'The patient must complete the assessment before viewing the report',
    invitationResent: 'Invitation resent successfully',
    copyToClipboard: 'The text was successfully copied to the clipboard',
    notPermissionForDeletingOrder:
      'Oops! we’re sorry, but your ability to Delete Orders has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    notPermissionForEditingOrder:
      'Oops! we’re sorry, but your ability to Edit Orders has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    notPermissionForStartingProgram:
      'You do not have permission to start programs for this patient.',
    notPermissionForCreatingOrder:
      'Oops! we’re sorry, but your ability to Create Orders has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    notPermissionForCreatingProgram:
      'Oops! we’re sorry, but your ability to Create Program has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    notPermissionForChangeClaimReportStatus:
      'Oops! we’re sorry, but your ability to Change Claim Report Status has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    notPermissionForCreatingAssessment:
      'Oops! we’re sorry, but your ability to Create Assessments has been suspended or not yet enabled in your Account. Please contact customer service at 1-800-393-8817 or email us at services@qhslab.com to request this feature be activated.',
    hasDrugAllergies:
      'This patient’s currently has unknown drug allergies. Update the patient record to create orders.',
    pleaseLogIn: 'Please log in to view the requested resource',
    noPermissions: 'You do not have permission to this resource',
    accessRemoved: 'Access removed.',
    bulkSaveSucceeded: 'Settings applied to {{count}} accounts.',
    bulkSavePartial: 'Applied to {{ok}} of {{total}} accounts. Failed: {{names}}.',
    bulkSaveFailed: 'No accounts were updated. Try again.',
    accountsAdded: '{{count}} account(s) added.',
    accountsAddFailed: 'Failed to add accounts.',
    feedbackSent: 'Thanks! Your feedback has been sent.',
    feedbackFailed: 'Could not send your feedback. Please try again.',
  },
  dialogs: {
    backTo: 'back to {{title}}',
    canUseForSeveralAccounts:
      'This action is available for lines belonging to one account. Please set the appropriate filter.',
    confirmRemove: 'Confirm {{name}} Remove',
    confirmStatusChange: 'Confirm Status Change',
    generateClaimsReport: 'Generate Claims Report',
    additionalOptions: 'Additional Options',
    downloadXlsxFile: 'Download XLSX File (optional)',
    confirmResend: 'Confirm to send anyway',
    confirmResendInvitation: 'Confirm Resend Invitation',
    reportHasBeenGenerated:
      'Report has been generated. You can view/download it from the Claim Reports screen.',
    generateClaimsReportDescription1:
      'A claims report will be generated for the items you selected. Here is a summary of the claim items. To generate the report, verify everything looks correct and select ',
    generateClaimsReportDescription2: 'Verify and Generate ',
    generateClaimsReportDescription3: 'below.',
    statusDescriptionForOneOption: 'Change status to "{{status}}" for the current row?',
    statusDescription:
      'Change status to "{{status}}" for all selected rows or only the current row?',
    prescriberDeclaration: 'Prescriber Declaration',
    bySavingThisPrescription: `By saving this prescription, I state that:`,
    requirementA: `a) I am or was treating this patient for the indicated diagnosis on the
      effective date of this order;`,
    requirementB: `b) This order accurately reflects this patient’s diagnosis and condition
      and is substantiated by my medical records;`,
    requirementC: `c) I will make the original signed copy of this document a part of this
      patient’s medical records and make it available to Medicare, Medicaid and other insurers
      or any authorized agent if requested.`,
    prescribingPhysician:
      'prescribing physician has approved this order to be sent to the pharmacy',
    hipaaAgreement: 'HIPAA Business Associate Agreement',
    hipaaAgreementFor: 'HIPAA Business Associate Agreement for {{accountName}}',
    privacyFor: 'Privacy for {{accountName}}',
    hippa_baa_For: 'HIPPA BAA for {{accountName}}',
    termsFor: 'Terms for {{accountName}}',
    scrollToTheBottom: 'Scroll to the bottom to accept agreement',
    readAndAccept: 'I have read and accept the agreement',
    administratorMustAccept: `An administrator must accept the HIPPA Business Associate
      Agreement before the account can be accessed.`,
    sessionTimeout: 'Session Timeout',
    inactivityWarning: `You're being timed out due to inactivity. Please choose to stay
      signed in or to logout. Otherwise, you will be logged out automatically.`,
    autoLogoutIn: 'Logging out in {{seconds}}s',
    createAssessmentDescription: 'Send an assessment to the patient.',
    updateRequired: 'Update Required',
    mandatoryUpdateTitle: 'Update required to continue',
    mandatoryUpdateSubtitle:
      'This version of the dashboard is no longer supported. Reload to load the current version — it takes a few seconds.',
    mandatoryUpdateStillOld:
      'Still on the old version. Your browser may be serving a cached copy — try reloading once more, or close and reopen the tab.',
    mandatoryUpdateVersionLabel: 'Current version:',
    // Shown instead of the blocking screen while something on the page
    // is unsaved: the update is required, but the user picks the moment.
    mandatoryUpdatePendingTitle: 'Update required — save your work first',
    mandatoryUpdatePendingSubtitle:
      'This version of the dashboard is no longer supported. You have unsaved changes, so nothing has been interrupted — save or discard them and the update will continue.',
    mandatoryUpdatePendingConfirm: 'Update now and lose unsaved changes',
    mandatoryUpdatePendingCancel: "I'll save first",
    chooseProviders: 'Choose Providers',
    updateVersionSubtitle:
      'There is a newer version of this dashboard available. To be sure you don’t run into any problems, click Update below to load the new version.',
    // The action, not the payload. The build number used to be
    // concatenated here ("Update to Version 261005001"), which named
    // the thing the user cannot read instead of the thing the button
    // does — and prompted "so which one am I on?", which the dialog
    // does not answer. The number lives in the sidebar and travels
    // with every feedback report; a clinician never needs it.
    updateNow: 'Update now',
    skipNow: 'Skip for now',
    // Create User wizard (v3 features/create-user)
    createUser: 'Create user',
    createUserFailedTitle: 'User was not created',
    stepDetails: 'Details',
    stepAccounts: 'Accounts',
    stepSettings: 'Settings',
    checkingEmail: 'Checking email availability...',
    emailAvailable: 'Email is available. Click "Next" to continue.',
    userExistsInAccount: 'User exists in your account',
    userExistsInAccountDesc:
      'This email already belongs to a user in this account. You can edit them instead.',
    userExistsInSystem: 'User exists in our system',
    userExistsInSystemDesc:
      'You can add them to your account with the role and permissions you choose next.',
    emailCheckFailed: "Couldn't check email. Try again.",
    selectAccounts: 'Select accounts',
    selectAccountsDesc:
      'Choose one or more accounts the user will have access to. You can refine roles and permissions next.',
    settingsTemplateHintSingle: 'These settings will be applied to the selected account.',
    settingsTemplateHintMany: 'These settings will be applied to all selected accounts.',
    roleAndProvider: 'Role and provider',
    permissions: 'Permissions',
    verifyEmailToContinue: 'Verify the email above to continue',
    accountAccess: 'Account access',
    unsavedChanges: 'Unsaved changes',
    unsavedChangesPreview: 'You have unsaved changes for "{{accountName}}":',
    bulkEditBanner: 'Editing {{count}} accounts',
    applyToAccounts: 'Apply these settings to all selected accounts.',
    bulkAllowedAccountsHint: 'Allowed accounts can only be edited per account.',
    removeAccountLastWarning:
      "This is the user's last account. Removing it will remove the user from the system entirely.",
    removeAccountWarning:
      'The user will lose access to {{accountName}}. Their other account access stays intact.',
    addAccountsToUser: 'Add accounts to user',
    addAccountsStep1Info:
      'Choose one or more accounts to grant the user access to. Settings will be applied uniformly in the next step.',
    addAccountsStep2Info:
      'Configure the role and permissions that will be applied to all selected accounts. You can fine-tune each account afterwards.',
    // Patient create flow (Session 12)
    stepNextSteps: "What's next",
    createOrderDescription: 'Place a clinical order for the patient.',
    sendResourceDescription: 'Send educational or care-plan resources to the patient.',
    patientCreatedNextStepHint: 'choose what to set up next, or skip and finish.',
    editPatientDescription: 'Update demographic, contact, or clinical details for this patient.',
    openPatientDashboardDescription:
      'Open the patient dashboard with assessments, orders, and history.',
  },
  scit: {
    buildUp46: '46 Dose/ Unit Build Up',
    buildUp50: '50 Dose/Unit Build-up',
    stage1: '10 Dose/ Unit Stage 1',
    stage2: '10 Dose/ Unit Stage 2',
    stage3: '10 Dose/ Unit Stage 3',
    stage4: '10 Dose/ Unit Stage 4',
    scitMaintenance: '12 Dose/ Unit SCIT Maintenance',
  },
  slit: {
    oneMonthLowDose: '1 Month Low Dose',
    oneMonthSLITMaintenance: '1 Month SLIT Maintenance',
  },
  allergens: {
    allergySymptomsDescription: 'List allergy symptoms',
    symptomsExposureDescription: 'Symptoms are mostly worse with exposure to',
    symptomsTimeOfYearDescription: 'Symptoms mostly occur at what time of year',
    symptomsTimeInDayDescription: 'Symptoms mostly occur at what time of day',
    symptomsMostlyOccurDescription: 'Symptoms mostly occur',
    examinationRevealsDescription: 'Examination reveals the following',
    allergyDiagnosisDescription: 'Allergy diagnosis',

    allergySymptoms: 'Patient allergy symptoms',
    symptomsExposure: 'Worse with exposure to',
    symptomsTimeOfYear: 'Seasonal occurrence',
    symptomsTimeInDay: 'Daily occurrence time',
    symptomsMostlyOccur: 'Where symptoms occur',
    examinationReveals: 'Physical exam findings',
    allergyDiagnosis: 'Clinical diagnosis',

    runnyOrStuffyNose: 'Runny or stuffy nose',
    sneezing: 'Sneezing',
    itchyNose: 'Itchy nose',
    blockedNose: 'Blocked nose',
    postNasalDripDrainage: 'Post nasal drip / drainage',
    mouthBreathingSnoring: 'Mouth breathing / snoring',
    frequentSniffling: 'Frequent sniffling',
    decreasedSmell: 'Decreased smell',
    headaches: 'Headaches',
    facialPressurePain: 'Facial pressure / pain',
    redEyes: 'Red eyes',
    itchyEyes: 'Itchy eyes',
    wateryEyes: 'Watery eyes',
    darkCircles: 'Dark circles',
    swollenDryEyes: 'Swollen dry eyes',
    soreEyes: 'Sore eyes',
    rash: 'Rash',
    hives: 'Hives',
    eczema: 'Eczema',
    swelling: 'Swelling',
    itchySkin: 'Itchy skin',
    wheezing: 'Wheezing',
    coughing: 'Coughing',
    chestTightness: 'Chest tightness',
    shortnessOfBreath: 'Shortness of Breath',
    chronicBronchitis: 'Chronic Bronchitis',
    itchyThroat: 'Itchy throat',
    throatClearing: 'Throat clearing',
    soreThroat: 'Sore throat',
    excessivePhlegm: 'Excessive phlegm',
    hoarseness: 'Hoarseness (weak, scratchy or husky voice)',

    grasses: 'Grasses',
    otherPollen: 'Other pollen',
    otherAnimalsOrInsects: 'Other animals or insects',
    dust: 'Dust',
    wind: 'Wind',
    perfume: 'Perfume',
    smokePollution: 'Smoke / pollution',
    cleaningProducts: 'Cleaning products',
    certainTypesOfFood: 'Certain types of food',
    grassesGrassMix:
      'Grass Mix (Timothy, Orchard, June, Red Top, Meadow Fescue, Perennial Rye, Sweet Venal)',
    grassesBermuda: 'Bermuda',
    grassesJohnson: 'Johnson',
    weeds: 'Weeds',
    weedsRagweed: 'Ragweed (Short ragweed, Giant/Tall Ragweed, Sagebrush)',
    weedsMugwort: 'Mugwort',
    weedsCocklbur: 'Cocklbur',
    weedsRoughMarshelder: 'Rough Marshelder',
    weedsPigweed: 'Pigweed (Rough Pigweed, Carelessweed, Western Water Hemp)',
    weedsDockSorrell: 'Dock Sorrell (Yellow Dock, Sheep Sorrel)',
    weedsChenopod: 'Chenopod (Kochia, Russian Thistle, Lambs Quarters)',
    weedsEnglishPlaintain: 'English Plantain',
    trees: 'Trees',
    treesBirch: 'Birch (Birch, Alder, Hazel)',
    treesCypress: 'Cypress (Juniper, Cedar, Cypress)',
    treesOlive: 'Olive (Olive, Ash, Privet)',
    treesBeechOak: 'Beech-Oak (Beech, Oak, Chestnut)',
    treesPecanHickory: 'Pecan-Hickory',
    treesPolarAspenCottonwood: 'Poplar-Aspen-Cottonwood',
    treesMapleElder: 'Maple-Elder',
    treesSycamore: 'Sycamore',
    treesElm: 'Elm',
    cat: 'Cat',
    dog: 'Dog',
    dustMites: 'Dust Mites',
    cockroach: 'Cockroach',
    mold: 'Mold',

    allYearRound: 'All year round',
    spring: 'Spring',
    summer: 'Summer',
    fall: 'Fall',
    winter: 'Winter',
    theyJustStarted: 'They just started',

    atNight: 'At night',
    duringTheDay: 'During the day',
    bothNightAndDay: 'Both night and day',

    indoor: 'Indoor',
    outdoor: 'Outdoor',
    bothIndoorAndOutdoor: 'Both indoor and outdoor',

    allergicRhinitis: 'Allergic rhinitis',
    asthma: 'Asthma',
    allergicConjunctivitis: 'Allergic conjunctivitis',
    atopicDermatitis: 'Atopic dermatitis',

    nasalAndSinusFindings: 'Nasal and Sinus Findings:',
    rhinorrhea: 'Rhinorrhea – Runny nose',
    nasalCongestion: 'Nasal congestion – Stuffy nose',
    turbinateHypertrophy: 'Turbinate hypertrophy – Enlarged nasal turbinates',
    septalDeviation: 'Septal deviation – Deviation of the nasal septum',
    postnasalDrip: 'Postnasal drip – Mucous drainage visible in the posterior pharynx',
    mouthBreathing: 'Mouth breathing – Observed during respiration',
    anosmiaOrHyposmia: 'Anosmia or hyposmia – Loss or decreased sense of smell',
    sinusTenderness: 'Sinus tenderness – Pain on palpation of sinuses',
    facialErythemaOrSwelling: 'Facial erythema or swelling – Inflammation around sinuses',
    boggyNasalMucosa: 'Boggy nasal mucosa – Swollen mucosa indicative of allergies or inflammation',
    eyeFindings: 'Eye Findings:',
    conjunctivalInjection: 'Conjunctival injection – Red eyes',
    periorbitalEdema: 'Periorbital edema – Swelling around the eyes',
    darkCirclesUnderEyes: 'Dark circles under eyes (Allergic shiners)',
    conjunctivalChemosis: 'Conjunctival chemosis – Swelling of the conjunctiva',
    blepharitis: 'Blepharitis – Eyelid inflammation',
    wateryEyesExcessiveLacrimation: 'Watery eyes – Excessive lacrimation',
    allergicConjunctivitisItchy: 'Allergic conjunctivitis – Itchy, red, and watery eyes',
    dermatologicalFindings: 'Dermatological Findings:',
    erythematousRash: 'Erythematous rash – Red skin rash',
    urticaria: 'Urticaria – Hives',
    lichenifiedPlaques: 'Lichenified plaques – Seen in chronic eczema',
    xerosis: 'Xerosis – Dry skin',
    angioedema: 'Angioedema – Swelling of subcutaneous tissues',
    pruritus: 'Pruritus – Generalized itchy skin',
    respiratoryFindings: 'Respiratory Findings:',
    wheezingHighPitched: 'Wheezing – High-pitched whistling sounds on auscultation',
    prolongedExpiratoryPhase:
      'Prolonged expiratory phase – Seen in asthma or obstructive airway diseases',
    cracklesOrRales:
      'Crackles or rales – Fine or coarse sounds on auscultation (if coexisting conditions)',
    rhonchi: 'Rhonchi – Low-pitched sounds from airway congestion',
    decreasedBreathSounds:
      'Decreased breath sounds – Indicative of airway obstruction or hyperinflation',
    coughingProductive: 'Coughing – Productive or nonproductive, audible during examination',
    barrelChest: 'Barrel chest – Chronic bronchitis-related physical finding',
    intercostalRetractions: 'Intercostal retractions – Seen in severe respiratory distress',
    throatFindings: 'Throat Findings:',
    pharyngealErythema: 'Pharyngeal erythema – Red throat',
    cobblestoningOfThePosteriorPharynx:
      'Cobblestoning of the posterior pharynx – Mucosal thickening due to postnasal drip',
    hoarsenessObserved: 'Hoarseness – Observed during conversation or phonation',
    tonsillarHypertrophy: 'Tonsillar hypertrophy – Enlarged tonsils',
    lymphadenopathy: 'Lymphadenopathy – Enlarged lymph nodes, typically cervical',
    throatClearingObserved: 'Throat clearing – Observed habit during examination',
  },
  formulas: {
    outdoor: 'Outdoor',
    indoor2: 'Indoor 2',
    indoor3: 'Indoor 3',
    indoor4: 'Indoor 4',
    mold: 'Mold',
    environment: 'Environment',
  },
  ordersCsv: {
    organization: 'Organization',
    firstName: 'First Name',
    lastName: 'Last Name',
    dob: 'DOB',
    gender: 'Gender',
    allergies: 'Allergies',
    patientPhone: 'Patient Phone',
    patientAddress: 'Patient Address',
    clinician: 'Clinician',
    npi: 'NPI',
    shipTo: 'Ship To',
    accountCustomIdentifier: 'Custom ID',
    category: 'Category',
    type: 'Type',
    formula: 'Formula',
    qty: 'Qty',
    geography: 'Geography',
    date: 'Date',
    expectedDeliveryDate: 'Expected Delivery Date',
    comments: 'Comments',
  },
  allergyBaselineAssessmentReport: {
    title: 'Allergy Baseline Assessment Report',
    firstPart: `The QHSLab ‘Allergy Assessment’ is a proprietary digital medicine tool developed to assist clinicians identify and deal with common allergic conditions, allergen triggers, symptom severity, medication use and frequency and health habits. The Allergy Assessment agrees with the definition for using CPT code 96160, “Administration of patient-focused health risk assessment instrument (e.g., health hazard appraisal) with scoring and documentation, per standardized instrument.`,
    requirementsFirst: 'The requirements to report 96160 are as follows:',
    requirementsSecond:
      'Practice expense is incurred to administer the instrument (such as nurse time or for purchase of the screen).\n' +
      'The instrument is standardized.\n' +
      'The instrument is scorable.\n' +
      'The results are documented in the medical record.',
    requirementsThird:
      'The term “standardized” means previously validated tests that are administered and scored in a consistent or “standard” manner.',
    requirementsForth:
      'What constitutes “scoring.” This is an important distinction between a true health risk assessment and history gathering forms. The instrument, at a minimum, should provide a threshold result or pertinent yes/no responses that would indicate a patient’s risk for an adverse health outcome or risk for further exacerbation of a current, typically chronic, medical condition.',
    QHSLabAllergyAssessmentTitle: 'QHSLab Allergy Assessment',
    QHSLabAllergyAssessmentText:
      'The Allergy Assessment is a proprietary digital medicine application that combines several validated and standardized allergy and asthma-related instruments described below. This assessment includes patient responses and scoring related to their allergy history, recent allergy and asthma symptoms, environmental impact and severity of these symptoms, allergy and asthma medication use, and lifestyle behaviors. The Allergy Assessment was developed to help physicians and other healthcare providers in their routine evaluation of patients suspected to have allergies and comorbid asthma. "Digital Medicine" is a term that relates to computerized applications that are directed by physicians and other healthcare providers. This assessment is not meant to be diagnostic or therapeutic, but to be used as an adjunct to clinical decision making. \n',
    respiratoryAllergyPredictionTestTitle: 'Respiratory Allergy Prediction Test',
    respiratoryAllergyPredictionTestText:
      'The Respiratory Allergy Prediction Test is a validated and straightforward four item assessment. This is designed to confirm the clinical suspicion of respiratory allergy and the medical necessity of performing allergy testing by its high predictive value. Answering yes to the following three questions: 1) occurrence of symptoms in the springtime, 2) to have or have had a cough and shortness of breath, and 3) to frequent use of nasal sprays, provides a high probability (85%) of a respiratory allergy diagnosis. It also suggests a real need for allergy testing to confirm the allergen trigger. If a patient answered yes to the questions just described. In that case, the physicians digital interpretation report will indicate the patient is highly likely to test positive to an allergy blood or skin test for confirmation of the environmental allergen triggers (Galimberti et al., 2015). ',
    generalAllergyHistoryTitle: 'General Allergy History',
    generalAllergyHistoryText:
      'A patient\'s knowledge of their various health conditions, or "health literacy," has been shown to benefit their approach to self-management and overall quality of life. Suppose a patient answers that they do not know if they have a health condition such as Allergic Rhinitis, Asthma, Allergic Conjunctivitis, or Allergic Urticaria. This situation could provide an educational opportunity to explain the condition, determine if the patient is suffering from the condition, and explain proper management of the condition. If a patient answers that they have the condition and treated in the past, this will provide insight into their expectation of the current treatment to be proposed. Both of these responses are opportunities to reinforce evidence-based approaches to allergy management.',
    patientReportedAllergySymptomsTitle: 'Patient Reported Allergy Symptoms',
    patientReportedAllergySymptomsText:
      "Allergens that cause symptoms can be broadly categorized as predominantly outdoor, indoor, or food-related. Different outdoor allergens pollinate at various times during the year. Trees produce pollen in the early to mid-springtime, grass pollination occurs later in spring through summer, and weeds pollinate in the fall season. Outdoor mold spores can also affect allergy sufferers year round when conditions suit fungi or mold growth, such as after the winter frost melts in early spring or after heavy rain periods followed by warmer weather conditions. Perennial allergens, such as dust mites, animal dander, insects, and mold allergens, which are likely to be found indoors in areas with high moisture or humidity conditions are very prevalent year round allergy symptom triggers. A patient's responses to questions regarding symptoms, occurrence, and environment help physicians determine the likely allergen to be affecting the patient, to be confirmed through a skin or blood test, and also helps the physician prescribe or modify medications.",
    sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
    sinoNasalOutcomeTestText2:
      "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
    sinoNasalOutcomeTestText3:
      'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
    sinoNasalOutcomeTestMildTitle: 'Mild',
    sinoNasalOutcomeTestMildText: 'Score of 8-19',
    sinoNasalOutcomeTestModerateTitle: 'Moderate',
    sinoNasalOutcomeTestModerateText: 'Score between 20-50',
    sinoNasalOutcomeTestSevereTitle: 'Severe',
    sinoNasalOutcomeTestSevereText: 'Score greater than 50',
    asthmaControlTestTitle: 'Asthma Control Test (ACT)',
    asthmaControlTestText:
      "Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004). Suppose your patient indicates that they have asthma in the general allergy history section. In that case, you will find the overall score to how well the patients asthma is under control from the ACT reported in the Physician Interpretation section. A score of 19 or less indicates that the patient's asthma might not be under control.",
    allergyMedicationUseTitle: 'Allergy Medication Use',
    allergyMedicationUseText:
      'Patients are often self-diagnosing and self-medicating inappropriately. The most commonly devised strategies for allergy symptoms are related to adherence to medications. Patients who self-medicate with OTC medications are likely to suffer from poor adherence rates, incorrect medications may be taken without medical or pharmacist direction. Self-management strategies can be better implemented when a patient’s medication type and use has been evaluated in combination with their symptom frequency and severity and environmental encounters.  The Allergy Assessment records the patients responses to medication use and frequency of antihistamines, decongestants, cromolyn, leukotriene receptor antagonists and combination long acting and beta2-adrenergic bronchodilators for patients that indicate they are asthmatic. ',
    healthBehaviorsTitle: 'Health Behaviors',
    healthBehaviorsTextFirst:
      "It is well known that a positive lifestyle including regular physical activity, weight control, good sleep hygiene, a healthy diet rich in fruits and vegetables, not using tobacco (and eliminating exposure to second-hand smoke), and psychological well-being can help allergy sufferers. Many patients know they need to make lifestyle changes but they don't often take it seriously until they hear it from a trusted medical professional. The Allergy Assessment also presents patients with questions related to their Health Behaviors and provides physicians with the patient's scores to physical activity and exercise levels, fruits and vegetable consumption, and tobacco use, as these health behaviors have obvious impact on a patients general wellbeing, weight management, and psychosocial health including quality of sleep.",
    healthBehaviorsTextSecond:
      'When patients are asymptomatic or have their pollen triggers under control, physicians should encourage their allergy and asthma patients achieve the recommended physical activity and exercise guidelines. Also, encouraging patients to spend time outside, especially in green spaces such as parks, forests, lakes, and beaches, when possible, to attract some good "bugs" into their microbiota is also beneficial to allergic disease management. Safe exposure to direct sunlight to soak up some natural vitamin D while exercising outdoors can also be beneficial.',
    healthBehaviorsTextThird:
      'Consuming a diet high in fermentable fiber, with fruits and vegetables and regular prebiotics, is highly beneficial and includes items such as garlic, onion, leek, chicory root, and asparagus. Probiotic-rich foods are also recommended and include fermented cabbage, sauerkraut or kimchi, pickles, buttermilk, and live-cultured yogurts. A healthy diet combined with prebiotics and probiotics may aid in allergy protection for your patients (Pullen and Grogan 2017).',
    healthBehaviorsTextForth:
      'In conclusion, the QHSLab Allergy Assessment provides a digital medicine tool for clinicians to quickly assess a patient’s likely allergy triggers and environmental conditions that affect their symptom severity and quality of life. With this simple digital health risk assessment, clinicians can determine if further confirmatory blood or skin tests are needed and if the patient would benefit from an allergy specialist involvement and/or allergen immunotherapy treatment approach.',
    referencesTitle: 'References',
    referencesFirst:
      'Galimberti et al. Catching allergy by a simple questionnaire. World Allergy Organization Journal (2015) 8:16',
    referencesSecond:
      'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
    referencesThird:
      'Toma S, Hopkins C. Stratification of SNOT-22 scores into mild, moderate, or severe and relationship with other subjective instruments. Rhinology. 2016 Jun;54(2):129-33.',
    referencesFourth:
      'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007). ',
    referencesFifth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
    referencesSixth:
      'Pullen and Grogan. Allergies on the Rise Solutions from Primary care. MedScience Research Group, Inc. (2017).',
  },
  QScaleReport: {
    title: 'Q-Scale',
    subtitle: 'Stress Type Test & Kessler 6 Instruments',
    firstPart:
      'A major advancement in psychological research and epidemiology over the last 40 years has been the development of lay-administered structured interviews, allowing the standardized estimation of the prevalence of psychological disorders among non-clinical populations.',
    secondPart:
      '"Q" stands for “Quality of Life,” and the Q-Scale measures a patient\'s responses or early warning signs to questions about their sleep, stress, anxiety, worry, pain and satisfaction. QHSLabs created the Q-Scale instrument to generate information on psychosocial wellbeing in otherwise healthy patients. Thus, items in the Q-Scale have been deliberately written to emphasize normal psychological functioning in generally healthy patients. If responses to the Q-Scale indicate potential mental health troubles, patients are directed to the Stress Type Test and Kessler 6 questions to identify their risk of clinical anxiety and depression for further clinical evaluation.',
    thirdPart:
      'Some people manage their stress best physically (running, playing sports, going to the gym), and others do it best mentally (meditation, relaxation, cognitive behavioral therapy). Patients who screen positively to questions relating to "feeling under strain pressure" or "finding it difficult to relax\' are directed to the Stress Type Test. The Stress Type Test is a 14 item assessment that identifies how the patient may best respond to a physical or cognitive stress management approach.¹',
    fourthPart:
      "The Kessler Screening Scale for Psychological Distress (Kessler 6) has been used widely as a screener for mental health problems and to measure the severity of the impact of mental health problems on a patient's daily life. The Kessler 6 is an appropriate screening and severity measure for mood disorders. It also predicts health-related quality of life over and above that predicted by diagnoses alone. Respondents rate how often they felt nervous, hopeless, restless, or fidgety, so sad that nothing could cheer them up, that everything was an effort, and worthless.²",
    referencesTitle: 'References',
    referencesFirst:
      'Egger, Binns, Rossner, & Sagner. (2017) Lifestyle Medicine. Lifestyle, the Environment and Preventive Medicine in Health and Disease. Third Edition. Academic Press',
    referencesSecond:
      'Kessler RC, Andrews G, Colpe LJ, Hiripi E, Mroczek DK, Normand SL, Walters EE, Zaslavsky AM Psychol Med. 2002 Aug; 32(6):959-76',
  },
  pediatricAllergyBaselineAssessmentReport: {
    title: 'Pediatric Allergy Baseline Assessment Report',
    firstPart: `The QHSLab ‘Pediatric Allergy Assessment’ is a proprietary digital medicine tool developed to assist clinicians identify and deal with common allergic conditions, allergen triggers, symptom severity, medication use and frequency in children. The Pediatric Allergy Assessment agrees with the definition for using CPT code 96160, “Administration of patient-focused health risk assessment instrument (e.g., health hazard appraisal) with scoring and documentation, per standardized instrument.`,
    requirementsFirst: 'The requirements to report 96160 are as follows',
    requirementsSecond:
      'Practice expense is incurred to administer the instrument (such as nurse time or for purchase of the screen). The instrument is standardized. The instrument is scorable. The results are documented in the medical record.',
    requirementsThird:
      'The term “standardized” means previously validated tests that are administered and scored in a consistent or “standard” manner.',
    requirementsForth:
      'What constitutes “scoring.” This is an important distinction between a true health risk assessment and history gathering forms. The instrument, at a minimum, should provide a threshold result or pertinent yes/no responses that would indicate a patient’s risk for an adverse health outcome or risk for further exacerbation of a current, typically chronic, medical condition.',
    QHSLabAllergyAssessmentTitle: 'QHSLab Pediatric Allergy Assessment',
    QHSLabAllergyAssessmentText:
      'The Pediatric Allergy Assessment is a proprietary digital medicine application that combines several validated and standardized allergy and asthma-related instruments described below. This assessment includes parent and guardian responses and scoring related to their child’s allergy history, recent allergy and asthma symptoms, environmental impact and severity of these symptoms, and allergy and asthma medication use. The Pediatric Allergy Assessment was developed to help physicians and other healthcare providers in their routine evaluation of children suspected to have allergies and comorbid asthma. "Digital Medicine" is a term that relates to computerized applications that are directed by physicians and other healthcare providers. This assessment is not meant to be diagnostic or therapeutic, but to be used as an adjunct to clinical decision making.',
    respiratoryAllergyPredictionTestTitle: 'Respiratory Allergy Prediction Test',
    respiratoryAllergyPredictionTestText:
      'The Respiratory Allergy Prediction Test is a validated and straightforward four item assessment. This is designed to confirm the clinical suspicion of respiratory allergy and the medical necessity of performing allergy testing by its high predictive value. Answering yes to the following three questions: 1) occurrence of symptoms in the springtime, 2) to have or have had a cough, wheezing and shortness of breath, and 3) to frequent use of nasal sprays, provides a high probability (85%) of a respiratory allergy diagnosis. It also suggests a real need for allergy testing to confirm the allergen trigger. If a patient answered yes to the questions just described. In that case, the physicians digital interpretation report will indicate the patient is highly likely to test positive to an allergy blood or skin test for confirmation of the environmental allergen triggers (Galimberti et al., 2015 & Sacchetti M et al).',
    generalAllergyHistoryTitle: 'General Allergy History',
    generalAllergyHistoryText:
      'A parent or guardians knowledge of their child’s various health conditions, or "health literacy," has been shown to benefit their approach to self-management and overall quality of life. Suppose a parent or guardian answers that they do not know if their child has a health condition such as Allergic Rhinitis, Asthma, Allergic Conjunctivitis, Allergic Urticaria, food allergy or anaphylaxis. This situation could provide an educational opportunity to explain the condition, determine if the child is suffering from the condition, and explain proper management of the condition. If a parent or guardian answers that their child has the condition and treated in the past, this will provide insight into their expectation of the current treatment to be proposed. Both of these responses are opportunities to reinforce evidence-based approaches to allergy management.',
    patientReportedAllergySymptomsTitle: 'Parent or Guardian Reported Child’s Allergy Symptoms',
    patientReportedAllergySymptomsText:
      'Allergens that cause symptoms can be broadly categorized as predominantly outdoor, indoor, or food-related. Different outdoor allergens pollinate at various times during the year. Trees produce pollen in the early to mid-springtime, grass pollination occurs later in spring through summer, and weeds pollinate in the fall season. Outdoor mold spores can also affect allergy sufferers year round when conditions suit fungi or mold growth, such as after the winter frost melts in early spring or after heavy rain periods followed by warmer weather conditions. Perennial allergens, such as dust mites, animal dander, insects, and mold allergens, which are likely to be found indoors in areas with high moisture or humidity conditions are very prevalent year round allergy symptom triggers. A parent or guardian’s responses to questions regarding their child’s symptoms, occurrence, and environment help physicians determine the likely allergen to be affecting the child, to be confirmed through a skin or blood test, and also helps the physician prescribe or modify medications.',
    sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
    sinoNasalOutcomeTestText2:
      "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
    sinoNasalOutcomeTestText3:
      'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
    sinoNasalOutcomeTestMildTitle: 'Mild',
    sinoNasalOutcomeTestMildText: 'Score of 8-19',
    sinoNasalOutcomeTestModerateTitle: 'Moderate',
    sinoNasalOutcomeTestModerateText: 'Score between 20-50',
    sinoNasalOutcomeTestSevereTitle: 'Severe',
    sinoNasalOutcomeTestSevereText: 'Score greater than 50',
    asthmaControlTestTitle: 'Asthma Control Test (ACT)',
    asthmaControlTestText:
      "Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004). Suppose your patient indicates that they have asthma in the general allergy history section. In that case, you will find the overall score to how well the patients asthma is under control from the ACT reported in the Physician Interpretation section. A score of 19 or less indicates that the patient's asthma might not be under control.",
    allergyMedicationUseTitle: 'Allergy Medication Use',
    allergyMedicationUseText:
      'Parents and guardians are often self-diagnosing and self-medicating their children inappropriately. The most commonly devised strategies for allergy symptoms are related to adherence to medications. Patients who self-medicate with OTC medications are likely to suffer from poor adherence rates, incorrect medications may be taken without medical or pharmacist direction. Self-management strategies can be better implemented when a patient’s medication type and use has been evaluated in combination with their symptom frequency and severity and environmental encounters. The Pediatric Allergy Assessment records the parent or guardians responses to their child’s medication use and frequency of antihistamines, decongestants, cromolyn, leukotriene receptor antagonists and combination long acting and beta2-adrenergic bronchodilators for patients that indicate they are asthmatic. \n In conclusion, the QHSLab Pediatric Allergy Assessment provides a digital medicine tool for clinicians to quickly assess a patient’s likely allergy triggers and environmental conditions that affect their symptom severity and quality of life. With this simple digital health risk assessment, clinicians can determine if further confirmatory blood or skin tests are needed and if the patient would benefit from an allergy specialist involvement and/or allergen immunotherapy treatment approach.',
    referencesTitle: 'References',
    referencesFirst:
      'Galimberti et al. Catching allergy by a simple questionnaire. World Allergy Organization Journal (2015) 8:16',
    referencesSecond:
      'Sacchetti M et al. Development and preliminary validation of a new screening questionnaire for identifying atopic children. Pediatric Health, Medicine and Therapeutics 2017:8 99–105',
    referencesThird:
      'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
    referencesFourth:
      'Toma S, Hopkins C. Stratification of SNOT-22 scores into mild, moderate, or severe and relationship with other subjective instruments. Rhinology. 2016 Jun;54(2):129-33.',
    referencesFifth:
      'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007).',
    referencesSixth: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
  },
  SNOT22Report: {
    title: 'SNOT-22 Assessment',
    firstPart: `SNOT-22 is a disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues, which provides an overall symptom severity score that may be impacting a patients quality of life.`,
    sinoNasalOutcomeTestTitle: 'Sino-Nasal Outcome Test-22 (SNOT-22)',
    sinoNasalOutcomeTestText1:
      "The Sino-Nasal Outcome Test-22 (SNOT-22) is a commonly utilized disease-specific questionnaire involving 22 symptoms that combine rhinologic issues with general health issues. The SNOT-22 has been validated and has been proven easy to use throughout the world in clinical practice and research. Physicians can use this test to facilitate routine clinical practice to highlight chronic rhinosinusitis's impact on patients' quality of life. This test is also frequently used to measure the outcome of surgical intervention and specific allergen immunotherapy treatment (Hopkins et al., 2009).",
    sinoNasalOutcomeTestText2:
      "You will find the patient's overall result of their SNOT-22 (reported in the section titled Physician Interpretation) with one of the following indications:",
    sinoNasalOutcomeTestText3:
      'Physicians can review each of the 22 answers to the SNOT-22 in the report section under the heading "Allergy Symptom Severity SNOT-22."',
    sinoNasalOutcomeTestMildTitle: 'Mild',
    sinoNasalOutcomeTestMildText: 'Score of 8-19',
    sinoNasalOutcomeTestModerateTitle: 'Moderate',
    sinoNasalOutcomeTestModerateText: 'Score between 20-50',
    sinoNasalOutcomeTestSevereTitle: 'Severe',
    sinoNasalOutcomeTestSevereText: 'Score greater than 50',
    referencesTitle: 'References',
    referencesFirst:
      'Hopkins C et al. Psychometric validity of the 22-item Sinonasal Outcome Test. Clin Otolaryngol. 2009 Oct;34(5):447-54.',
  },
  asthmaControlAssessmentReport: {
    title: 'Asthma Control Test (ACT)',
    firstPart: `The Asthma control test is a 5 item assessment that indicates how well a patients Asthma control has been over the past month.`,
    asthmaControlTestTitle: 'Asthma Control Test (ACT)',
    asthmaControlTestText:
      'Chronic Rhinosinusitis (CRS) is strongly associated with comorbid asthma. The Asthma Control Test (ACT) quickly provides a numerical score to assess asthma control. The ACT is recognized by the National Institutes of Health (NIH) in its 2007 asthma guidelines and has been clinically validated against spirometry and specialist assessment (Nathan et al. 2004).',
    asthmaControlTestText2:
      "A score of 19 or less indicates that the patient's asthma might not be under control.\n",
    referencesTitle: 'References',
    referencesFirst:
      'US Department of Health and Human Services, National Institutes of Health, National Heart, Lung, and Blood Institute. Expert Panel Report 3: Guidelines for the Diagnosis and Management of Asthma (EPR-3 2007).',
    referencesSecond: 'Nathan RA et al. J Allergy Clin Immunol. 2004;113:59-65.',
  },
  printReport: {
    assessmentDate: 'Assessment Date',
    dateOfBirth: 'Date of Birth',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    MRN: 'MRN',
    zipCode: 'Zip code',
    providerName: 'Provider Name',
    providerNPI: 'Provider NPI',
    accountAddress: 'Account Address',
  },
  printBilling: {
    billingReport: 'Billing Report',
    procedureName: 'Procedure Name',
    procedureDescription: 'Procedure Description',
    exampleCPT: 'Example CPT',
    completedTimestamp: 'Date Completed',
    reviewedTimestamp: 'Provider Review Date',
    dateOfBirth: 'Date of Birth',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    MRN: 'MRN',
    zipCode: 'Zip code',
    providerName: 'Provider Name',
    accountAddress: 'Account Address',
  },
  charts: {
    '< 1': '< 1',
    '1-4': '1-4',
    '5-14': '5-14',
    '15-24': '15-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-64': '55-64',
    '65-74': '65-74',
    '75-84': '75-84',
    '> 84': '> 84',
    genderFemale: 'Gender (Female)',
    averageAge: 'Average age',
    generalHealth: 'General Health',
    symptomSeveritySnot22: 'Symptom Severity (SNOT-22)',
    physicalActivity: 'Physical Activity',
    fruitVegetableConsumption: 'Fruit and Vegetable Consumption',
    tobaccoUse: 'Tobacco Use',
    ageRange: 'Age Range',
    asthma: 'Asthma',
    allergicRhinitis: 'Allergic Rhinitis',
    allergicUrticara: 'Allergic Urticara',
    allergicConjunctivitis: 'Allergic Conjunctivitis',
    numberOfPatients: 'Number of patients',
    good: 'Good',
    fair: 'Fair',
    very_good: 'Very Good',
    excellent: 'Excellent',
    poor: 'Poor',
    do_not_know: 'I do not know if I have this condition',
    know_i_dont_have: 'I know I do not have this condition',
    never_treated: 'I have this condition but never treated for it',
    treated_in_past: 'I have this condition and treated in the past',
    treated_monitored: 'I am treated and monitored regulary for this condition',
    low: 'Low',
    lowRisk: 'Low Risk',
    moderate: 'Moderate',
    moderateRisk: 'Moderate Risk',
    highRisk: 'High Risk',
    mild: 'Mild',
    severe: 'Severe',
  },
  dashboard: {
    activePatients: '{{count}} active patients',
    errorLoadingMetrics: "Couldn't load dashboard metrics",
    numberOfPatients: 'Number of Patients',
    genderFemale: 'Gender (Female)',
    averageAge: 'Average Age',
    ageUnit: 'yrs',
    femaleOfTotal: '{{female}} of {{total}} patients',
    noChartData: 'No data',
    healthStatus: 'Health Status',
    riskConditions: 'Risk Conditions',
    lifestyle: 'Lifestyle',
  },
  permissionsTesting: {
    banner: 'Non-production testing tool. Changes take effect after the user signs in again.',
    account: 'Account',
    user: 'User',
    selectAccount: 'Select an account',
    selectUser: 'Select a user',
    noUsers: 'This account has no editable users.',
    pickPair: 'Select an account and a user to load their permissions.',
    pairUnavailable: 'This account and user pair is no longer available. Pick another.',
    loading: 'Loading...',
    sectionUser: 'User',
    sectionUserHint: 'Global for this person, across every account they belong to.',
    sectionUserAccount: 'User in this account',
    sectionUserAccountHint: 'Role and per-account flags.',
    sectionAccount: 'Account',
    sectionAccountHint: 'Features switched off for the whole account.',
    readOnly: 'Read-only',
    effective: 'Effective permissions',
    effectiveHint: 'The masks the backend will bake into this user’s next token.',
    effectiveCurrent: 'Current account',
    effectiveChild: 'Child accounts',
    decode: 'Decode',
    decodeUnknown: 'Set bits with no name in the dashboard',
    decodeNone: 'No permissions set.',
    bulkJson: 'Bulk edit as JSON',
    bulkJsonHint: 'Replaces every value at once. Save still sends only the sections you changed.',
    bulkJsonInvalid: 'Not valid JSON.',
    save: 'Save',
    clearAll: 'Clear all flags',
    clearAllHint:
      'Sets every editable flag to false and leaves the role unchanged. Account flags are "disable" flags, so clearing them enables those features.',
    saved: 'Saved. Changes take effect after the user signs in again.',
    featureOff: 'Not available on this environment.',
  },
  fileUploading: {
    dragFileHere: 'DRAG FILE HERE OR',
    availableFormats: '* available file format - ".XLSX"',
    fileIsUploaded: 'The file is uploaded and validated...',
    fileSuccessfullyValidated: 'File successfully validated',
    importPatientsNow: 'Import Now',
    importNow: 'Import Now',
    importInsuranceNow: 'Import Insurance Now',
    fileTypeNotSupported: 'File type not supported',
    downloadValidationErrors: 'download validation errors',
    fileHasValidationErrors: 'Uploaded file has validation errors',
    uploadAndValidate: 'Upload And Validate',
    selectFile: 'Select File',
    uploadOneFile: 'Please upload one file',
    fileTooLarge: 'File is too large. Maximum size is 10 MB',
    fileTypeInvalid: 'Invalid file type. Only .XLSX files are accepted',
    importWasSuccessful: 'Import was successful',
    ok: 'ok',
    error500:
      "The string 'United States' was not recognized as a valid DateTime. There is an unknown word starting at index '0'",
  },
  claimUpload: {
    title: 'Claims Upload',
    boxSubtitle:
      'Upload an .xlsx file. Validate it first to preview issues without saving, or import to apply the changes.',
    boxSubtitleNoValidate: 'Upload an .xlsx file to import the rows.',
    dropHint: 'Drop your .xlsx file or browse',
    dropHintSub: 'Only .xlsx files',
    changeFile: 'Change file',
    removeFile: 'Remove file',
    uploadAndImport: 'Upload & import',
    uploadAndImportHint: 'Imports and saves the rows',
    validateOnly: 'Validate only',
    validateOnlyHint: 'Checks for errors — nothing is saved',
    onlyXlsx: 'Only .xlsx files are supported',
    selectOneFile: 'Please select a single .xlsx file',
    resultTotal: 'Total',
    resultImported: 'Imported',
    resultFailed: 'Failed',
    downloadErrorRows: 'Download error rows ({{count}})',
    addedToHistory: 'New row also added to history below',
    dryRunTitle: 'Validation only — nothing was saved',
    rejectedTitle: 'File rejected — invalid structure',
    issuesCount: '{{count}} issues',
    noErrorDetails: 'No further details provided.',
    rejectedSubtitle: 'No rows were imported. Fix the issues below and re-upload.',
    rejectedSubtitleValidate:
      'Validation only — the file was rejected, nothing was saved. Fix the issues below.',
    summaryValidatePassed:
      'Validation passed — {{imported}} of {{total}} rows are ready to import. Nothing was saved.',
    validatedSuccess: 'File validated successfully — ready to upload.',
    summaryValidateIssues:
      'Validation found {{failed}} issue(s) in {{total}} rows. Nothing was saved.',
    summaryImportComplete: 'All {{imported}} rows imported successfully.',
    summaryImportPartial: 'Import finished — {{imported}} imported, {{failed}} failed.',
    skippedEmptyRows: '{{count}} empty rows skipped',
    statusCompleted: 'Completed',
    statusCompletedWithErrors: 'Completed with errors',
    statusRejected: 'Rejected',
    statusValidationFailed: 'Validation failed',
    // Binary-response domains (Patients / Insurance / Providers): the POST
    // returns an empty 200 (all rows in) or an annotated .xlsx workbook.
    fileSuccessTitle: 'All rows imported successfully.',
    fileFailedTitle: 'Some rows could not be imported.',
    fileFailedSubtitle:
      'Rows without errors were imported. Download the annotated file to see what failed and why.',
    fileValidateFailedTitle: 'Validation found issues.',
    fileValidateFailedSubtitle: 'Nothing was saved. Download the annotated file to see the issues.',
    downloadAnnotated: 'Download annotated file',
    importedLink: 'Imported',
    historyTitle: 'Upload history',
    filterDateRange: 'Date range',
    filterUploadedBy: 'Uploaded by',
    allUploaders: 'All users',
    colFile: 'File',
    colStatus: 'Status',
    colImpFail: 'Imp/Fail',
    colUploadedBy: 'Uploaded by',
    colUploaded: 'Uploaded',
    errorsLink: 'Errors',
    historyEmpty: 'No uploads yet',
    justNow: 'just now',
    loadMore: 'Load more',
  },
  tooltips: {
    notificationsComingSoon: 'News and release updates are coming soon',
    oneAccountColumnsMustBeSelected:
      'At least one of the account columns must be selected for a Distribution Sponsor.',
    enableAutomation: 'Enable Automation',
    availableOnlyForDS: 'Available only for DS account',
    availableAfterSaving: 'Available after saving the account',
    // Create User wizard
    dsIncompatiblePermission:
      'Not available — your selection includes a Distribution Sponsor account.',
    compareImproved: 'Improved',
    compareWorsened: 'Worsened',
    compareChanged: 'Changed',
    severityCritical: 'Critical',
    severityMonitor: 'Monitor',
    help: 'Help',
    // Row-menu availability hints
    noPermissionForAction: "You don't have permission for this action",
    rowActionResendUnavailable:
      'Available while the assessment is awaiting the patient (Invited, Opened, In Progress, or Partial Processed)',
    rowActionGenerateClaimUnavailable:
      "Available for completed assessments that don't already have a claim",
    rowActionViewLinkUnavailable:
      'The link is not available for Scheduled, No Show, or Declined assessments',
    rowActionReportUnavailable: 'The patient report is generated when the assessment is completed.',
    rowActionComparisonUnavailable:
      'A comparison needs an earlier completed assessment of the same type for this patient.',
    rowActionEVisitUnavailable:
      'No E-Visit report for this assessment: an E-Visit (99422) claim was not created. Claims are created when a provider accepts the results, only for assessment types ticked in the E-Visit column, and once per patient in 30 days.',
    rowActionCounselingUnavailable:
      'No Preventive Health Counseling report: this assessment type does not include the wellness-conversation question, or the patient did not choose any topics in it.',
    rowActionAppointmentNotPassed: 'Available after the appointment date has passed',
    rowActionPatientDisabled: 'Available when the patient status is Active',
    rowActionImmunotherapyUnavailable: 'Available for SCIT immunotherapy orders',
    rowActionResourceScheduled: 'This resource is scheduled and has not been sent yet',
    rowActionEVisitClaimUnavailable: 'Available for claims generated from an E-Visit program',
  },
  infoPane: {
    patient: 'Patient',
    clickToCopyToClipboard: 'Click to copy value',
    editPatient: 'Edit patient',
    openPatientDashboard: 'Open Patient Dashboard',
    sentEmail: 'Send email',
    metrics: 'Metrics',
    claims: 'Claims',
    assessments: 'Assessments',
    reportables: 'Reportables',
    resource: 'Resources',
    alerts: 'Alerts',
    emailPatient: 'Email Patient?',
    openEmailApp: 'Choose how you would like to send an email to this patient.',
    emailPatientWithApp: 'Open in Mail App',
    emailPatientWithOutlook: 'Open in Outlook Web',
    emailHandlerNote:
      'If clicking "Open in Mail App" does nothing, your browser may not have a default email handler configured.',
    emailHandlerLink: 'How to set up',
    send: 'Send',
    filtersApplied: 'Filters Applied',
    moreDetails: 'More Details',
    clickToOpenInfoPane: 'Click to open info pane',
    anonymousPatient: 'Anonymous Assessment',
    anonymousPatientInfo: 'No patient information collected',
    sections: {
      identification: 'Identification',
      engagement: 'Patient Status',
      contact: 'Contact',
      demographics: 'Demographics',
    },
    collapseButton: 'Collapse',
    callPatient: 'Call patient',
    errorTitle: 'Could not load patient',
    errorRetry: 'Try again',
  },
  populationHealth: {
    exportFile: 'Export file',
    dateRange: 'Date Range',
    assessmentType: 'Assessment Type',
    comparisonMode: 'Comparison Mode',
    baselineVsFollowup: 'Baseline vs Follow-up',
    singleTimePoint: 'Single Time Point',
    totalPatients: 'Total Patients',
    loadingPopulationHealthData: 'Loading population health data...',
    noMetricsAvailable: 'No metrics available for selected assessment instrument',
    pleaseSelectDifferentInstrument:
      'Please select a different instrument or choose "All Instruments"',
    patientDetails: 'Patient Details',
    baselinePatients: 'Baseline Patients',
    followupPatients: 'Follow-up Patients',
    populationDistribution: 'Population Distribution',
    baselineVsFollowupComparison: 'Baseline vs Follow-up Comparison',
    metricSummary: 'Metric Summary',
    totalPatientsCount: 'Total Patients',
    ofPopulation: 'Of Population',
    riskLevel: 'Risk Level',
    change: 'Change',
    patientList: 'Patient List',
    noPatients: 'No patients',
    foundForThisMetric: 'found for this metric',
    noBaselinePatients: 'No baseline patients',
    noFollowupPatients: 'No follow-up patients',
    lastAssessment: 'Last assessment',
    score: 'Score',
    low: 'Low',
    moderate: 'Moderate',
    high: 'High',
    critical: 'Critical',
    helpRequested: 'Help Requested',
    monitor: 'Monitor',
    otherPatients: 'Other Patients',
    baseline: 'Baseline',
    followup: 'Follow-up',
    baselineLight: 'Baseline (Light)',
    followupFullColor: 'Follow-up (Full Color)',
    numberOfPatients: 'Number of Patients',
    patients: 'Patients',
    clickToViewDetails: 'Click to view patient details',
    colorsIndicateRiskLevels:
      'Colors indicate risk levels: Red (Critical), Orange (High), Blue (Monitor), Green (Help Requested)',
    redCritical: 'Red (Critical)',
    orangeHigh: 'Orange (High)',
    blueMonitor: 'Blue (Monitor)',
    greenHelpRequested: 'Green (Help Requested)',
    alerts: 'Alerts',
    ofTotal: 'Of Total',
    populationHealthMetrics: 'Population Health Metrics',
    clickBarToViewDetails: 'Click on any bar to view detailed patient information',
    selectDateRange: 'Select date range',
    clearDateRange: 'Clear date range',
    searchAssessments: 'Search assessments...',
    loadingAssessments: 'Loading assessments...',
    noAssessmentsFound: 'No assessments found',
    noAssessmentsAvailable: 'No assessments available',
    allAssessments: 'All Assessments',
    noPatientDataAvailable: 'No patient data available',
    searchPatientsPlaceholder: 'Search patients by name, ID, or details...',
    noPatientFoundFor: 'No patients found for "{{query}}"',
    // Export report
    exportReportTitle: 'Population Health Assessment Report',
    exportReportSubtitle: 'Comprehensive patient outcome analysis and clinical metrics overview',
    reportingPeriod: 'Reporting Period',
    assessmentTool: 'Assessment Tool',
    patientCohort: 'Patient Cohort',
    activePatients: 'Active Patients',
    analysisType: 'Analysis Type',
    comparativeAnalysis: 'Comparative Analysis',
    currentPeriod: 'Current Period',
    dataStatus: 'Data Status',
    deidentified: 'De-identified',
    generated: 'Generated',
    allTime: 'All time',
    allInstruments: 'All Instruments',
    clinicalGrade: 'Clinical Grade',
    accountFilter: 'Account',
    selectAccount: 'Select Account',
    loadingAccountsText: 'Loading accounts...',
    noAccountsAvailable: 'No accounts available',
    exportDisclaimer:
      'Clinical Data Disclaimer: This report contains aggregated, de-identified patient health information processed in compliance with HIPAA Privacy Rule. Data is intended for healthcare quality improvement and clinical decision support. Individual patient identifiers have been removed to protect privacy.',
    anyDate: 'Any date',
    allAccounts: 'Current account',
    metricsTitle: 'Population Health Metrics',
    clickBarHint: 'Click on any bar to view detailed patient information.',
    exportPng: 'PNG',
    exportPdf: 'PDF',
    exportData: 'Export Data',
    loadingMetrics: 'Loading population metrics…',
    loadingHint: 'Crunching patient data for the selected filters. This usually takes a moment.',
    errorTitle: "Couldn't load the metrics",
    errorHint:
      'Something went wrong while fetching the dashboard. Try again in a moment or adjust your filters.',
    emptyTitle: 'No matching data',
    emptyHint:
      'No patients match the selected filters. Try widening the date range or picking a different assessment.',
    resetFilters: 'Reset filters',
  },
  assessmentPerformance: {
    includeAutomated: 'Include automated assessments',
    automatedExcluded: 'Automated assessments excluded',
    pageTitle: 'Assessment Performance',
    pageSubtitle: 'Compare assessment completion across accounts for any two periods.',

    // Filter chips
    periodA: 'Current',
    periodB: 'Previous',
    quickRange: 'Quick range',
    quickRangePlaceholder: 'Apply preset…',
    account: 'Account',
    selectPeriod: 'Select period',
    presetWoW: 'Week over week',
    presetMoM: 'Month over month',
    selectedAccountSingle: '1 selected',
    selectedAccountsCount: '{{count}} selected',
    clearAll: 'Clear',
    columnOffice: 'Office',

    // Account picker (server-driven via /accounts)
    accountPickerPlaceholder: 'Pick accounts to compare',
    accountPickerSearch: 'Search accounts by name…',
    accountPickerLoading: 'Loading accounts…',
    accountPickerNoResults: 'No accounts match this search.',
    accountPickerEmpty: 'No accounts available.',
    accountPickerNoSelection: 'No accounts selected — pick at least one',
    accountPickerLoadMore: 'Load more',
    accountPickerFilterByTags: 'Filter by tags',

    // KPIs
    kpiSent: 'Sent',
    kpiCompleted: 'Completed + E-T',
    kpiCompletionRate: 'Completion rate',
    kpiDelta: 'Δ vs prev period',
    pp: 'pp',
    noChange: 'no change',

    // Comparison table
    tableTitle: 'Comparison table',
    tableHint: 'Previous → Current (Δ%). Click a row to drill down.',
    columnAccount: 'Account',
    rowTotal: 'Total (all accounts)',

    // Metric labels
    metricSent: 'Sent',
    metricCompleted: 'Completed',
    metricETransfer: 'E-Transfer',
    metricCombinedCompleted: 'Completed + E-T',
    metricPartialProcessed: 'Partial Processed',
    metricPendingReview: 'Pending Review',
    metricInProgress: 'In Progress',
    metricNoShow: 'No Show',
    metricDeclined: 'Declined',
    metricNoShowAndDeclined: 'No Show + Declined',
    metricInvited: 'Invited',
    metricCompletionRate: 'Completion %',
    metricEngagementRate: 'Engagement %',
    metricNoResponseRate: 'No-response %',

    // Tone tooltips
    toneInfoTitle: 'Colour semantics',
    toneInfoBody:
      'Performance metrics turn green when moving in the right direction and red when not. Monitor metrics show orange on a rise (attention) and green on a fall (improvement). Neutral volume metrics stay grey regardless of change.',

    // Charts
    chartCardTitle: 'Visualisations',
    chartCardHint: 'Switch between focused (one metric) and overview (all metrics) views.',
    chartTabDiverging: 'Per-account Δ',
    chartTabHeatmap: 'Heatmap',
    chartMetricSelector: 'Metric',
    chartXLabel: 'Δ% vs Previous',
    chartLegendUp: 'Increase',
    chartLegendDown: 'Decrease',

    // Drill-down modal
    drilldownTitle: 'Account breakdown',
    drilldownActiveFilters: 'Active filters',
    drilldownPeriodALabel: 'Current',
    drilldownPeriodBLabel: 'Previous',
    drilldownStatusDistribution: 'Status distribution',
    drilldownMetricsBreakdown: 'Metrics breakdown',
    drilldownMetricColumn: 'Metric',
    drilldownEmailSummary: 'Email account summary',
    drilldownEmailHint: 'Opens your default mail client with the breakdown pre-filled.',

    // Toolbar
    exportCsv: 'Export CSV',
    exportPng: 'Export PNG',
    emailFullReview: 'Email full review',

    // Email-draft dialog (used when the body is too long for mailto)
    emailDraftDialogTitle: 'Email draft is too long for auto-fill',
    emailDraftDialogDescription:
      'This monthly review covers every account in one email — the full body is too large for most mail clients (Gmail, Outlook web) to accept through the auto-fill link. They reject anything over ~2 KB.',
    emailDraftStep1: 'Copy the email body',
    emailDraftStep1Hint: '— click the button below to write the full body to your clipboard.',
    emailDraftStep2: 'Open your mail client',
    emailDraftStep2Hint: '— a new draft opens with the subject pre-filled.',
    emailDraftStep3: 'Paste the body',
    emailDraftStep3Hint: '— Cmd / Ctrl + V into the message body.',
    emailDraftSubjectLabel: 'Subject',
    emailDraftCopyButton: 'Copy email body',
    emailDraftCopiedButton: 'Copied',
    emailDraftCopied: 'Email body copied to clipboard.',
    emailDraftOpenButton: 'Open empty draft',

    // Empty / loading / error / pick-something
    loading: 'Loading assessment performance…',
    pickToBeginTitle: 'Pick a date range and at least one account',
    pickToBeginHint:
      'Use the chips above to set the current period, previous period, and the accounts you want to compare. Defaults to last week vs the week before.',
    emptyTitle: 'No data for the selected periods',
    emptyHint: 'Try a wider date range or change the account selection.',
    errorTitle: 'Could not load metrics',
    errorRetry: 'Retry',
  },
  messages: {
    checkingEmail: 'Checking email availability...',
    emailAvailable: 'Email is available. Click "Next" to continue.',
    userExists: 'User {email} already exists',
    userExistsAddToAccount: 'User {email} exists in system',
    errorCheckingEmail: 'Error checking email. Please try again.',
    validating: 'Validating...',
    userAddedSuccess:
      'User {{firstName}} {{lastName}} has been successfully added to your account.',
    userCreatedSuccess: 'User {{firstName}} {{lastName}} has been successfully created.',
    emailRequired: 'Email is required',
    invalidEmail: 'Please enter a valid email address',
    searchAccountsPlaceholder: 'Search accounts...',
    noAccountsFound: 'No accounts found',
    noAccountsAvailable: 'No accounts available',
    permissionsCount: '{{count}} permissions',
  },
  unsavedChanges: {
    title: 'Unsaved changes',
    defaultMessage: 'Your changes will be lost if you leave.',
    keepEditingButton: 'Stay',
    discardButton: 'Leave',
    // User forms
    userProfile: 'You have unsaved changes to your profile.',
    userCreate: 'You have unsaved changes to the new user.',
    providerCreate: 'You have unsaved changes to the new provider.',
    providerEdit: 'You have unsaved changes to this provider.',
    userAccountAdd: 'You have unsaved access details. Leave anyway?',
    userEdit: "You have unsaved changes to {name}'s profile.",
    userEditWarning:
      'Any changes you made to user information, roles, or permissions will be permanently lost and cannot be recovered.',
    // Account forms
    accountCreate: 'You have unsaved changes to the new account.',
    accountEdit: 'You have unsaved changes to {{name}} settings.',
    accountPermissions: 'You have unsaved changes to {name} permissions.',
    accountSwitchWarning:
      'You have unsaved changes to {name} permissions. Switching accounts will lose your changes.',
    accountSwitchTabMessage:
      'You have unsaved changes. Are you sure you want to switch to the Instant Assessments tab? Your changes will be lost.',
    switchTab: 'Switch Tab',
    // Order forms
    orderCreate: 'You have unsaved changes to the new order.',
    orderEdit: 'You have unsaved changes to this order.',
    // Assessment forms
    assessmentCreate: 'You have unsaved changes to the new assessment.',
    // Patient forms
    patientEdit: 'You have unsaved changes to this patient record.',
    patientCreate: 'You have unsaved patient details. Leave anyway?',
    // Claim forms
    claimEdit: 'You have unsaved changes to this claim.',
    // Button labels
    leaveAnyway: 'Leave anyway',
    keepEditing: 'Keep editing',
    switchAnyway: 'Switch anyway',
  },
  instantSurvey: {
    // Search and filters
    searchPlaceholder: 'Search instant assessments...',
    addButtonTitle: 'Add new instant assessment',

    // Status filters
    statusAll: 'All',
    statusDraft: 'Draft',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusArchived: 'Archived',

    // Status indicators (display text)
    statusLabelDraft: 'Draft',
    statusLabelActive: 'Active',
    statusLabelInactive: 'Inactive',
    statusLabelArchived: 'Archived',

    // Badge
    badgeNew: 'NEW',

    // Empty states
    emptyStateNoAssessments: 'No instant assessments created yet',
    emptyStateNotFound: 'No instant assessments found',

    // Submissions text
    submissions: 'submissions',
    submissionsWithLimit: '{{current}}/{{max}} submissions · {{completed}} completed',
    submissionsWithoutLimit: '{{current}} submissions · {{completed}} completed',

    // SurveyContent - Empty state
    emptyStateTitle: 'No Instant Assessment Selected',
    emptyStateDescription:
      'Select an instant assessment from the sidebar to view and edit its details, or create a new instant assessment to get started.',

    // SurveyContent - Main title
    mainTitle: 'Instant Assessment Configuration',
    mainSubtitle: '{{surveyType}} • Configure and customize your instant assessment',
    mainSubtitleNoType: 'Assessment Type Not Set • Configure and customize your instant assessment',

    // Section titles
    basicConfigTitle: 'Basic Configuration',
    linkQrCodeTitle: 'Generated Link & QR Code',
    submissionsTitle: 'Submissions Status',

    // Field labels
    fieldAssessmentName: 'Assessment Name',
    fieldAssessmentType: 'Assessment Type',
    fieldSurveyCode: 'Survey Code',
    fieldMaxSubmissions: 'Max Submissions',
    fieldAnonymous: 'Anonymous',

    // Field values
    valueUntitledAssessment: 'Untitled Assessment',
    valueTypeNotSpecified: 'Type not specified',
    valueNoCodeGenerated: 'No code generated',
    valueUnlimited: 'Unlimited',
    valueAllowed: 'Allowed',
    valueNotAllowed: 'Not Allowed',

    // Action tooltips
    editConfigurationTooltip: 'Edit configuration',

    // QR and Link sections
    sectionSurveyLink: 'Survey Link',
    sectionQrCode: 'QR Code',
    downloadQrAriaLabel: 'download QR code',
    shareHelper: 'Share this link with patients or print the QR code for on-site scanning.',

    // Submissions section
    submissionsLabel: 'Submissions',
    maxSubmissionsLabel: 'Max Submissions',
    createdByText: 'Created by {{creator}} on {{date}}',
    submissionsProgressCaption: '{{count}} of {{max}} responses collected',
    completedSubmissionsCaption: '{{count}} completed',
    ofLabel: 'of',
    noLimitLabel: 'No limit',

    // AddInstantSurveyModal
    editInstantAssessment: 'Edit Instant Assessment',
    createNewInstantAssessment: 'Create New Instant Assessment',
    basicInformation: 'Basic Information',
    assessmentType: 'Assessment Type',
    instantAssessmentName: 'Instant Assessment Name',
    instantAssessmentNamePlaceholder: 'Enter a descriptive name for this instant assessment',
    privacySettings: 'Privacy Settings',
    anonymousModeLabel: 'Anonymous Mode (No patient information collected)',
    patientInfoCollected:
      'Patient information (name, email, phone) will be collected within the survey',
    submissionsSectionTitle: 'Submissions',
    maximumSubmissions: 'Maximum Submissions',
    maxSubmissionsPlaceholder: 'Leave empty for unlimited submissions',
    autoCloseAfterLimit: 'The assessment will automatically close after reaching this limit',
    fixValidationErrors: 'Please fix the validation errors below',
    failedToCreateAssessment: 'Failed to {{action}} instant assessment',

    // DeleteConfirmationModal
    deleteInstantAssessment: 'Delete Instant Assessment',
    finalConfirmation: 'Final Confirmation',
    deleteInstantAssessmentQuestion: 'Delete Instant Assessment?',
    deleteConfirmMessage: 'Are you sure you want to permanently delete',
    deleteWarningMessage:
      'This action cannot be undone. All data associated with this assessment will be permanently deleted.',
    actionIrreversible: 'This action is irreversible',
    assessment: 'Assessment:',
    deleteAboutToMessage:
      'You are about to permanently delete this assessment configuration. This action cannot be undone and will remove all settings and configuration data.',
    deletePermanently: 'Delete Permanently',

    // StatusChangeConfirmationModal
    confirmAction: 'Confirm Action',
    confirm: 'Confirm',

    // Status change configs
    launchTitle: 'Launch Assessment',
    launchMessage: 'Are you sure you want to launch this assessment?',
    launchDescription:
      'Once launched, the assessment will become active and accessible to patients. You can deactivate it later if needed.',
    launchConfirm: 'Launch Assessment',
    deactivateTitle: 'Deactivate Assessment',
    deactivateMessage: 'Are you sure you want to deactivate this assessment?',
    deactivateDescription:
      "The assessment will be temporarily disabled and patients won't be able to access it. No data will be lost and you can reactivate it anytime.",
    deactivateConfirm: 'Deactivate',
    reactivateTitle: 'Reactivate Assessment',
    reactivateMessage: 'Are you sure you want to reactivate this assessment?',
    reactivateDescription:
      'The assessment will become active again and accessible to patients. All previous data will remain intact.',
    reactivateConfirm: 'Reactivate',
    archiveStep1Title: 'Archive Assessment',
    archiveStep1Message: 'Are you sure you want to archive this assessment?',
    archiveStep1Description:
      'The assessment will be moved to archive and hidden from the main list. All data will be preserved and you can unarchive it anytime.',
    archiveStep2Title: 'Final Confirmation',
    archiveStep2Message: 'This action will archive the assessment permanently',
    archiveStep2Description:
      'The assessment will be moved to the archive section and removed from the main view. While data is preserved, this action requires careful consideration.',
    archiveConfirm: 'Archive Assessment',
    unarchiveTitle: 'Unarchive Assessment',
    unarchiveMessage: 'Are you sure you want to unarchive this assessment?',
    unarchiveDescription:
      'The assessment will be restored to inactive status and shown in the main list. All data will remain intact.',
    unarchiveConfirm: 'Unarchive',
  },
  accountEdit: {
    // Page / footer
    unsavedOn: 'Unsaved changes on {{name}}',
    discard: 'Discard',
    readOnly: 'Read only',

    // Rail
    configure: 'Configure',
    needHelp: 'Need help?',
    needHelpText: 'Contact your Customer Success manager to change account-level permissions.',

    // Section rail — labels + hints
    identityLabel: 'Identity',
    identityHint: 'Name, type, contact',
    locationsLabel: 'Locations',
    locationsHint: 'Org & shipping addresses',
    featuresLabel: 'Features',
    featuresHint: 'Modules for this account',
    communicationsLabel: 'Communications',
    communicationsHint: 'Email & SMS templates',
    billingLabel: 'Billing',
    billingHint: 'CPT codes & Zoho Books',
    billingSectionDescription:
      'Claim-report codes and fees, and where this account’s invoices go in Zoho Books.',
    zohoSectionTitle: 'Zoho Books',
    zohoSuggested: 'Suggested',
    zohoSectionDescription:
      'Invoices for this account are created in Zoho Books for the linked customer and assigned to the selected salesperson.',
    zohoEnabled: 'Create invoices in Zoho Books',
    zohoEnabledDescription: 'When on, each claim report creates an invoice in Zoho Books.',
    zohoNoCustomerWarning: 'No Zoho customer linked: invoices will fail until one is selected',
    zohoCustomer: 'Zoho customer',
    zohoCustomerHint: 'Search by name, Account No or email.',
    zohoCustomerPlaceholder: 'Select a customer',
    zohoSearchPlaceholder: 'Name, Account No or email',
    zohoTypeToSearch: 'Type at least 2 characters to search',
    zohoCustomerNone: 'None (unlink)',
    zohoSearching: 'Searching Zoho Books…',
    zohoNoMatches: 'No matching Zoho customers',
    zohoAccountNo: 'Account No',
    zohoLinkedElsewhere: 'linked to another account',
    zohoSalesperson: 'Salesperson',
    zohoSalespersonNone: 'None',
    zohoInactive: 'inactive',
    zohoUnavailable: 'Zoho Books is unavailable. Try again later.',
    instantAssessmentsLabel: 'Instant assessments',
    instantAssessmentsHint: 'Public links & QR',

    // Identity section
    identitySectionDescription: 'Who runs this account and how we reach them.',
    accountType: 'Account type',
    selectAccountType: 'Select a tag',
    isDS: 'Distribution Sponsor',
    isDSDescription: 'DS accounts manage child accounts and unlock extra settings.',
    basicInfo: 'Basic info',
    businessName: 'Business name',
    tradeName: 'Entity / trade name',
    sameAsBusinessName: 'Same as business name',
    usingBusinessName: 'Using the business name',
    same: 'Same',
    headProvider: 'Head provider',
    contactName: 'Contact name',
    customId: 'Custom ID',
    customIdLockedHint: 'Cannot be changed while editing your own account',
    phone: 'Phone',
    fax: 'Fax',
    scheduledDelivery: 'Scheduled delivery',
    timeZone: 'Time zone',
    scheduleDeliveryTime: 'Daily delivery time',
    scheduleDeliveryTimeHint: 'Local to the time zone above',

    // Locations section
    locationsSectionDescription: 'Headquarters, shipping address, and any satellite locations.',
    headquartersAddress: 'Headquarters',
    sameAsHQ: 'Same as headquarters',
    shippingAddress: 'Shipping address',
    otherLocations: 'Other locations',
    locationName: 'Location name',
    streetAddress: 'Street address',
    suite: 'Suite / Unit',
    city: 'City',
    state: 'State',
    selectState: 'Select…',
    zipCode: 'ZIP',
    location: 'Location',
    addLocation: 'Add location',

    // Features section
    features: 'Features',
    featuresSectionDescription: 'Which product modules are turned on for this account.',
    enableOrders: 'Orders',
    enableOrdersDescription: 'Patients can be assigned individual orders.',
    enableOrdersAutomations: 'Order automations',
    enableOrdersAutomationsDescription: 'Automated follow-ups for orders that need action.',
    enableAllergiendResources: 'AllergiEnd documents',
    enableAllergiendResourcesDescription:
      'Show AllergiEnd educational resources in the patient portal.',
    enableImmunotherapyReport: 'Immunotherapy report',
    enableImmunotherapyReportDescription: 'Access the combined immunotherapy performance report.',
    enableClaimsManagement: 'Claims management',
    enableClaimsManagementDescription: 'Unlock the full claims module for this account.',
    intellyChartAssessments: 'Preventive Health Counseling assessments',
    intellyChartAssessmentsHelper:
      'Only the selected assessments create an Preventive Health Counseling claim. Choose from the assessments allowed for this account.',
    intellyChartAssessmentsEmpty:
      'No assessments selected. No Preventive Health Counseling claims will be created for this account.',
    intellyChartAssessmentsNoOptions:
      'Add assessments to the Allowed assessments list below first.',
    intellyChartAssessmentsRemoved:
      'Also removed from Preventive Health Counseling billing: {{titles}}.',
    intellyChartAssessmentsCount: '{{selected}} of {{total}} selected',
    intellyChartSelectAll: 'Select all',
    intellyChartClear: 'Clear',
    enablePrograms: 'Programs',
    enableProgramsDescription:
      'Enroll patients in multi-step programs built by your sponsor. Each user also needs Programs granted in their user settings.',
    enableProgramsSponsorDescription:
      'Always on for distribution sponsors. Grant Programs to each user in their user settings.',
    programs: 'Programs',
    panelUnappliedTitle: 'Unapplied changes',
    panelUnappliedMessage:
      'This list has changes that are not applied yet. Discard them, or keep editing.',
    programsHelper:
      'Turning a program on adds everything it needs to the lists below and locks it there. Removing a locked item turns the program off, after a confirmation.',
    programsEnabledCount: '{{enabled}} of {{total}} enabled',
    programsEmpty: 'No published programs are available to this account yet.',
    programOn: 'On',
    programName: 'Program',
    programIncludes: 'Includes',
    programOwnTemplate: 'Own template — always available',
    programIncludesSummary: '{{surveys}} assessments · {{resources}} resources · {{steps}} steps',
    programHintAssessments: 'Assessments',
    programHintResources: 'Resources',
    programHintAllowed: 'Allowed',
    programHintWillBeAdded: 'Will be added',
    usedBy: 'Used by programs',
    requiredByProgram: 'Required by a program. Click to remove anyway.',
    requiredByOwnProgram:
      "Required by this account's own program. Edit that program template to remove it.",
    allowedTableEmpty: 'Nothing allowed yet. Use the Add button to pick from the catalogue.',
    assessmentColumn: 'Assessment',
    resourceColumn: 'Resource',
    searchPrograms: 'Search programs',
    searchNoMatches: 'Nothing matches your search.',
    manage: 'Manage',
    manageNeedsModule: 'Turn this module on first.',
    programsCatalogueNeedsGrant: 'Program list unavailable',
    programsCatalogueNeedsGrantHint:
      'Your user does not have Programs on your own account. Ask an administrator to grant Programs in your user settings, then sign in again.',
    rowAllowedSummary: '{{allowed}} of {{total}} allowed',
    rowRequiredSummary: '{{count}} required by programs',
    filterAll: 'All {{count}}',
    filterAllowed: 'Allowed {{count}}',
    filterRequired: 'Required {{count}}',
    selectAllShown: 'Select or clear every row shown',
    tableLockHint:
      'locked rows are required by an enabled program; click a lock to remove anyway, you will be asked to confirm',
    neededByOff: 'Needed by {{program}} (off)',
    definitionsUnavailable:
      'The programs catalogue could not be loaded, so the allowed lists are read-only for now. Reload the page to try again.',
    usedByMore: 'More programs',
    allowedColumnHintAssessments:
      'Patients of this account can be sent this assessment. Untick to stop it being assigned; assessments already sent or in progress are not affected.',
    allowedColumnHintResources:
      'Patients of this account can be sent this resource. Untick to stop it being assigned; resources already sent are not affected.',
    automationColumnHint:
      "After a patient completes this assessment, QHS automatically sends the follow-up it has for this assessment type: educational resources and videos, follow-up assessments, or a lesson course, depending on the type and the patient's answers. Untick to stop new follow-ups; follow-ups already started for a patient run to the end.",
    intellyChartColumnHint:
      'When a provider accepts the results of this assessment, QHS creates a Preventive Health Counseling claim (CPT 99401) for it. Available while Claims management is on.',
    eVisitColumnHint:
      'When a provider accepts the results of this assessment, QHS creates an E-Visit claim (CPT 99422 or 99423) for it, at most once per patient in 30 days. Available while Claims management is on. The claim needs a resource the automation sends, so it has no effect while Automation is off for this assessment.',
    usedByHintAssessments:
      'Programs that send this assessment in one of their steps. While such a program is enabled for the account, the assessment cannot be removed from this list.',
    usedByHintResources:
      'Programs that send this resource in one of their steps. While such a program is enabled for the account, the resource cannot be removed from this list.',
    allowedColumn: 'Allowed',
    automationColumn: 'Automation',
    eVisitColumn: 'E-Visit',
    intellyChartColumn: 'Preventive Health Counseling',
    intellyChartNeedsClaims: 'Turn on Claims management first.',
    intellyChartNeedsClaimsColumn: 'Turn on {{module}} to use this column.',
    presets: 'Presets',
    presetsHint: 'Adds a usual set of assessments. Nothing already allowed is removed.',
    presetFullScreening: 'Full screening',
    presetHealthBehavioral: 'Health and behavioral',
    presetBehavioral: 'Behavioral only',
    presetAllAllowed: 'Already allowed',
    eVisitNeedsAutomation: 'Turn on Automation for this assessment first.',
    cptCodeOr: 'or',
    claimCptNeeded: 'Needs CPT {{code}} on this account.',
    claimCptMissingColumn: 'Needs CPT {{code}} on this account.',
    cptNeededTitle: 'Claim settings need these codes',
    cptNeededMissing: '{{column}} is billed under CPT {{code}}. Add the code below.',
    claimCptDialogTitle: 'This needs a CPT code',
    claimCptDialogMissing:
      '{{column}} is billed under CPT {{code}}, which this account does not have. Add the code in CPT codes, then come back and tick the assessments it applies to.',
    claimCptDialogMissingNoAccess:
      '{{column}} is billed under CPT {{code}}, which this account does not have. Ask your distribution sponsor to add the code.',
    openCptSection: 'Open CPT codes',
    ordersAutomationsNeedOrders: 'Turn on Orders first.',
    columnNeedsAllowed: 'Allow this assessment first.',
    pickerSearchAssessments: 'Search assessments',
    pickerSearchResources: 'Search resources',
    programNeedsAssessments: 'Turn on Enable assessments first: this program sends assessments.',
    programNeedsResources: 'Turn on Enable resources first: this program sends resources.',
    programAddedItems: 'Added to the allowed lists ({{count}}): {{items}}',
    programAddedNothing: 'Everything this program needs was already allowed.',
    moduleOffTitle: 'Turn off {{module}}?',
    moduleOffBodyOne: 'An enabled program depends on it and will be turned off for this account.',
    moduleOffBodyMany:
      '{{count}} enabled programs depend on it and will be turned off for this account.',
    moduleOffConfirmOne: 'Turn off and disable {{program}}',
    moduleOffConfirmMany: 'Turn off and disable {{count}} programs',
    removeDependencyTitle: 'Remove {{name}}?',
    removeDependencyBodyOne:
      'An enabled program sends this item. Removing it turns that program off for this account. Patients already enrolled keep their current program.',
    removeDependencyBodyMany:
      '{{count}} enabled programs send this item. Removing it turns those programs off for this account. Patients already enrolled keep their current program.',
    removeDependencyWillTurnOff: 'will be turned off',
    removeDependencyNote: 'Nothing is saved until you press Save changes on the account.',
    removeDependencyKeep: 'Keep it',
    removeDependencyConfirmOne: 'Remove and turn off {{program}}',
    removeDependencyConfirmMany: 'Remove and turn off {{count}} programs',
    enableBhiIntegration: 'BHI integration',
    enableBhiIntegrationDescription:
      'Send webhook notifications for this account (Behavioral Health Integration).',
    allowedAssessments: 'Allowed assessments',
    enableAssessments: 'Enable assessments',
    enableAssessmentsDescription: 'Patients can be sent invitations to complete assessments.',
    allowedAssessmentsHelper: 'Patients can complete any of the selected assessments.',
    searchAssessments: 'Search assessments',
    allowedResources: 'Allowed resources',
    enableResources: 'Enable resources',
    enableResourcesDescription: 'Patients see the selected educational resources.',
    allowedResourcesHelper: 'Only the selected resources show up in assignment menus.',
    searchResources: 'Search resources',

    // CPT section
    cptCodes: 'CPT codes',
    cptCodesSectionDescription:
      'Billable service codes and fees used for this account’s claim reports.',
    reportFormat: 'Claim report format',
    reportFormatField: 'Report format',
    selectFormat: 'Select a format',
    cptCodesList: 'Codes',
    cptCode: 'Code',
    cptFee: 'Fee (USD)',
    cptEmpty: 'No CPT codes yet. Add the first one using the row below.',
    cptAddHint: 'Add a new code →',
    cptCodePlaceholder: '99213',
    add: 'Add',
    remove: 'Remove',

    // Communications section
    communications: 'Communications',
    communicationsSectionDescription:
      'Templates used when the system emails or texts patients. Merge tags like {patientName} are preserved verbatim.',
    templates: 'templates',
    assessmentTemplates: 'Assessment templates',
    resourceTemplates: 'Resource templates',
    useDefault: 'Use default',
    usingDefault: 'Using default',
    customTemplate: 'Custom',
    topicAssessment: 'Assessment',
    topicResource: 'Resource',
    templateInvitationEmail: 'Email — invitation',
    templateInvitationSMS: 'SMS — invitation',
    templateReminderEmail: 'Email — reminder',
    templateReminderSMS: 'SMS — reminder',
    templateCompletionEmail: 'Email — completion',
    templateCompletionSMS: 'SMS — completion',

    // Instant assessments section
    instantAssessments: 'Instant assessments',
    instantAssessmentsSectionDescription:
      'One-tap assessments patients can launch without an invite. Saved individually via the legacy widget.',

    // Completeness tooltips
    completenessMissing: 'Required fields missing',
    completenessWarn: 'Recommended fields empty',
    completenessError: 'Has validation errors',

    // Dirty footer counter
    noChanges: 'No unsaved changes',
    changeSingular: 'unsaved change',
    changePlural: 'unsaved changes',
    across: 'across',
    sectionSingular: 'section',
    sectionPlural: 'sections',

    // Post-create banner
    justCreatedTitle: 'Account created. Next step: invite your team.',
    justCreatedSubtitle:
      "We've pre-filled the basics — finish configuring features here, then head to Users to add at least one person who can sign in.",
    goToUsers: 'Go to Users',

    // Delete flow
    deleteAccount: 'Delete account',
    deleteConfirmTitle: 'Delete {{name}}?',
    deleteConfirmMessage:
      'This will permanently remove the account and all associated patients, claims, and orders. This action cannot be undone.',
  },
  accountCreate: {
    title: 'New account',
    description:
      "We only need the essentials to get started — you'll configure the rest on the account page.",
    businessName: 'Business name',
    accountType: 'Account type',
    accountTypePlaceholder: 'Select one or more',
    phone: 'Phone',
    contactName: 'Contact name',
    timeZone: 'Time zone',
    helperText:
      "After creating the account, we'll take you straight to the account page so you can enable features, add other locations, and invite your first user.",
    stepCopy: 'Step 1 of 2 · then invite users',
    submitLabel: 'Create & configure',
    addressTitle: 'Headquarters address',
    addressHint: 'Used for shipping by default — you can split them later.',
    required: 'Required',
    isDS: 'Distribution Sponsor',
    isDSDescription: 'DS accounts manage child accounts and unlock extra settings.',
    isDSHint: "Can't be changed later",
  },
  instantAssessments: {
    backToAccount: 'Back to account',
  },
  surveyStatus: {
    invited: 'Invited',
    created: 'Pending',
    staled: 'Opened',
    inProgress: 'In progress',
    pendingReview: 'Pending review',
    partialProcessed: 'Partial',
    completed: 'Completed',
    processing: 'Processing',
    scheduled: 'Scheduled',
    eTransfer: 'Transferred',
    canceled: 'Canceled',
    noShow: 'No show',
  },
  providers: {
    // list columns
    colName: 'Name',
    colTitle: 'Title',
    colNpi: 'NPI',
    colLinked: 'Has Users',
    colDefault: 'Default',
    colCreated: 'Created',
    // cell values, row actions and badges
    linkedYes: 'Yes',
    linkedNo: 'No',
    // Default-column chips, one per context (wire `Surveys` -> "Assessments").
    // Right-aligned pill on the account's default provider inside a
    // picker, so a preselected field says why it chose that row.
    defaultTag: 'Default',
    defaultChipPdf: 'PDF',
    defaultChipClaims: 'Claims',
    defaultChipAssessments: 'Assessments',
    // Per-context set-default group (backend change 2026-08-12): group
    // head + one sub-item per context, labels shared with the
    // Default-column chips below.
    // The preposition lives in the group head ("Sort by ->" pattern):
    // each head + sub-item pair reads as a full phrase, e.g.
    // "Set as default for PDF".
    setDefaultGroup: 'Set as default for',
    // Reason tooltip on a disabled set-default sub-item; {{context}}
    // is the sub-item's own label (PDF / Claims / Assessments).
    alreadyDefaultFor: 'This provider is already the default for {{context}}',
    // Clear-default group: same per-context sub-item labels as the
    // set-default group, rendered only for contexts the row holds.
    clearDefaultGroup: 'Clear default for',
    uploadProvidersBtn: 'Upload Providers',
    // add dialog
    addProvider: 'Add Provider',
    howToAdd: 'How to add',
    providerDetails: 'Provider details',
    nameFromUser: 'Taken from the selected user',
    modeManualTitle: 'Enter details',
    modeManualSubtitle: 'Type the provider name, title and NPI.',
    modeLinkTitle: 'Link an account user',
    modeLinkSubtitle: 'Attach the provider to someone who already has a login.',
    accountUser: 'Account user',
    selectAccountUser: 'Select a user',
    searchUsers: 'Search users...',
    loadingUsers: 'Loading users...',
    alreadyLinked: 'already linked',
    linkOnlyViaPicker:
      'Typing a name does not link anyone. To link a provider to an account user, choose "Link an account user" above and pick them from the list.',
    providerAdded: 'Provider added.',
    userRequired: 'Select a user to link.',
    nameConflict: 'A provider with this name already exists on this account.',
    // edit dialog
    editProvider: 'Edit Provider',
    editName: 'Name',
    editTitle: 'Title',
    editNpi: 'NPI Number',
    providerUpdated: 'Provider updated.',
    nameRequired: 'Name is required.',
    titleRequired: 'Title is required.',
    npiRequired: 'NPI Number is required.',
    nameTooLong: 'Name must be 64 characters or less.',
    titleTooLong: 'Title must be 64 characters or less.',
    npiExactDigits: 'NPI Number must be exactly 10 digits.',
    // errors
    staleRow: 'This provider is no longer available. The list has been refreshed.',
    genericError: 'Something went wrong. Please try again.',
    // shared picker
    selectProvider: 'Select provider',
    noProvider: 'No provider',
  },
  programsDashboard: {
    common: {
      idPrefix: 'ID',
    },
    filters: {
      quickRangeLabel: 'Quick range',
      customRangeLabel: 'Custom range',
      applyPresetPlaceholder: 'Apply preset…',
      pickDatesPlaceholder: 'Pick dates',
      accountLabel: 'Account',
      accountStatusLabel: 'Account status',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      statusAll: 'All',
      presetPreviousMonth: 'Previous month',
      presetCurrentMonth: 'Current month',
      presetPreviousQuarter: 'Previous quarter',
      presetCurrentQuarter: 'Current quarter',
      presetYtd: 'Year to date (through today)',
      presetFullYear: 'Current year (full)',
      presetCustom: 'Custom',
      resetFilters: 'Reset filters',
    },
    export: {
      csv: 'Export CSV',
      xlsx: 'Export xlsx',
      pickDateRangeFirst: 'Pick a date range first.',
      downloaded: 'Export downloaded.',
      exportFailed: 'Export failed.',
    },
    compare: {
      dialogTitle: 'Compare periods',
      dialogSubtitle: 'Pick two date windows to compare enrollment activity side by side.',
      accountLabel: 'Accounts',
      currentLabel: 'Current',
      previousLabel: 'Previous',
      selectPeriod: 'Select period',
      quickPresets: 'Quick presets',
      presetPairs: {
        currentVsPreviousMonth: 'Current vs previous month',
        lastCompletedVsBefore: 'Last completed month vs the one before',
        currentVsPreviousQuarter: 'Current vs previous quarter',
        currentVsPreviousYear: 'Current vs previous year',
        ytdVsLastYear: 'Year to date vs last year',
        sameWindowLastYear: 'Current window vs same period last year',
      },
      // Own-namespace copies of CompareAccountPopover's chrome text
      // (values verbatim from assessmentPerformance.* — same UI, own
      // feature's i18n namespace, per the one-namespace-per-feature
      // convention PH's AccountPopover already follows).
      selectedAccountSingle: '1 selected',
      selectedAccountsCount: '{{count}} selected',
      accountPickerPlaceholder: 'Pick accounts to compare',
      accountPickerSearch: 'Search accounts by name…',
      accountPickerLoading: 'Loading accounts…',
      accountPickerNoResults: 'No accounts match this search.',
      accountPickerEmpty: 'No accounts available.',
      accountPickerLoadFailed: 'Could not load accounts. Close and reopen to try again.',
      metricColumn: 'Metric',
      changeColumn: 'Change',
      accountsSectionTitle: 'Accounts driving the change',
      accountsSectionHint: 'by active patients at period end',
      showAllAccounts: 'Show all {{count}} accounts',
      exportCsv: 'Export comparison CSV',
      ppSuffix: 'pp',
      predatesHistory: 'Comparison period predates available history.',
      loadFailed: 'Could not load the comparison. Adjust the periods and try again.',
    },
    exceptions: {
      rowLabel: 'Attention',
      noNewEnrollments: 'No new enrollments',
      declining: 'Declining',
      noActivePatients: 'No active patients',
      highCancellationRate: 'High cancellation rate',
      noActivity: 'No activity in period',
    },
    help: {
      buttonLabel: 'How this is computed',
      modalAriaLabel: 'How BHI Dashboard numbers are computed',
      genericTitle: 'How this is computed',
      gotItBtn: 'Got it',
      l1Title: 'BHI Dashboard — Portfolio',
      l1Subtitle: 'What each column and KPI on this page means, and how the backend computes it.',
      l2Title: 'BHI Dashboard — Account Detail',
      l2Subtitle:
        'What each KPI and column in the patient list means, and how the backend computes it.',
      sectionFieldsOnThisPage: 'Fields on this page',
      metaSource: 'Source',
      metaFormula: 'Formula',
      metaAnchor: 'Anchor',
      metaNotes: 'Notes',
    },
    l1: {
      viewAccountsTab: 'By account',
      viewInsuranceTab: 'By insurance',
      byInsuranceTableTitle: 'Reimbursement by Insurance',
      byInsuranceSubtitle:
        'Every CPT broken down by insurance payer, with one row per account under each payer — the same payer and CPT at different contracted rates, side by side.',
      groupAccountsSingular: '{{count}} account',
      groupAccountsPlural: '{{count}} accounts',
      groupAccountsPartial: '{{loaded}} of {{count}} accounts',
      pageTitle: 'BHI Dashboard',
      pageSubtitle:
        'Portfolio-level enrollment activity for the BHI program across your customer accounts. Chase net-change dips, cancellation spikes, and accounts without recent activity.',
      tableTitle: 'BHI Dashboard',
      backAriaLabel: 'Back to {{title}}',
      pickRange: 'Pick a date range',
      nonDs: {
        accountFallback: 'Your account',
        headlineOpeningActive: 'Opening Active',
        headlineNewEnrollments: 'New Enrollments',
        headlineCancellations: 'Cancellations',
        headlineClosingActive: 'Closing Active',
        opsNetChange: 'Net Δ',
        opsGrowthPercent: 'Growth %',
        opsCancellationRate: 'Cancellation %',
        opsLastNewEnrollment: 'Last enrollment',
        opsLastCancellation: 'Last cancellation',
        viewPatientListCta: 'View patient list',
      },
    },
    l2: {
      pageSubtitleWithAccount:
        'BHI enrollment activity for this account during the selected period.',
      tableTitle: 'Patients',
      periodLabel: 'Period',
    },
    history: {
      noHistoryYet: 'This account has no BHI enrollment history yet.',
      historyStartsOn:
        'BHI enrollment history starts on {{date}}. Numbers below reflect the available period only.',
    },
    kpis: {
      opening: 'Opening',
      newEnrollments: 'New',
      cancellations: 'Cancellations',
      netChange: 'Net Δ',
      closing: 'Closing',
      cancellationRate: 'Cancellation %',
      accountsWithActive: 'Accounts with active',
      accountsWithNew: 'Accounts with new',
      accountsWithCancellations: 'Accounts with cancellations',
    },
    columns: {
      businessName: 'Account',
      customIdentifier: 'Custom ID',
      accountStatus: 'Status',
      statusActive: 'Active',
      statusInactive: 'Inactive',
      opening: 'Opening Active',
      newEnrollments: 'New Enrollments',
      cancellations: 'Cancellations',
      netChange: 'Net Δ',
      closing: 'Closing Active',
      growthPercent: 'Growth %',
      cancellationRate: 'Cancellation %',
      lastNewEnrollment: 'Last Enrollment',
      lastCancellation: 'Last Cancellation',
      patientFirstName: 'First Name',
      patientLastName: 'Last Name',
      mrn: 'MRN',
      enrollmentDate: 'Enrollment Date',
      currentStatus: 'Status',
      patientStatusActive: 'Active',
      patientStatusCancelled: 'Cancelled',
      statusEffectiveDate: 'Status Effective',
      cancellationDate: 'Cancellation Date',
      lastBhiActivityDate: 'Last Activity',
    },
    patientStatus: {
      active: 'Active',
      cancelled: 'Cancelled',
    },
    dictionary: {
      openingActivePatients: {
        label: 'Opening Active',
        definition:
          "Patients enrolled in the BHI program and still active as of the period's start.",
        formula:
          'Count of patients whose latest enrollment event ≤ from and no cancellation event ≤ from.',
        source: 'BHI enrollment events table.',
        anchor: 'Period start (from).',
      },
      newEnrollments: {
        label: 'New Enrollments',
        definition: 'Number of patients newly enrolled in BHI during the selected period.',
        formula: 'Count of enrollment events with timestamp in [from, to].',
        source: 'BHI enrollment events table.',
        anchor: 'Event timestamp.',
      },
      cancellations: {
        label: 'Cancellations',
        definition: 'Number of BHI enrollments cancelled during the selected period.',
        formula: 'Count of cancellation events with timestamp in [from, to].',
        source: 'BHI cancellation events table.',
        anchor: 'Event timestamp.',
        gotchas:
          'Reason is not captured yet — every cancellation reads as a single "Cancelled" category.',
      },
      netChange: {
        label: 'Net Δ',
        definition: 'Change in active patient count over the period.',
        formula: 'newEnrollments − cancellations',
        source: 'Derived.',
        anchor: 'Same as inputs.',
      },
      closingActivePatients: {
        label: 'Closing Active',
        definition: "Patients active at the period's end.",
        formula: 'openingActivePatients + netChange',
        source: 'Derived.',
        anchor: 'Period end (to).',
      },
      growthPercent: {
        label: 'Growth %',
        definition: 'Growth of active patients over the period, relative to the opening count.',
        formula: '(netChange ÷ openingActivePatients) × 100',
        source: 'Derived.',
        anchor: 'Same as inputs.',
        gotchas: 'Rendered as "—" when openingActivePatients is 0.',
      },
      cancellationRate: {
        label: 'Cancellation %',
        definition: 'What share of the at-risk population cancelled in the period.',
        formula: '(cancellations ÷ (openingActivePatients + newEnrollments)) × 100',
        source: 'Derived.',
        anchor: 'Same as inputs.',
        gotchas: 'Rendered as "—" when the denominator is 0.',
      },
      lastNewEnrollment: {
        label: 'Last Enrollment',
        definition: 'Date of the most recent enrollment event.',
        formula: 'Max enrollment timestamp during the period.',
        source: 'BHI enrollment events table.',
        anchor: 'Event timestamp.',
      },
      lastCancellation: {
        label: 'Last Cancellation',
        definition: 'Date of the most recent cancellation event.',
        formula: 'Max cancellation timestamp during the period.',
        source: 'BHI cancellation events table.',
        anchor: 'Event timestamp.',
      },
      accountsWithActivePatients: {
        label: 'Accounts with active',
        definition:
          'How many customer accounts have at least one patient active at the period end.',
        formula: 'Count of accounts where closingActivePatients > 0.',
        source: 'Derived.',
        anchor: 'Period end (to).',
      },
      accountsWithNewEnrollments: {
        label: 'Accounts with new',
        definition: 'How many customer accounts had at least one new enrollment during the period.',
        formula: 'Count of accounts where newEnrollments > 0.',
        source: 'Derived.',
        anchor: 'Event timestamps.',
      },
      accountsWithCancellations: {
        label: 'Accounts with cancellations',
        definition: 'How many customer accounts had at least one cancellation during the period.',
        formula: 'Count of accounts where cancellations > 0.',
        source: 'Derived.',
        anchor: 'Event timestamps.',
      },
      accountsInScope: {
        label: 'Accounts in scope',
        definition:
          'Total customer accounts the current user is permitted to see, regardless of activity.',
        formula: 'Count of permitted accounts.',
        source: 'Account permission set.',
        anchor: 'Right now.',
      },
      earliestEventTimestamp: {
        label: 'Earliest event',
        definition: 'The earliest BHI enrollment event known for any account in scope.',
        formula: 'Min event timestamp across all events in scope.',
        source: 'BHI events tables.',
        anchor: 'Event timestamp.',
        gotchas:
          'null when the account has no BHI history yet — the history banner then reads "no history yet".',
      },
      patientFirstName: {
        label: 'First Name',
        definition: 'Patient given name as recorded in the demographic record.',
        formula: 'Direct field.',
        source: 'Patient demographics.',
      },
      patientLastName: {
        label: 'Last Name',
        definition: 'Patient family name as recorded in the demographic record.',
        formula: 'Direct field.',
        source: 'Patient demographics.',
      },
      mrn: {
        label: 'MRN',
        definition: 'Medical Record Number.',
        formula: 'Direct field.',
        source: 'Patient demographics.',
      },
      enrollmentDate: {
        label: 'Enrollment Date',
        definition: 'Date the patient was enrolled in the BHI program.',
        formula: 'Timestamp of the initial enrollment event.',
        source: 'BHI enrollment events.',
      },
      currentStatus: {
        label: 'Status',
        definition: 'Whether this patient is currently active in BHI or has been cancelled.',
        formula: 'Latest enrolled event ≥ latest cancelled → active, else cancelled.',
        source: 'BHI events table (last-event-wins).',
        anchor: 'Right now.',
      },
      statusEffectiveDate: {
        label: 'Status Effective',
        definition: 'Timestamp of the event that established the current status.',
        formula: 'Max(latest enrolled, latest cancelled).',
        source: 'BHI events.',
      },
      cancellationDate: {
        label: 'Cancellation Date',
        definition: 'Date of the latest cancellation event, if any.',
        formula: 'Max cancellation timestamp.',
        source: 'BHI cancellation events.',
        gotchas: 'Null for patients who were never cancelled.',
      },
      lastBhiActivityDate: {
        label: 'Last Activity',
        definition:
          'Most recent BHI-related activity for this patient (enrollment, cancellation, or program touchpoint).',
        formula: 'Max event timestamp for this patient across the BHI event tables.',
        source: 'BHI events.',
      },
      compareDeltas: {
        label: 'Comparison deltas',
        definition:
          'Comparison report between two freely chosen date windows, broken down per headline metric.',
        formula:
          'delta = current − baseline. Previous period: the window shifted back by its own calendar length. Same period last year: identical dates minus one year. Change cells are colored by metric direction: deterioration red, improvement green.',
        source: 'Two responses of the same summary endpoints; computed on the client.',
        anchor: 'Both windows resolved at request time.',
        gotchas:
          'Deltas are suppressed when the comparison window starts before the earliest known BHI event, and render as "—" when either side is missing.',
      },
      l1DerivedCancellationRate: {
        label: 'Cancellation % (portfolio)',
        definition:
          'Portfolio-level cancellation rate shown in the Compare periods report. The portfolio summary carries no rate of its own, so it is derived on the client.',
        formula: 'cancellations ÷ (openingActivePatients + newEnrollments) × 100',
        source: 'Derived from the summary aggregates.',
        gotchas: 'Rendered as "—" when the denominator is 0.',
      },
      exceptionNoNewEnrollments: {
        label: 'No new enrollments',
        definition: 'Accounts with zero new BHI enrollments in the selected period.',
        formula: 'newEnrollments === 0',
        source:
          'Server-side filter — the summary request carries the preset id in its exception parameter.',
      },
      exceptionDeclining: {
        label: 'Declining',
        definition:
          'Accounts whose active patient count shrank over the period (more cancellations than new enrollments).',
        formula: 'netChange < 0',
        source:
          'Server-side filter — the summary request carries the preset id in its exception parameter.',
      },
      exceptionNoActivePatients: {
        label: 'No active patients',
        definition: 'Accounts with nobody active in BHI at the period end.',
        formula: 'closingActivePatients === 0',
        source:
          'Server-side filter — the summary request carries the preset id in its exception parameter.',
      },
      exceptionHighCancellationRate: {
        label: 'High cancellation rate',
        definition: 'Accounts whose cancellation rate meets or exceeds the alert threshold.',
        formula: 'cancellationRate ≥ 20',
        source:
          'Server-side filter — the summary request carries the preset id in its exception parameter.',
        gotchas:
          'The dashboard sends threshold 20 explicitly (the server default is also 20) and the server echoes the applied value back as cancellationRateThreshold. Making it configurable per account is a planned follow-up.',
      },
      exceptionNoActivity: {
        label: 'No activity in period',
        definition: 'Accounts with no enrollment movement at all during the period.',
        formula: 'newEnrollments === 0 AND cancellations === 0 AND netChange === 0',
        source:
          'Server-side filter — the summary request carries the preset id in its exception parameter.',
      },
    },
  },
  // Patient dashboard Overview tab. Rows are produced as data by
  // `widgets/patient-overview/lib/needsAttention`; the copy that turns a
  // row into a sentence lives here. `*Many` keys exist because rows
  // collapse per kind and these catalogues are read as plain objects
  // from redux, so i18next pluralization does not apply.
  patientOverview: {
    needsAttention: 'Needs attention',
    needsAttentionEmpty: 'Nothing needs attention for this patient.',
    loadFailed: "Some of this patient's records could not be loaded.",

    // Every `*Detail` template has a `*NoDate` twin for the rows whose
    // timestamp can be absent. Leaving the placeholder to resolve to an
    // empty string produces "completed ." and "Raised  and still open" —
    // the sentence has to change, not just lose a word.
    alert: 'Imminent risk alert not acknowledged',
    alertMany: '{{count}} imminent risk alerts not acknowledged',
    alertDetail: 'Raised {{age}} and still open.',
    alertDetailNoDate: 'Still open.',
    alertAction: 'Review alerts',

    declinedAssessment: 'Patient declined an assessment',
    declinedAssessmentMany: 'Patient declined {{count}} assessments',
    declinedAssessmentDetail: '{{subject}}, {{age}}. Nothing further will be sent for it.',
    declinedAssessmentDetailNoDate: '{{subject}}. Nothing further will be sent for it.',
    declinedAssessmentAction: 'Open assessments',

    awaitingReview: 'Report waiting for a provider',
    awaitingReviewMany: '{{count}} reports waiting for a provider',
    awaitingReviewDetail: '{{subject}} completed {{age}}. Results have not been accepted.',
    awaitingReviewDetailNoDate: '{{subject}} is complete. Results have not been accepted.',
    // Two labels for one row: the collapsed form leads to the filtered
    // assessments list, not to a report. `opensSingleReport` picks.
    awaitingReviewAction: 'Open report',
    awaitingReviewActionMany: 'Open assessments',

    unopenedInvitation: 'Assessment invitation not opened',
    unopenedInvitationMany: '{{count}} assessment invitations not opened',
    unopenedInvitationDetail: '{{subject}} sent {{age}}. The patient has not opened the link.',
    unopenedInvitationDetailNoDate: '{{subject}}. The patient has not opened the link.',
    unopenedInvitationAction: 'Open assessments',

    abandonedAssessment: 'Assessment started but not finished',
    abandonedAssessmentMany: '{{count}} assessments started but not finished',
    abandonedAssessmentDetail: '{{subject}} sent {{age}}. The patient opened it and stopped.',
    abandonedAssessmentDetailNoDate: '{{subject}}. The patient opened it and stopped.',
    abandonedAssessmentAction: 'Open assessments',

    unopenedResource: 'Resource not opened',
    unopenedResourceMany: '{{count}} resources not opened',
    unopenedResourceDetail: '{{subject}} sent {{age}}.',
    unopenedResourceDetailNoDate: '{{subject}} has not been opened.',
    unopenedResourceAction: 'Open resources',

    overdueOrder: 'Order past its delivery date',
    overdueOrderMany: '{{count}} orders past their delivery date',
    overdueOrderDetail: 'Expected {{date}}, {{late}}. No delivery recorded.',
    overdueOrderDetailNoDate: 'Expected {{date}}. No delivery recorded.',
    overdueOrderAction: 'Open orders',

    stalledStep: 'Program stopped moving',
    stalledStepDetail: '{{subject}} is waiting on a step that should already have moved on.',
    stalledStepAction: 'Open programs',

    failedJourney: 'Program failed',
    failedJourneyDetail: '{{subject}} stopped. {{reason}}',
    failedJourneyAction: 'Open programs',

    failedUpload: 'Report did not reach the EHR',
    failedUploadMany: '{{count}} reports did not reach the EHR',
    failedUploadDetail: '{{subject}}, {{age}}. {{reason}}',
    failedUploadDetailNoDate: '{{subject}}. {{reason}}',
    // No re-upload operation exists in the API, so the row leads to the
    // record rather than promising a retry the product cannot perform.
    failedUploadAction: 'Open assessments',

    // Stands in for a backend reason that is absent, so a sentence built
    // around one never trails off.
    reasonUnknown: 'No reason was recorded.',

    unreachable: 'No way to reach this patient',
    unreachableDetail: 'There is no email or phone on file, so invitations will not be sent.',
    unreachableOneChannel: 'Only one way to reach this patient',
    unreachableSmsOff: 'Text messages are off. Email is the only channel on file.',
    unreachableEmailOff: 'Email is off. Text message is the only channel on file.',
    unreachableAction: 'Open record',

    engagementPaused: 'Patient engagement is paused',
    engagementPausedDetail:
      'Paused {{age}}. Nothing is being sent, so assessments and resources will not move.',
    engagementPausedWithReason:
      'Paused {{age}}: {{reason}}. Nothing is being sent, so assessments and resources will not move.',
    engagementPausedDetailNoDate:
      'Nothing is being sent, so assessments and resources will not move.',
    engagementPausedWithReasonNoDate:
      'Paused: {{reason}}. Nothing is being sent, so assessments and resources will not move.',
    // No action of its own: the Resume button sits in the patient hero
    // directly above this block, and offering a second one here would
    // put the same irreversible switch in two places on one screen.

    ageToday: 'today',
    ageYesterday: 'yesterday',
    ageDays: '{{count}} days ago',
    lateOneDay: '1 day late',
    lateDays: '{{count}} days late',

    clinicalSnapshot: 'Clinical snapshot',
    firstReading: 'First reading',
    noChange: 'No change',
    wasValue: 'was {{value}}',
    riskNeedsAttention: 'Needs attention',
    riskMonitor: 'Monitor',
    riskClear: 'No risks flagged',
    scoredOn: 'Scored {{date}}',

    // "Not scored" and "scored and clean" are different findings, and
    // only the second is "No risks flagged". Most assessment types have
    // no risk scoring at all, so this is the ordinary case rather than
    // an error, and the block says so instead of vanishing.
    riskNotScored: '{{subject}} is complete, but this assessment type is not risk-scored.',
    riskNoAssessment: 'This patient has not completed an assessment yet.',
    riskThisAssessment: 'The latest assessment',

    timeline: 'Patient timeline',
    timelineEmpty: 'Nothing has happened on this patient yet.',
    timelineViewAll: 'View full timeline',
    timelineSubtitle: 'Every recorded event, newest first.',
    // The timeline shows what happened to records. The system keeps no
    // action log, so it cannot say who did it — stated in the UI rather
    // than left for a reader to wonder about.
    timelineCaveat:
      'Shows what happened to records, not who did it. Edits to the patient card are not recorded.',

    // Event labels. The backend sends the record's own name as `title`;
    // these name what happened to it.
    eventAssessmentOrdered: 'Assessment created',
    eventAssessmentInvited: 'Invitation sent',
    eventAssessmentOpened: 'Assessment opened',
    eventAssessmentCompleted: 'Assessment completed',
    eventAssessmentAccepted: 'Results accepted by a provider',
    eventAssessmentUploadedToEhr: 'Report uploaded to the EHR',
    eventAssessmentCanceled: 'Assessment canceled',
    eventAssessmentNoShow: 'Marked as a no-show',
    eventResourceSent: 'Resource sent',
    eventResourceEngaged: 'Resource opened',
    eventOrderPlaced: 'Order placed',
    eventProgramStarted: 'Program started',
    eventProgramStepCompleted: 'Program step finished',
    eventProgramPaused: 'Program paused',
    eventProgramCompleted: 'Program completed',
    eventEngagementChanged: 'Patient engagement changed',
    eventBhiEnrolled: 'Enrolled in BHI',
    eventBhiCancelled: 'BHI enrolment cancelled',

    // The same events as a badge word beside the record's name. The
    // assessment ones use the wording of the Assessments table so the
    // same state is never called two things in one product: "Opened"
    // for `staled`, "E-Transfer" for the EHR upload, "No Show" rather
    // than "declined".
    eventStatusAssessmentOrdered: 'Created',
    eventStatusAssessmentInvited: 'Invited',
    eventStatusAssessmentOpened: 'Opened',
    eventStatusAssessmentCompleted: 'Completed',
    eventStatusAssessmentAccepted: 'Accepted',
    eventStatusAssessmentUploadedToEhr: 'E-Transfer',
    eventStatusAssessmentCanceled: 'Canceled',
    eventStatusAssessmentNoShow: 'No Show',
    eventStatusResourceSent: 'Sent',
    eventStatusResourceEngaged: 'Opened',
    eventStatusOrderPlaced: 'Placed',
    eventStatusProgramStarted: 'Started',
    eventStatusProgramStepCompleted: 'Step finished',
    eventStatusProgramPaused: 'Paused',
    eventStatusProgramCompleted: 'Completed',
    eventStatusEngagementChanged: 'Changed',
    eventStatusBhiEnrolled: 'Enrolled',
    eventStatusBhiCancelled: 'Cancelled',

    // Chip labels. Coarser than the event types on purpose — the
    // question is "show me the assessments", not "show me the ones that
    // were invited".
    eventGroupAssessment: 'Assessments',
    eventGroupResource: 'Resources',
    eventGroupOrder: 'Orders',
    eventGroupProgram: 'Programs',
    eventGroupEngagement: 'Engagement',
    eventGroupBhi: 'BHI',
    eventGroupOther: 'Other',

    bhi: 'Behavioral Health Integration',
    bhiActive: 'Enrolled',
    bhiCancelled: 'Cancelled',
    bhiEnrolledSince: 'Enrolled {{date}}',
    bhiCancelledOn: 'Cancelled {{date}}',
    bhiNoDate: 'No date recorded',
    bhiNoHistory: 'From the patient record. No enrolment events on file, so there are no dates.',
    bhiLastActivity: 'Last activity {{date}}',
    bhiNoActivity: 'No activity recorded',
    bhiReason: 'Reason',
    // Shown when the event stream and the flag on the patient record
    // disagree. Deliberately plain: it is a data problem, and the page
    // says so rather than choosing a side silently.
    bhiMismatch:
      'The enrolment events and the flag on the patient record disagree. The dates below come from the events.',

    // The card that holds contact, programs, BHI and assessment
    // history as sections. "Record" rather than "Patient" alone, which
    // would say nothing on a page that is already about one patient.
    patientRecord: 'Patient record',
    contactAndCare: 'Contact and care',
    activeProgram: 'Active program',
    noActiveProgram: 'This patient is not enrolled in a program.',
    channelEmail: 'Email',
    channelSms: 'Text message',
    channelOptedOut: 'Opted out',
    insuranceFromAssessment: 'From the assessment of {{date}}',
    programStep: 'Step {{current}} of {{total}}',
  },
  journeys: {
    patientJourneysTab: 'Patient Programs',
    journeyProgramsTab: 'Program Templates',
    // list
    colAccount: 'Account',
    colPatient: 'Patient',
    colProgram: 'Template',
    colStatus: 'Status',
    colStarted: 'Started',
    colCompleted: 'Completed',
    filterStatus: 'Status',
    filterProgram: 'Template',
    allStatuses: 'All statuses',
    allPrograms: 'All templates',
    listEmpty: 'No programs yet. Start one from a published template.',
    noPatientsFound: 'No patients found',
    searchingPatients: 'Searching…',
    searchFirstName: 'First name',
    searchLastName: 'Last name',
    searchMrn: 'MRN',
    colMrn: 'MRN',
    colDob: 'Date of birth',
    // Start program panel (patient dashboard and Programs page)
    startStepPatient: 'Patient',
    startStepChoose: 'Choose',
    startStepReview: 'Review',
    startChoosePatientTitle: 'Choose a patient',
    startChooseProgramTitle: 'Choose a program',
    startReviewTitle: 'Review and start',
    startChooseProgramSubtitle: 'Pick the program the patient will follow.',
    startReviewSubtitle: 'Check the program and its steps, then start it.',
    startSearchPrograms: 'Search programs',
    startProgramsLabel: 'programs',
    startStepsCount: '{{count}} steps',
    startOneStep: '1 step',
    startChange: 'Change',
    startChooseHint: 'Selecting a program takes you to the review step.',
    startNoPrograms: 'No published programs are available to this account yet.',
    startJourney: 'Start Program',
    // lifecycle labels
    running: 'Running',
    paused: 'Paused',
    completed: 'Completed',
    failed: 'Failed',
    // step statuses
    stepPending: 'Pending',
    stepWaiting: 'Waiting',
    stepActive: 'Active',
    stepCompleted: 'Completed',
    stepSkipped: 'Skipped',
    stepFailed: 'Failed',
    stepTimedOut: 'Timed out',
    // start dialog
    startDialogTitle: 'Start a Program',
    startDialogSubtitle: 'The first step is sent to the patient immediately.',
    patientLabel: 'Patient',
    programLabel: 'Template',
    startBtn: 'Start',
    started: 'Program started — the first step was sent to the patient.',
    // drawer
    progressLabel: 'Progress',
    currentStepLabel: 'Current step',
    openAsset: 'Open {{assetType}}',
    expiresIn: 'Times out {{date}}',
    waitingCopy: 'Waiting for the patient to complete this step.',
    scheduledCopy: 'Scheduled: next step will be sent on {{date}}.',
    scheduledStep: 'Sends {{date}}',
    failedCopy: 'This program failed and cannot continue. Contact support if you need it restored.',
    pausedCopy: 'This program is paused.',
    completedCopy: 'This program is completed.',
    pause: 'Pause',
    resume: 'Resume',
    skipStep: 'Skip Step',
    retryStep: 'Retry Step',
    reasonLabel: 'Reason (optional)',
    confirmBtn: 'Confirm',
    pauseConfirmTitle: 'Pause this program?',
    pauseConfirmBody: 'The current step timer is cancelled until you resume.',
    skipConfirmTitle: 'Skip the current step?',
    skipConfirmBody: 'The program advances along the default path. This cannot be undone.',
    retryConfirmTitle: 'Retry the current step?',
    retryConfirmBody: 'The step action is sent again. The patient may receive a new copy.',
    retryNewInstance: 'A new instance was sent to the patient.',
    // programs tab
    colName: 'Name',
    colVersion: 'Version',
    colSource: 'Source',
    colSteps: 'Steps',
    sourceGlobal: 'Global',
    sourceAccount: 'This account',
    statusDraft: 'Draft',
    statusPublished: 'Published',
    statusArchived: 'Archived',
    draftNotOfferable: 'Publish it to offer it to accounts and start patients on it.',
    createProgram: 'Create Template',
    seedMetabolic: 'Set up Metabolic Lessons',
    seedDone: 'Metabolic Lessons template is ready. Publish it to start programs.',
    edit: 'Edit',
    view: 'View',
    publish: 'Publish',
    publishConfirmTitle: 'Publish this template?',
    publishConfirmBody:
      'Published templates are locked and can no longer be edited. Patients can then be enrolled.',
    published: 'Template published.',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete this template?',
    deleteConfirmBody: 'The draft and its steps are removed permanently. This cannot be undone.',
    deleted: 'Template deleted.',
    deleteOnlyDrafts:
      'Only a draft can be deleted. Published templates may already have programs running against them.',
    deleteNotOwned: 'This template belongs to another account and cannot be deleted here.',
    deleteNotDraft: 'Only a draft can be deleted. This template has already been published.',
    deleteHasJourneys:
      'This template cannot be deleted: programs have been started from it. That stays true even after those programs finish.',
    programsEmpty: 'No templates yet. Create one or set up Metabolic Lessons.',
    // builder
    backToPrograms: 'Back to Program Templates',
    builderSubtitle:
      'Define the sequence of steps the patient walks through. Each step sends an assessment, resource or video and can wait for its completion.',
    stepsSectionTitle: 'Steps',
    stepsSectionSubtitle:
      'Steps run in order, top to bottom. Each step says when it is sent, what it sends and whether the program waits for the patient before moving on.',
    builderCreateTitle: 'Create Program Template',
    builderEditTitle: 'Edit Program Template',
    builderViewTitle: 'Program Template',
    programDescriptionLabel: 'Description',
    programDescriptionHelper:
      'Optional. Shown to staff wherever the program is listed and when they start it for a patient. {{count}} of {{max}} characters.',
    programDescriptionTooLong: 'The description can be up to {{max}} characters.',
    programNameLabel: 'Template name',
    stepNameLabel: 'Step name',
    actionLabel: 'Action',
    actionSendSurvey: 'Send Assessment',
    actionSendVideo: 'Send Video',
    actionSendAudio: 'Send Audio',
    actionSendArticle: 'Send Article',
    // Program panel, step rows: the column caption over the one badge
    // (what the patient did with the item), the badge for a sent
    // resource / video, the engine's "waiting" as a plain phrase, and
    // the kind of each step's item.
    stepsPatientColumn: 'Patient',
    stepSent: 'Sent',
    stepWaitingForPatient: 'Waiting for the patient',
    stepKindVideo: 'Video',
    stepKindAudio: 'Audio',
    stepKindArticle: 'Article',
    assetSurveyLabel: 'Assessment',
    assetResourceLabel: 'Resource',
    // Step card. Each step reads as three sentences, When / Send / Then,
    // and the collapsed head repeats them in one line.
    templateSectionTitle: 'Template details',
    templateSectionDesc: 'The name and description staff see wherever the template is listed.',
    stepFallbackName: 'Step {{n}}',
    collapseStep: 'Collapse step',
    expandStep: 'Expand step',
    whenLabel: 'When',
    sendLabel: 'Send',
    thenLabel: 'Then',
    whenRightAway: 'Right away',
    whenAfterDelay: 'After a delay',
    whenProgramStarts: 'when the program starts',
    whenPrevFinishes: 'as soon as the previous step finishes',
    whenAfterPrev: 'after the previous step finishes',
    whenAfterStart: 'after the program starts',
    unitDays: 'days',
    unitHours: 'hours',
    thenNext: 'Go to the next step',
    thenWait: 'Wait for completion',
    thenNextHint: 'The next step is sent as soon as this one is.',
    thenWithin: 'If not completed within',
    thenWaitHint:
      'The patient has {{duration}} to complete it; after that the program will {{outcome}}.',
    thenWaitNoLimitHint:
      'No time limit: the program waits until the patient completes this step. Set days or hours to add one.',
    onTimeoutSkip: 'skip this step',
    onTimeoutFail: 'fail the program',
    onTimeoutEscalate: 'escalate',
    resourceWaitHint:
      'Any resource engagement by this patient advances this step — asset-specific matching is not available for resources yet.',
    // Collapsed head: "Assessment: Weekly Check-In · sent 7 days after the
    // previous step · waits up to 3 days, then skip this step".
    summaryNoAsset: 'no item chosen',
    summaryStart: 'sent when the program starts',
    summaryRightAway: 'sent right after the previous step',
    summaryAfterDelay: 'sent {{duration}} after the previous step',
    summaryAfterStart: 'sent {{duration}} after the program starts',
    summaryNext: 'next step follows at once',
    summaryWait: 'waits for completion',
    summaryWaitLimit: 'waits up to {{duration}}, then {{outcome}}',
    // Timeline rail: the day each step is reached and what sits between
    // two steps.
    dayLabel: 'Day',
    dayStartLabel: 'start',
    gapRightAway: 'right away',
    gapAfterFinishes: 'as soon as step {{n}} finishes',
    gapWaitAfter: 'after step {{n}} finishes, wait {{duration}}',
    lengthSameDay: 'all on the first day',
    lengthOpen: 'length set by the patient',
    lengthDays: 'about {{count}} days',
    lengthAtLeastDays: 'at least {{count}} days',
    durationDay: '1 day',
    durationDays: '{{count}} days',
    durationHour: '1 hour',
    durationHours: '{{count}} hours',
    durationShortDays: '{{count}}d',
    durationShortHours: '{{count}}h',
    sendAfterTooShort: 'A delay is at least 1 hour.',
    sendAfterTooLong: 'A delay is at most 365 days.',
    sendAfterInvalid: 'Check the step delays: at least 1 hour, at most 365 days.',
    addStep: 'Add step',
    removeStep: 'Remove step',
    moveUp: 'Move up',
    moveDown: 'Move down',
    createProgramBtn: 'Create Template',
    saveChanges: 'Save Changes',
    draftSaved: 'Draft saved.',
    notLinearWarning:
      'This template uses branching and can only be viewed here. Edit it via the API.',
    atLeastOneStep: 'Add at least one step.',
    fieldsRequired: 'Every step needs a name and an asset.',
    // errors (mapped via getJourneyErrorKey)
    alreadyEnrolled: 'This patient is already enrolled in this program.',
    programNotAvailable: 'This template is not available to start.',
    programLocked: "This template can't be edited — published templates are locked.",
    programInvalid: 'The template failed validation. Check the steps and try again.',
    programNotFound: 'Template not found.',
    actionNotAllowed: 'This action is not available in the current program state.',
    viewAssessmentReport: 'View assessment report',
    journeyNotFound: 'Program not found.',
    concurrentChange: 'The program changed in the background. The view has been refreshed.',
    genericError: 'Something went wrong. Please try again.',
  },
  // Decline-reason dialog for the assessments row action (backend
  // Assessment Decline Workflow). Reason labels are DISPLAY text; the
  // wire reasonCode is the backend's English StringValue and lives in
  // @features/toggle-no-show/model/declineReasons.js — do not localize
  // the wire values.
  assessmentDecline: {
    title: 'Decline Assessment',
    subtitle: 'Select the reason the patient declined this assessment.',
    reasonDeclinedToday: 'Declined today',
    reasonNoTime: 'No time',
    reasonTooFrequent: 'Assessments are too frequent',
    reasonNotRelevant: 'Assessment not relevant',
    reasonPrivacyConcerns: 'Privacy concerns',
    reasonPermanentRemoval: 'Patient requested permanent removal from QHS communications',
    reasonOther: 'Other',
    managerOnlyHint: 'Requires manager permission',
    otherLabel: 'Describe the reason',
    otherHint: 'Between 3 and 500 characters.',
    reasonRequired: 'Select a decline reason.',
    confirmBtn: 'Decline',
  },
  claimsManager: {
    common: {
      activeBadge: 'Active',
      unmappedTitle: 'Missing from ISP config: {{codes}}.',
      unmappedCptSingular: '{{count}} unmapped CPT',
      unmappedCptPlural: '{{count}} unmapped CPTs',
      idPrefix: 'ID',
      dash: '—',
    },
    filters: {
      quickRangeLabel: 'Quick range',
      customRangeLabel: 'Custom range',
      presetPreviousMonth: 'Previous month',
      presetCurrentMonth: 'Current month',
      presetPreviousQuarter: 'Previous quarter',
      presetCurrentQuarter: 'Current quarter',
      presetLast90Days: 'Last 90 days',
      presetYtd: 'Year to date',
      presetCustom: 'Custom',
      applyPresetPlaceholder: 'Apply preset…',
      pickDatesPlaceholder: 'Pick dates',
      cptLabel: 'CPT codes',
      cptAllPlaceholder: 'All CPTs',
      cptSearchPlaceholder: 'Search CPT codes',
      cptSelectedCount: '{{count}} selected',
      cptNoResults: 'No CPT codes found',
    },
    export: {
      csvBtn: 'Export CSV',
      xlsxBtn: 'Export xlsx',
    },
    help: {
      buttonLabel: 'How this is computed',
      modalAriaLabel: 'How Claims Manager numbers are computed',
      genericTitle: 'How this is computed',
      gotItBtn: 'Got it',
      l1Title: 'Claims Manager — Portfolio',
      l1Subtitle: 'What each column and KPI on this page means, and how the backend computes it.',
      l2Title: 'Claims Manager — Account Detail',
      l2Subtitle:
        'What each KPI and CPT-Mix column on this page means, and how the backend computes it.',
      l3Title: 'Claims Manager — CPT Detail',
      l3Subtitle: 'What each column and KPI on this page means, and how the backend computes it.',
      sectionGlobalConventions: 'Global conventions',
      sectionAttentionBadges: 'Attention badges',
      sectionFieldsOnThisPage: 'Fields on this page',
      sectionAlsoWorthKnowing: 'Also worth knowing',
      metaSource: 'Source',
      metaFormula: 'Formula',
      metaAnchor: 'Anchor',
      metaNotes: 'Notes',
    },
    globalConventions: {
      period: {
        label: 'Period filter',
        text: 'Inclusive calendar days, interpreted as UTC — [from 00:00 UTC, to 23:59:59 UTC].',
      },
      inScope: {
        label: '"In scope" account',
        text: 'Active (not deleted, not disabled) AND claims-management enabled AND inside your permitted account set.',
      },
      softDeleted: {
        label: 'Soft-deleted rows',
        text: 'Excluded everywhere — claims, reportables, reports.',
      },
      cptFilter: {
        label: 'CPT filter',
        text: 'When a CPT filter is applied, every number recalculates to include only the selected codes. Data-integrity checks are the one exception (they ignore the filter — see the attention column).',
      },
      timeDrift: {
        label: 'Payment figures keep updating',
        text: "Counts and dollars driven by insurance payments reflect the latest known status for work done in the period — they keep moving as payments post. Re-running July's report in October will show higher paid counts than it did on Aug 1. This is normal.",
      },
    },
    badges: {
      unmappedBadge: {
        label: 'Orange circle with a number',
        text: "Number of CPT codes on this account's claims that have no price in its ISP configuration. Setup issue for ops (add the missing prices); while > 0 the dollar totals for this account are understated.",
      },
      attentionBadge: {
        label: 'Red circle with "!"',
        text: 'One or more data-integrity probes tripped — paid CPT missing reportable, duplicate rows, orphan reportables, or a claim-report referencing a missing reportable. Hover the badge for the exact reasons. Review before invoicing.',
      },
    },
    crossLevelNote:
      "Same-named fields match to the cent across L1 / L2 / L3 when the same date range and CPT filter are sent. L2's summaryRow is produced by the same aggregation code as its L1 row, just scoped to one account. If a drill-down request drops the filter the table had, numbers will legitimately differ — always keep the active filters when drilling in.",
    workedExample: {
      title: 'Worked example — Recognized vs Invoicable',
      body: 'Q3 2026, Mercy Health Partners: `qhsRevenueFromReportables = $21,420` means QHS minted 21 billable items between Jul 1 and Sep 30 at an average snapshot price of $1,020. Six of those billables belong to claims generated back in June — they count toward Q3 because that\'s when QHS recognized them. Meanwhile `qhsInvoiceBasis = $19,800` values only Q3\'s own claim work at today\'s prices — the two columns answer "what did we book?" vs "what did this quarter\'s work earn us?".',
    },
    l1: {
      pageSubtitle:
        'Portfolio-level financial performance across all customer accounts. Chase unmapped CPTs, missing reportables, and stalled invoices.',
      pickDateRangeTitle: 'Pick a date range',
      pickDateRangeHint:
        'Use the Quick range or Custom range chip above to set the window for the portfolio.',
      hintInScope: '{{count}} in scope',
      hintActive: '{{count}} active',
      hintPaidClaims: '{{count}} paid claims',
      tableTitle: 'Claims Manager',
      backAriaLabel: 'Back to {{title}}',
      nonDs: {
        accountFallback: 'Your account',
        opsClaims: 'Claims',
        opsPaid: 'Paid',
        opsPatients: 'Patients',
        opsReports: 'Reports',
        opsAvgPaid: 'Avg $/Paid',
        opsLastClaim: 'Last Claim',
        viewCptBreakdownBtn: 'View CPT breakdown',
        unmappedNoteLeadSingular: '{{count}} unmapped CPT:',
        unmappedNoteLeadPlural: '{{count}} unmapped CPTs:',
        unmappedNoteTailSingular:
          '— no ISP price, so dollar totals above are understated. Ask ops to add the missing price.',
        unmappedNoteTailPlural:
          '— no ISP price, so dollar totals above are understated. Ask ops to add the missing prices.',
        unmappedNoteNoCodes: 'no ISP price — dollar totals above are understated.',
      },
    },
    l2: {
      pageSubtitle:
        'Account-level financial breakdown. Click a priced CPT row to see which insurance payers reimbursed it, then a payer for its claim lines.',
      tableTitle: 'CPT Mix',
      unmappedNoteHeadSingular: '{{count}} unmapped CPT not shown below:',
      unmappedNoteHeadPlural: '{{count}} unmapped CPTs not shown below:',
      unmappedNoteTailSingular:
        "— no ISP price, so it can't be aggregated. Ask ops to add the missing price.",
      unmappedNoteTailPlural:
        "— no ISP price, so they can't be aggregated. Ask ops to add the missing prices.",
      unmappedNoteNoCodes: 'no ISP price, so aggregation is not possible.',
    },
    l3: {
      pageSubtitleWithAccount:
        'Every claim at {{account}} that carried this CPT during the selected period.',
      pageSubtitleNoAccount:
        'Every claim at the target account that carried this CPT during the selected period.',
      accountFallback: 'Account Detail',
      tableTitle: 'Supporting Claims',
      cptPrefix: 'CPT',
      unmappedNoIspBadge: 'Unmapped (no ISP price)',
      ispPriceBadge: 'ISP ${{price}}',
      claimsCountBadgeSingular: '{{count}} claim',
      claimsCountBadgePlural: '{{count}} claims',
      ispLockedHint: 'ISP price locked at ${{price}}.',
      ispNotPricedHint: 'Not priced in ISP configuration — dollar totals hidden.',
      // Reimbursement by insurance payer (2026-09-08)
      insurancesTableTitle: 'Insurance Payers',
      insurancesSubtitleWithAccount:
        'Who paid for this CPT at {{account}} during the selected period, one row per insurance payer. Click a payer for its claim lines.',
      insurancesSubtitleNoAccount:
        'Who paid for this CPT at the target account during the selected period, one row per insurance payer.',
      claimsForPayerSubtitle:
        'Every claim line at {{account}} for this CPT paid by {{payer}} during the selected period.',
      unknownPayer: 'Unknown',
      payersCountBadgeSingular: '{{count}} payer',
      payersCountBadgePlural: '{{count}} payers',
      backToPayersAria: 'Back to insurance payers',
    },
    kpis: {
      reimbursement: 'Reimbursement',
      invoicable: 'Invoicable',
      recognized: 'Recognized',
      invoicablePercent: 'Invoicable %',
      claims: 'Claims',
      paid: 'Paid',
      ispPrice: 'ISP Price',
      totalPaid: 'Total Paid',
    },
    columns: {
      account: 'Account',
      customId: 'Custom ID',
      claims: 'Claims',
      paid: 'Paid',
      patients: 'Patients',
      totalCpts: 'Total CPTs',
      cptsPaid: 'CPTs Paid',
      reimbursement: 'Reimbursement',
      invoicable: 'Invoicable',
      recognized: 'Recognized',
      patientResponsibility: 'Patient Responsibility',
      invPercent: 'Inv %',
      avgPaid: 'Avg $/Paid',
      reports: 'Reports',
      lastClaim: 'Last Claim',
      unmappedCpts: 'Unmapped CPTs',
      cptHcpcs: 'CPT / HCPCS',
      ispPrice: 'ISP Price',
      countClaims: 'Count (Claims)',
      countReportables: 'Count (Reportables)',
      providerOweUs: 'Provider Owe Us',
      providerGain: 'Provider Gain',
      firstName: 'First Name',
      lastName: 'Last Name',
      dos: 'DOS',
      cptStatus: 'CPT Status',
      price: 'Price',
      claimGenerated: 'Claim Generated',
      insurance: 'Insurance',
      unknownInsurance: 'Unknown',
      lines: 'Lines',
      paidLines: 'Paid Lines',
      avgPaidPerPaidLine: 'Avg Paid / Paid Line',
    },
    cptStatus: {
      notProcessed: 'Not processed',
      paid: 'Paid',
      // Claim-level fallback status (backend fix 5f3e27a57, 2026-08-21)
      partiallyPaid: 'Partially Paid',
      billed: 'Billed',
      inProcess: 'In Process',
      pending: 'Pending',
      patientResponsibility: 'Patient Responsibility',
      patientResponsibilityShort: 'Patient Resp.',
      denied: 'Denied',
      resubmitted: 'Resubmitted',
      notBillable: 'Not Billable',
      unmapped: 'Unmapped',
    },
    dictionary: {
      totalClaims: {
        label: 'Claims',
        definition: 'Number of claims created for this account during the period.',
        source: 'Claims table.',
        formula:
          'Count of claims (with the CPT filter applied, a claim counts only if it carries at least one line item with a selected code).',
        anchor: 'Claim generated.',
        gotchas: 'Deleted claims excluded.',
      },
      paidClaimCount: {
        label: 'Paid',
        definition: 'How many of those claims have received at least one insurance payment.',
        source: 'Claims + their CPT line items (payments).',
        formula:
          'Count of claims having ≥ 1 line item with paid amount > 0 (matching the CPT filter if one is set).',
        anchor: 'Claim generated — NOT payment date.',
        gotchas:
          'A claim generated in July but paid in September still counts toward July — and only appears here once the payment posts. This number grows over time for a fixed period.',
      },
      patientsWithActivity: {
        label: 'Patients',
        definition: "Number of unique patients behind the period's claims.",
        source: 'Claims table.',
        formula: 'Distinct patient count across the counted claims.',
        anchor: 'Claim generated.',
        gotchas:
          'A patient with 5 claims counts once. Respects the CPT filter via the claims it keeps.',
      },
      insurancePaidToProvider: {
        label: 'Reimbursement',
        definition: "Total dollars insurance has paid the practice for the period's claim work.",
        source: 'Paid amounts on claim line items.',
        formula: 'Sum of `paid` across ISP-covered line items on claims generated in the period.',
        anchor: 'Claim generated (NOT payment date); amounts as of now.',
        gotchas:
          'Payments on unmapped CPT codes are excluded from this total (same universe as the QHS numbers). Grows over time as payments post.',
      },
      qhsInvoiceBasis: {
        label: 'Invoicable',
        definition:
          'What QHS could invoice this account today, at current contract prices, for the claim work done in the period.',
        source: "Account's ISP price list (live current prices) × claim line items.",
        formula:
          "Sum of the current ISP price for every ISP-covered line item on the period's claims. One price per line-item occurrence.",
        anchor: 'Claim generated.',
        gotchas:
          "Uses today's price — if the account's price for a code changed mid-period, the whole period is valued at the new price. Regular Price is always used (never the first-visit Initial Price). Independent of whether payments or invoices exist yet.",
      },
      qhsRevenueFromReportables: {
        label: 'Recognized',
        definition:
          'QHS revenue actually locked in during the period — billable items QHS minted for invoicing.',
        source:
          'Reportables ledger (one entry per claim × CPT, created when QHS recognizes a billable item), each carrying a price snapshot taken at creation time.',
        formula: 'Sum of the snapshot price of reportables created in the period.',
        anchor:
          'Reportable minted — NOT claim generated. A reportable minted in July for a June claim counts toward July.',
        gotchas:
          'Snapshot price is immune to later price edits (unlike Invoicable Potential). This is why the two revenue columns can differ even for the same work.',
      },
      invoicablePercent: {
        label: 'Inv %',
        definition:
          "QHS's share: what portion of the customer's insurance reimbursement QHS could invoice.",
        source: 'Derived.',
        formula: '(qhsInvoiceBasis ÷ insurancePaidToProvider) × 100, rounded to 2 decimals.',
        anchor:
          'Same as its inputs — numerator on work done, denominator on payments received so far.',
        gotchas:
          'Early in a period the % looks inflated because payments lag. Stabilizes as payments post. Renders as "—" (not 0 %) when reimbursement is zero.',
      },
      avgReimbursementPerPaidClaim: {
        label: 'Avg $/Paid',
        definition: 'Average insurance payment per paid claim.',
        source: 'Derived.',
        formula: 'insurancePaidToProvider ÷ paidClaimCount, rounded to 2 decimals.',
        anchor: 'Same as its inputs.',
        gotchas: 'Renders as "—" (not $0) when no claims have been paid yet.',
      },
      claimReportsIssued: {
        label: 'Reports',
        definition:
          'Number of QHS claim reports (invoicing bundles) issued to this account during the period.',
        source: 'Claim reports.',
        formula: 'Count of claim reports.',
        anchor: 'Report issued — third distinct anchor in the same row.',
        gotchas:
          'With a CPT filter, only reports containing at least one billable with a selected code count.',
      },
      lastClaimGenerated: {
        label: 'Last Claim',
        definition: 'Date of the most recent claim in the period — a "still active?" signal.',
        source: 'Claims table.',
        formula: 'Max claim-generated timestamp among the counted claims.',
        anchor: 'Claim generated.',
      },
      unmappedCptCount: {
        label: 'Unmapped CPTs',
        definition:
          "Number of distinct CPT codes that appeared on this account's claims but have no price in its ISP configuration.",
        source: 'Claim line items × ISP config.',
        formula: "Distinct count of codes on the period's line items with no ISP entry.",
        anchor: 'Claim generated.',
        gotchas:
          'Checked against the full ISP config — a code you filtered out is still "mapped". When > 0, dollar totals are understated: the warning badge on the row is a signal for ops to add the missing prices. The actual codes ship alongside as `unmappedCptCodes` — see that entry.',
      },
      unmappedCptCodes: {
        label: 'Unmapped CPT codes',
        definition:
          'The specific codes missing an ISP price — sorted alphabetically. Same universe and filters as `unmappedCptCount`; `count === codes.length` always holds.',
        source: 'Claim line items × ISP config.',
        formula: "Distinct set of codes on the period's line items with no ISP entry.",
        anchor: 'Claim generated.',
        gotchas:
          "Empty array (not null) when the count is zero. Use this list to tell ops exactly which codes to add to the account's ISP configuration.",
      },
      attentionReasons: {
        label: 'Attention',
        definition:
          "Data-integrity issues found in this account's period data that should be reviewed before invoicing. Empty = clean.",
        source: 'Five automated probes across claims / reportables / claim reports.',
        formula: [
          '"N paid CPT(s) missing reportable" — insurance paid a line item but no QHS billable was ever minted → QHS is leaving money on the table.',
          '"duplicate rows" — the same claim × CPT appears more than once (activities or reportables) → totals may be inflated.',
          '"orphan reportables" — a reportable exists with no matching claim line item behind it.',
          '"claim-report references missing reportable" — an issued report points at a deleted/missing billable.',
        ],
        anchor:
          "Each probe scopes to its own layer's anchor (claims → claim generated; reportables → minted; reports → issued).",
        gotchas:
          "Deliberately ignores the CPT filter — an integrity problem doesn't disappear when the viewer narrows the view. Slow payments / low yield are intentionally NOT flagged (normal payment cadence).",
      },
      summaryTotals: {
        label: 'Row totals',
        definition:
          'Every total on the totals row is computed by summing over the returned rows — so the totals always reconcile with the visible table by construction.',
        source: 'Same rows the table renders.',
      },
      activeAccounts: {
        label: 'Active accounts',
        definition:
          'Number of rows in the table — in-scope accounts with ≥ 1 claim generated in the period (respecting the CPT filter). Zero-claim accounts are hidden.',
      },
      accountsInScope: {
        label: 'Accounts in scope',
        definition:
          'All in-scope accounts (claims-management enabled + inside your permitted set), regardless of activity. `accountsInScope − activeAccounts` = accounts that were quiet this period.',
      },
      summaryInvoicablePercent: {
        label: 'Totals-row Invoicable %',
        definition:
          'Total invoicable ÷ total reimbursement (ratio of the two sums, NOT an average of the per-row percents). Renders as "—" when total reimbursement is zero.',
      },
      ispPrice: {
        label: 'ISP Price',
        definition: 'The current contract price QHS charges this account for this CPT code.',
        source: "Account's ISP configuration (live).",
        formula: 'Regular price — never the first-visit InitialPrice.',
        anchor: 'Now.',
        gotchas:
          'CPTs in the ISP config with zero activity still appear here (all-zero row) — intentional, shows unused contract items. Codes on claims but NOT in the config do not appear here — they roll into unmappedCptCount instead.',
      },
      countFromClaims: {
        label: 'Count (Claims)',
        definition: 'Line items with this code on claims generated in the period (any status).',
        source: 'Claim line items.',
        anchor: 'Claim generated.',
        gotchas: 'Rule of thumb: claims side = work volume; reportables side = billing progress.',
      },
      countFromReportables: {
        label: 'Count (Reportables)',
        definition: 'QHS billables with this code minted in the period.',
        source: 'Reportables ledger.',
        anchor: 'Reportable minted.',
        gotchas:
          'Differs from Count (Claims) because (1) different anchors — a June claim\'s billable can mint in July; (2) not every line item produces a billable (typically only paid ones do); (3) a soft-deleted billable drops from the reportables side only. A persistent large gap = billables not being minted → shows up as "paid CPTs missing reportable" in the attention flag.',
      },
      totalProviderOweUs: {
        label: 'Provider Owe Us',
        definition: "What QHS would invoice for this code's period volume at today's price.",
        source: 'Derived.',
        // Backend formula change (feature/claims-manager-table-exports,
        // confirmed by Ahmed): billing basis moved from claims volume
        // to minted reportables.
        formula: 'countFromReportables × ispPrice.',
        anchor: 'Reportable minted.',
      },
      providerGain: {
        label: 'Provider Gain',
        definition: 'What the practice earned from insurance on this code so far.',
        source: 'Paid amounts on claim line items.',
        formula: "Sum of insurance `paid` for this code's line items on the period's claims.",
        anchor: 'Claim generated; amounts as of now.',
        gotchas: 'Grows over time as payments post.',
      },
      insurance: {
        label: 'Insurance',
        definition:
          'The payer named on the claim line. Grouped by exact text after trimming and collapsing whitespace; case matters, so "BCBS" and "Blue Cross Blue Shield" are two payers.',
        gotchas:
          'Unknown = the claim carries no payer. Payer names come from the dropdown on the assessment form; if two spellings of one payer appear, that is a data question, not something the dashboard merges.',
      },
      lineCount: {
        label: 'Lines',
        definition: 'Claim lines for this CPT and payer in the period.',
        formula:
          "Only lines whose CPT is in the account's ISP configuration are counted — the same rule as the money columns on the portfolio.",
      },
      paidLineCount: {
        label: 'Paid Lines',
        definition: 'Lines with paid > 0.',
      },
      avgPaidPerPaidLine: {
        label: 'Avg Paid / Paid Line',
        definition: 'The rate this payer actually reimburses for this CPT.',
        formula: 'totalPaid / paidLineCount. Blank when paidLineCount is 0.',
        gotchas:
          "On the portfolio view the payer header row uses the backend's group totals, computed over the whole filtered set, so it does not change as pages load. ISP Price is deliberately not averaged in the header: it differs per account, and that difference is the point of the view.",
      },
      cptStatus: {
        label: 'CPT Status',
        definition: 'Where this line item currently sits in the billing flow.',
        formula: [
          'paid — insurance has paid this line item.',
          'billed — submitted to insurance, awaiting adjudication.',
          'inProcess — being worked internally, not yet submitted.',
          'patientResponsibility — balance shifted to the patient (copay / deductible / denial to patient).',
          'denied — insurance denied this line item.',
          'resubmitted — denied previously, corrected and re-sent.',
          'notBillable — marked as not billable, excluded from billing flow.',
        ],
      },
      paid: {
        label: 'Paid',
        definition: 'Dollars insurance actually paid the practice for this line item.',
        gotchas:
          'Can be 0 (not yet paid / denied / patient responsibility). Same money as Reimbursement on L1 / Provider Gain on L2 — just one row of it.',
      },
      price: {
        label: 'Price',
        definition:
          "QHS's contract price for this code from the account's ISP config — what QHS charges the account for it.",
        gotchas:
          "0 if the code isn't in the config (unmapped). Answers a different question than Paid — Paid = practice's revenue; Price = QHS's revenue per unit. Don't sum them together.",
      },
    },
  },
  oauthConsent: {
    title: 'Authorize Access',
    subtitle: 'would like to access your QHS account:',
    scopeSignedIn: 'See your name and which QHS account you are signed in to',
    scopeAnalytics: 'Read aggregate assessment-performance analytics you already have access to',
    unverifiedApp:
      'QHS has not verified this app. The name above is chosen by the app itself, so allow access only if you started this connection and trust it.',
    allow: 'Allow',
    deny: 'Deny',
    expiredMessage:
      'This request has expired or is no longer valid. Please start the connection again from your MCP client.',
    missingRequest:
      'No connection request was found. Please start the connection again from your MCP client.',
  },
  dateRangePicker: {
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    daysUpToToday: 'days up to today',
    daysStartingToday: 'days starting today',
  },
  patientOptions: {
    languageEnglish: 'English',
    languageSpanish: 'Spanish',
    languageUnknown: 'Unknown',
    raceNonHispanicWhite: 'Non-Hispanic White / Caucasian',
    raceHispanicLatino: 'Hispanic / Latino',
    raceAfricanAmericanBlack: 'African American Black',
    raceAsian: 'Asian',
    raceAmericanIndianAlaskaNative: 'American Indian or Alaska Native',
    raceNativeHawaiianPacificIslander: 'Native Hawaiian or Other Pacific Islander',
    raceMiddleEasternNorthAfrican: 'Middle Eastern or North African',
    raceMultiracialOther: 'Multiracial or none of the above',
  },
  patientHero: {
    dob: 'DOB',
    mrn: 'MRN',
    phone: 'Phone',
    language: 'Language',
    insurance: 'Insurance',
    yearsOld: 'y.o.',
    editPatient: 'Edit patient',
    callPatient: 'Call patient',
    emailPatient: 'Email patient',
    noPhoneOnFile: 'No phone on file',
    noEmailOnFile: 'No email on file',
    openInfoPane: 'Patient info pane',
    drugAllergies: 'Drug Allergies',
    anonymousPatient: 'Anonymous patient',
    openDashboard: 'Open patient dashboard',
  },
  usStates: {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'District of Columbia',
  },
  sidebar: {
    groupOrganization: 'Organization',
    groupMonitoring: 'Monitoring',
    groupPatientCare: 'Patient Care',
    groupOperations: 'Operations',
    noNewAlerts: 'No new alerts',
    seeAllAlerts: 'See all alerts',
    critical: 'Critical',
    alertSingular: 'alert',
    alertPlural: 'alerts',
    alertGroupImminentRisk: 'Imminent Risk',
    alertGroupHelpSeekingBehavior: 'Help Seeking Behavior',
    alertGroupRiskFactorsIdentified: 'Risk Factors Identified',
  },
  resourceCenter: {
    hub: {
      howCanWeHelp: 'How can we help?',
      searchComingSoon: 'Search is coming soon',
      popular: 'Popular:',
      startHere: 'Start here',
      featuredVideoTitle: 'Helping patients complete their assessment',
      featuredVideoDescription:
        'How to find the patients who still need to finish their assessment, and how to help them complete it.',
      browseByTopic: 'Browse by topic',
      aeEnabled: 'Enabled for your account',
      aeEnabledDescription:
        'Allergy testing and immunotherapy program materials for your practice: testing procedures, immunotherapy guides, patient education, and marketing resources.',
      aeChips: [
        'Getting started',
        'Testing procedure',
        'Immunotherapy guides',
        'Patient education',
        'Marketing kit',
      ],
      aeNotEnabled: 'Not enabled',
      aeNotEnabledDescription:
        'The AllergiEnd allergy testing and immunotherapy program is not enabled for this account. Contact QHS to learn how it fits your practice.',
      cantFind: "Can't find what you need?",
      responseTime: 'Our team typically responds within one business day.',
      contactSupport: 'Contact Support',
    },
    sections: {
      catalog: {
        title: 'Products & Services',
        description:
          'Explore QHS Assessments, Resources, Programs and solutions available to your practice.',
        links: ['Assessment catalog', 'Audio resources', 'Programs overview'],
      },
      training: {
        title: 'Training',
        description:
          'Learn how to successfully implement, operate, and optimize QHS programs within your practice.',
        links: ['Onboarding journey', 'Front-desk procedures', 'Billing-team training'],
      },
      guides: {
        title: 'Guides & Resources',
        description:
          'Practical tools and reference materials for using QHS in everyday practice operations.',
        links: ['Quick-start guides', 'Patient communication kit', 'Checklists & PDFs'],
      },
      billing: {
        title: 'Billing & Reimbursement',
        description:
          'Understand QHS-related billing opportunities, documentation requirements, and reimbursement workflows.',
        links: ['CPT guidance', 'Coding examples', 'Reimbursement FAQs'],
      },
      faq: {
        title: 'FAQs',
        description:
          'Quick answers to commonly asked questions about QHS programs, technology, billing, and workflows.',
        links: ['Provider questions', 'Staff questions', 'Troubleshooting'],
      },
      support: {
        title: 'Support',
        description:
          'Get help from QHS with your account, programs, patients, billing, or technology.',
        links: ['Submit a request', 'Request training', 'Report a technical issue'],
      },
      news: { title: "What's New" },
    },
    headers: {
      catalog: {
        title: 'Products & Services',
        subtitle:
          'Explore QHS Assessments, Resources, Programs and solutions available to your practice.',
      },
      news: {
        title: "What's New",
        subtitle:
          'Stay informed about new QHS capabilities, program enhancements, important changes, and upcoming opportunities.',
      },
      training: {
        title: 'Training',
        subtitle:
          'Learn how to successfully implement, operate, and optimize QHS programs within your practice.',
      },
      guides: {
        title: 'Guides & Resources',
        subtitle:
          'Access practical tools and reference materials for using QHS in everyday practice operations.',
      },
      billing: {
        title: 'Billing & Reimbursement',
        subtitle:
          'Understand QHS-related billing opportunities, documentation requirements, and reimbursement workflows.',
      },
      faq: {
        title: 'FAQs & Support',
        subtitle:
          'Find quick answers to common questions, or get help from the QHS team when you need assistance.',
      },
    },
    rail: {
      back: 'Resource Center',
      on: 'On',
      enabled: 'Enabled',
    },
    catalog: {
      pitchTitle:
        'Assessments your patients finish on their phone, scored and in your dashboard before the visit.',
      pitchText:
        'Every assessment below is a validated instrument set, delivered by text and email in English or Spanish, with a patient report and a physician report at the end. Try any of them exactly as a patient would.',
      assessmentsCount: 'assessments',
      resourcesCount: 'patient resources',
      everyAssessment: 'every assessment',
      addToPractice: 'Add an assessment to your practice',
      accessNote:
        'Request Access or ask your QHSLab Representative for Access to these Assessments or Resources.',
      requestAccess: 'Request access',
      haveQuestion: 'I have a question first',
      bothOpenEmail: 'Both open an email to your QHSLab representative.',
      searchPlaceholder: 'Search by name or instrument, e.g. PHQ-9, sleep, allergy',
      searchAria: 'Search assessments and resources',
      all: 'All',
      patientResources: 'Patient resources',
      patientResourcesDescription:
        'Audio, articles and short videos your patients get on their phone, assigned from a program or directly from the dashboard.',
      nothingMatches: 'Nothing matches “{{query}}”.',
      assessmentBadge: 'Assessment',
      tryAssessment: 'Try assessment',
      runsOnPhone: 'Runs on the patient’s phone, English and Spanish',
      instruments: 'Instruments: {{list}}',
      kinds: {
        audio: 'Audio',
        podcast: 'Podcast',
        video: 'Video',
        article: 'Article',
        program: 'Program',
      },
      audiences: {
        adults: 'Adults',
        childrenByParent: 'Children and teens, answered by a parent',
      },
      aeBadge: 'AllergiEnd',
      aeItems: {
        allergyTesting: {
          name: 'Allergy Testing',
          description:
            'In-office skin prick testing program: procedure guides, supplies, and documentation workflows.',
        },
        immunotherapy: {
          name: 'Allergen Immunotherapy',
          description:
            'SCIT immunotherapy program: mixing supervision, dosing schedules, and injection protocols.',
        },
      },
    },
    topics: {
      start: {
        title: 'Start here',
        why: 'One assessment that covers behavioral health, sleep, pain and allergy in a single visit. Most practices begin with one of these.',
      },
      behavioral: {
        title: 'Behavioral health',
        why: 'Validated depression, anxiety and cognitive screens with scoring the provider can act on at the visit.',
      },
      allergy: {
        title: 'Allergy & respiratory',
        why: 'Baseline, control and treatment follow-up for allergy, asthma and lung patients.',
      },
      sleep: {
        title: 'Sleep & pain',
        why: 'Two short screens that find the patients who need a sleep study or a pain plan.',
      },
      lifestyle: {
        title: 'Lifestyle & prevention',
        why: 'Habits, nutrition, weight and risk factors: the material for preventive counseling and annual visits.',
      },
    },
    assessments: {
      allergyBaseline: {
        name: 'Allergy Baseline Assessment',
        description:
          "Captures the patient's allergy history, symptoms, triggers and their severity. Includes scoring for the SNOT-22, Asthma Control and Respiratory Allergy Prediction.",
      },
      asthmaControl: {
        name: 'Asthma Control Test',
        description:
          "A 5-question assessment of how well the patient's asthma has been controlled over the past month. Gives the provider a quick, scored view of asthma control.",
      },
      cvdRiskAssessment: {
        name: 'CVD Risk Assessment',
        description:
          'A self-administered assessment for adults that identifies risk factors for heart disease, stroke and peripheral artery disease, including smoking, diabetes, blood pressure, cholesterol, physical activity and family history. It also screens for warning symptoms of peripheral artery disease and supports early detection and personalized care planning in line with ACC/AHA, CMS and USPSTF guidelines.',
      },
      glp1Assessment: {
        name: 'GLP-1 Assessment',
        description:
          'A weight management assessment covering weight history, awareness of GLP-1 and GIP medications, and body composition with a BMI calculation. It includes an educational video and a short quiz and is part of a 12-lesson weight loss program.',
      },
      health: {
        name: 'Health Assessment',
        description:
          'Screens behavioral health, sleep quality and sleep apnea risk, persistent pain, stress and allergy symptoms in one assessment. Uses validated instruments such as the PHQ-9, GAD-7, SNOT-22, STOP-Bang and Epworth Sleepiness Scale, and identifies whether the patient is looking for help.',
      },
      healthHabits: {
        name: 'Health Habits Assessment',
        description:
          "Reviews the patient's everyday health habits: stress management, fruit and vegetable intake, exercise, tobacco use and alcohol use. Gives the care team a quick picture of lifestyle factors to discuss at the visit.",
      },
      immunotherapyTreatment: {
        name: 'Immunotherapy Treatment Assessment',
        description:
          'Captures how well patients are keeping up with their allergen immunotherapy and how satisfied they are with the treatment. Also records current over-the-counter allergy medication use.',
      },
      diet: {
        name: 'Medical Nutrition Assessment',
        description:
          "Reviews the patient's diet, including variety, fiber, omega-3, fat and fluid intake, with dietary risk scoring. Identifies opportunities for medical nutrition therapy and weight management.",
      },
      medicalSymptoms: {
        name: 'Medical Symptoms Questionnaire',
        description:
          "A simple symptom questionnaire that gives clues to the underlying causes of a patient's current and potential health problems. Repeated over time, it tracks symptom changes and response to treatment.",
      },
      obstructiveSleepApnea: {
        name: 'Obstructive Sleep Apnea (OSA) Assessment',
        description:
          "Measures the patient's risk of obstructive sleep apnea using the Epworth Sleepiness Scale, modified Berlin and STOP-Bang questionnaires. Patients at high risk are flagged for further screening and, where appropriate, a sleep study.",
      },
      pediatricAllergyBaseline: {
        name: 'Pediatric Allergy Baseline Assessment',
        description:
          "Parents report their child's allergy history, symptoms, triggers and severity. Includes scoring for the SNOT-22, Asthma Control and Respiratory Allergy Prediction.",
      },
      pediatricHealth: {
        name: 'Pediatric Health Assessment',
        description:
          'A brief, risk-based screening for children covering behavioral health, allergy symptoms, sleep and quality of life, using validated measures such as the PSC-17, SDQ Prosocial Scale, CARAT and suicide risk screening. Gives pediatricians clear decision guidance and families simple, actionable feedback.',
      },
      pediatricSymptom: {
        name: 'Pediatric Symptom Checklist-17',
        description:
          'A brief, easy-to-interpret screening that helps pediatricians and primary care providers see how likely a child is to have a mental health concern. It screens well even compared with much longer instruments such as the Child Behavior Checklist.',
      },
      painInventory: {
        name: 'Persistent Pain Assessment',
        description:
          "Uses the Brief Pain Inventory to measure how intense the patient's pain is. Also measures how much the pain interferes with daily life.",
      },
      psychoEmotional: {
        name: 'PHQ-GAD16 Health Assessment',
        description:
          "Measures the patient's risk of depression and anxiety using the validated PHQ-9 and GAD-7 instruments. Also identifies patients living with persistent or chronic pain.",
      },
      preventiveScreening: {
        name: 'Preventive Screening Assessment',
        description:
          'Captures how patients rate their overall and mental health, their family medical history, existing conditions and recommended age-based preventive screenings. Also assesses fall risk and use of healthcare services over the past year.',
      },
      q360: {
        name: 'Q-360™ Assessment',
        description:
          'A digital screening for children and adolescents that identifies early signs of emotional, social and environmental risk, including safety, social media impact, physical activity and social determinants of health. Built for schools, community settings and healthcare, its scoring highlights both risk and protective factors to support timely intervention.',
      },
      qCogComprehensive: {
        name: 'Q-Cog™ Comprehensive Assessment',
        description:
          'A digital assessment for adults 65 and older that detects mild cognitive impairment, dementia-related risks and co-occurring behavioral health conditions. It covers memory, orientation, executive function, daily functioning, falls risk, social needs and DSM-5 cross-cutting mental health symptoms in one workflow.',
      },
      pulmonaryHealthAssessment: {
        name: 'Q-Lung Assessment',
        description:
          'A patient-reported pulmonary assessment that adapts its questions to each patient and scores symptom control with validated tools such as the COPD Assessment Test, Asthma Control Test and Allergic Rhinitis Control Test. It also screens behavioral health, sleep, stress, quality of life and tobacco use, which can all affect respiratory care.',
      },
      qScale: {
        name: 'Q-Scale Assessment',
        description:
          '"Q" stands for Quality of Life: the Q-Scale looks for early warning signs in sleep, stress, anxiety, worry, pain and life satisfaction. Patients flagged as higher risk continue to validated follow-up instruments such as the PHQ-9, GAD-7, PTSD screen and Kessler-6, plus sleep apnea and chronic pain screening.',
      },
    },
    resources: {
      progressiveMuscleRelaxation: {
        name: 'Progressive Muscle Relaxation',
        description:
          'A short introduction explains the benefits of progressive muscle relaxation, a widely used stress reliever. It is followed by a 15-minute guided session that relaxes the body step by step from head to toe to ease muscle tension, stress and anxiety and help with falling asleep.',
      },
      beatingTheWorryBug: {
        name: 'Beating the Worry Bug',
        description:
          'A 25-minute audio program with practical techniques to manage and reduce anxiety and worry. It introduces proven methods from cognitive behavioral therapy (CBT).',
      },
      mindfulness: {
        name: 'Mindfulness',
        description:
          'A mindfulness practice for reducing anxiety and depression. Includes a 15-minute guided meditation focused on breathing and a calming seashore visualization.',
      },
      obesity: {
        name: 'Obesity',
        description:
          'A short presentation that explains what obesity is and how it is measured. It also covers the diseases linked to obesity and the treatment options that may be recommended.',
      },
      eatWell: {
        name: 'EatWell',
        description:
          'A 28-minute guide to healthier eating based on the latest dietary evidence. It focuses on eating more fiber from fruits and vegetables to support digestive health, lower bowel cancer risk and improve overall nutrition.',
      },
      sleepWell: {
        name: 'SleepWell',
        description:
          'A 21-minute guide to better sleep and common sleep disorders. It explains brain waves and sleep cycles and how to build sleep habits and a bedroom environment that support quality sleep.',
      },
      painless: {
        name: 'Painless',
        description:
          'A five-part program for people living with chronic pain or a long-term injury, designed to help them regain a sense of control. It covers the types of pain and how pain affects emotions, the "boom and bust" cycle and pacing, overcoming fear of pain, and pain medication.',
      },
      smartMoves: {
        name: 'SmartMoves',
        description:
          'An approximately 30-minute guide to the benefits of exercise and physical activity for managing chronic disease, building muscle strength and reducing pain. It explains why daily movement matters and offers strategies to be more active.',
      },
      nonSmoker: {
        name: 'Benefits of Being a Non-Smoker',
        description:
          'Support for patients who are thinking about quitting smoking or tobacco. No matter how long or how often someone has smoked or chewed tobacco, quitting is one of the most important things they can do for their health.',
      },
      masteringBackPain: {
        name: 'Mastering Back Pain',
        description:
          'A two-part program with key facts about the back and the causes of back pain, including when to rest and when to move more. Part two covers handling an acute attack, controlling back pain and understanding that hurt often does not mean harm.',
      },
      diabetes: {
        name: 'Diabetes',
        description:
          'A short presentation on what diabetes is, how it is diagnosed and how it is treated. It also shows how patients can improve their health and reduce or avoid the risk of type 2 diabetes.',
      },
      hypertension: {
        name: 'Hypertension',
        description:
          'Hypertension is one of the most common diagnoses today. This podcast explains why healthy blood pressure matters and gives strategies to maintain it.',
      },
      allergies: {
        name: 'Allergies',
        description:
          'A short presentation on what allergies are and how they are diagnosed. It covers the tests that confirm what causes the allergies and the treatment options that may be recommended.',
      },
    },
    durations: {
      minutes: '{{count}} min',
      parts: '{{count}} parts',
    },
    preview: {
      english: 'English',
      spanish: 'Español',
      phone: 'Phone',
      browser: 'Browser',
      aboutMinutes: 'About {{minutes}} minutes.',
      asPatient: 'You are taking it as a patient would.',
      notSaved: 'Preview, answers are not saved',
      restart: 'Restart',
      close: 'Close',
      previewTitle: '{{name}} preview',
      loading: 'Loading the assessment…',
      sample: 'Sample assessment (Q-360) until the preview API is on dev.',
      patientSees: 'The patient sees exactly this on their phone.',
      hostNotConfigured: 'The live assessment appears here once the preview host is configured.',
      whatHappens: 'What happens',
      invitation: 'Invitation',
      invitationDescription: 'Sent by SMS and email from your account. Opened from the text.',
      assessment: 'Assessment',
      progress: '{{answered}} of about {{total}} answers given.',
      progressPlaceholder: 'Progress shows here as the questions are answered.',
      patientReport: 'Patient report',
      patientReportDescription: 'Plain-language feedback the patient keeps, from these answers.',
      clinicSees: 'What your clinic sees',
      clinicSeesDescription:
        'Scores, flags and the physician report in the dashboard. Pending review until you accept it.',
      patientsCompleted: '{{count}} patients',
      completedThisAssessment: 'completed this assessment',
      inPeriod: 'in {{period}}',
      acrossNetwork: 'across the QHSLab network.',
      billable: 'Billable:',
      requestAccess: 'Request access for my practice',
      haveQuestion: 'I have a question first',
      bothOpenEmail:
        'Both open an email to your QHSLab representative. You can finish the preview first, nothing is saved.',
      mockSection: 'SLEEP · 7 OF 22',
      mockQuestion:
        'Over the last 2 weeks, how often have you had trouble falling or staying asleep?',
      mockOptions: ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'],
      mockBack: 'Back',
      mockNext: 'Next',
    },
    training: {
      roles: {
        allRoles: 'All roles',
        frontDesk: 'Front desk',
        providers: 'Providers',
        billingTeam: 'Billing team',
      },
      comingSoon: 'Coming soon',
      new: 'New',
      upcoming: {
        orientation: {
          title: 'Dashboard orientation',
          description:
            'A tour of the dashboard: navigation, patients, assessments, and where to find help.',
        },
        frontDeskChecklist: {
          title: 'Front-desk daily checklist',
          description:
            'The morning routine: appointments, pending invitations, and no-show follow-ups.',
        },
        readingReport: {
          title: 'Reading the assessment report',
          description:
            'Interpreting scores, clinical flags, and the physician interpretation overview.',
        },
        reviewingResponses: {
          title: 'Reviewing patient responses',
          description:
            'Working with instrument responses, severity colors, and comparison reports.',
        },
        claimsWorkflow: {
          title: 'Claims workflow end-to-end',
          description:
            'From completed assessment to submitted claim: statuses, reports, and denials.',
        },
      },
    },
    lesson: {
      whatYouLearn: "What you'll learn",
      chapter: 'Chapter {{number}}',
      stepByStepGuide: 'Step-by-step guide',
      stepsCount: '{{count}} steps',
      videoComingSoon: 'Video is being produced, coming soon',
      statusLifecycle: 'The status lifecycle at a glance',
      stepByStep: 'Step by step',
      tip: 'Tip:',
      allTraining: 'All training',
      nextLesson: 'Next lesson: {{title}}',
      previousLesson: 'Previous lesson: {{title}}',
      subtitles: 'English',
      updated: 'Updated Aug 2026',
    },
    lessons: {
      createPatient: {
        title: 'Creating a Patient',
        subtitle: 'Step-by-step video lesson: add a new patient and set up their first assessment.',
        description:
          'Add a new patient in under two minutes: the form, required fields, and what to do next.',
        learn: [
          'Where to find the Add Patient action',
          'Which fields are required, and which are optional but needed for assessment delivery',
          'How drug allergies and communication consents are recorded',
          'What the "What’s next" step offers right after creation',
        ],
        steps: [
          {
            title: 'Open Patients',
            text: 'In the left navigation, open Patients (the Patient Care group).',
          },
          {
            title: 'Click Add Patient',
            text: 'Use the primary Add Patient button in the table toolbar. A panel opens on the right with two steps: Details and What’s next.',
          },
          {
            title: 'Personal Information',
            text: 'Enter the MRN #, First Name, and Last Name. Phone and Email are optional, but the patient needs at least one of them to receive assessment invitations. Preferred Phone is managed by the patient and is read-only here.',
          },
          {
            title: 'Demographics & Medical Information',
            text: 'Set the Date of Birth (MM/DD/YYYY); patients confirm it when opening their assessment link. Select Gender at Birth. For Drug Allergies choose No, Yes, or Unknown; choosing Yes reveals a required Drug List field.',
          },
          {
            title: 'Language Preference & Race (optional)',
            text: 'Set the Patient Language (assessments and messages are delivered in it) and Race if known.',
          },
          {
            title: 'Address Information',
            text: 'Street Address, City, State, and ZIP are required; Suite is optional.',
          },
          {
            title: 'Communication Preferences',
            text: 'Tick SMS Opt-In and Email Subscription if the patient agreed to receive text messages and emails.',
          },
          {
            title: 'Create, and pick what’s next',
            text: 'Click Create. After the success message the panel shows the What’s next step: send the first assessment, create an order or a resource, edit the patient, or open the patient dashboard. Click Done to finish.',
          },
        ],
        tip: 'Missed something? The form highlights every required field inline when you click Create. Fix the highlighted fields and create again.',
      },
      assessmentLifecycle: {
        title: 'Sending an Assessment & the Status Lifecycle',
        subtitle:
          'Three-part video lesson: send an assessment and follow it through every status to Completed.',
        description:
          'Send an assessment two ways, then follow it through every status, from Invited to Completed.',
        duration: '3 chapters · ~2.5 min',
        learn: [
          'Two ways to create an assessment: from the Patients list and from the Patient Dashboard',
          'The two delivery options: Send invitation vs Take in-clinic',
          'What every status means: Invited, Opened, In Progress, Pending Review, Completed',
          'How to find assessments waiting for review and accept their results',
        ],
        chapters: [
          {
            title: 'Creating an assessment',
            description:
              'Find the patient, open Create Assessment, choose the assessment and the delivery option, send the invitation.',
            steps: [
              {
                title: 'Open the Patients list',
                text: 'In the left navigation open Patients (the Patient Care group) and find your patient; filter by first or last name right in the table.',
              },
              {
                title: 'Choose Create, then Assessment',
                text: 'Open the row menu on the patient and pick Assessment under Create. The same action is available from the Patient Dashboard.',
              },
              {
                title: 'Pick the assessment',
                text: 'Step 1 of the panel, Choose: scroll or search the catalog and select the assessment.',
              },
              {
                title: 'Configure the delivery',
                text: 'Send invitation emails or texts the patient a secure link; Take in-clinic generates the same link to open on a device in your office.',
              },
              {
                title: 'Check the contacts and send',
                text: 'Review the patient email or phone, set the appointment date if needed, and send. The new row appears with the status Invited.',
              },
            ],
          },
          {
            title: 'Watching the status change',
            description:
              'What the statuses tell you while the patient works through the assessment: Opened, In Progress, Pending Review.',
            steps: [
              {
                title: 'Invited',
                text: 'The invitation with a secure link was sent; the assessment waits for the patient.',
              },
              {
                title: 'Opened',
                text: 'The patient opened their assessment link but has not started yet. Refresh the list to see status updates.',
              },
              {
                title: 'In Progress',
                text: 'The patient verified their date of birth and is answering; they can pause and come back with the same link.',
              },
              {
                title: 'Pending Review',
                text: 'The patient finished; the results now wait for the provider review.',
              },
            ],
          },
          {
            title: 'Reviewing and accepting results',
            description:
              'Find assessments in Pending Review, open the report, accept the results; the assessment becomes Completed.',
            steps: [
              {
                title: 'Filter by Pending Review',
                text: 'On the Assessments page open the Status filter and pick Pending Review to see everything waiting for review.',
              },
              {
                title: 'Open the report',
                text: 'Click the assessment row; the report opens with scores, clinical flags, and the interpretation. The same report is reachable from the patient dashboard.',
              },
              {
                title: 'Accept the results',
                text: 'Click Accept Results at the top of the report. The status switches to Completed and the review is recorded with your name and time.',
              },
              {
                title: 'Download if needed',
                text: 'Back in the list the row shows Completed; its report is available from the row menu under Download.',
              },
            ],
          },
        ],
        statusFlow: [
          {
            label: 'Invited',
            who: 'Patient',
            description: 'The invitation with a secure link was sent to the patient.',
          },
          {
            label: 'Opened',
            who: 'Patient',
            description: 'The patient opened their assessment link but has not started yet.',
          },
          {
            label: 'In Progress',
            who: 'Patient',
            description:
              'The patient verified their date of birth and is working through the assessment; they can pause and come back with the same link.',
          },
          {
            label: 'Pending Review',
            who: 'Provider',
            description: "The patient finished; results await the provider's review.",
          },
          {
            label: 'Completed',
            who: 'Done',
            description: 'The provider accepted the results; the report is final and downloadable.',
          },
        ],
        tip: 'Both delivery options follow the same lifecycle: with Take in-clinic the patient simply opens the same secure link on a device in your office. Instant assessments are a separate feature and are not covered in this lesson.',
      },
    },
  },
};
